<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
            >{{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>

    <!-- STATS -->
    <el-row
      :gutter="20"
      v-if="droitAcces.intervention || droitAcces.list_dmdeur_intervention"
    >
      <v-container fluid grid-list-md>
        <v-layout row justify>
          <v-flex md4>
            <div
              id="chartsDisponibilite"
              style="width: 450px; height: 300px"
            ></div>
          </v-flex>
          <v-flex md4>
            <div id="chartsMarqueVeh" style="width: 900px; height: 300px"></div>
          </v-flex>
        </v-layout>
      </v-container>
    </el-row>

    <!-- STATS -->
    <el-row
      :gutter="20"
      v-if="droitAcces.intervention || droitAcces.list_dmdeur_intervention"
    >
      <v-container fluid grid-list-md>
        <v-layout row justify>
          <v-flex md12>
            <div
              id="chartAllBilanCarburant"
              style="width: 100%; height: 300px"
            ></div>
          </v-flex>
        </v-layout>
      </v-container>
    </el-row>

    <!-- STATS -->
    <el-row
      :gutter="20"
      v-if="droitAcces.intervention || droitAcces.list_dmdeur_intervention"
    >
      <v-container fluid grid-list-md>
        <v-layout row justify>
          <v-flex md12>
            <div
              id="chartAllBilanCarburantQut"
              style="width: 100%; height: 300px"
            ></div>
          </v-flex>
        </v-layout>
      </v-container>
    </el-row>

    <!-- MENU PRINCIPAL -->
    <v-card-text>
      <el-row :gutter="20">
        <!-- MENU DE GAUCHE -->
        <el-col :span="18">
          <div class="grid-content">
            <el-row>
              <el-col>
                <el-card class="box-card">
                  <!-- MENU DU PARC -->
                  <v-layout row justify>
                    <!-- VEHICULE -->
                    <v-flex
                      md6
                      style="padding: 10px"
                      v-if="
                        droitAcces.webservice_consommation_index ||
                          droitAcces.intervention ||
                          droitAcces.list_dmdeur_intervention
                      "
                    >
                      <el-button type="primary" size="medium" class="btnV"
                        >VEHICULES</el-button
                      >

                      <v-layout row justify>
                        <v-flex xs12 style="padding: 10px">
                          <el-card class="box-card">
                            <el-collapse accordion>
                              <el-collapse-item name="1">
                                <template slot="title">
                                  Statistique flotte vehicule
                                  <i class="header-icon el-icon-info"></i>
                                </template>
                                <div>
                                  <el-table
                                    :data="tableStatVeh"
                                    style="width: 100%"
                                    height="330"
                                  >
                                    <el-table-column
                                      prop="etatVeh"
                                      label="Etat"
                                      width="150"
                                    >
                                      <template slot-scope="scope">
                                        <el-tag
                                          :type="scope.row.color"
                                          disable-transitions
                                          >{{ scope.row.etatVeh }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="nbVehicule"
                                      label="Nb vehicule"
                                      width="100"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                      fixed="right"
                                      prop="action"
                                      label="Action"
                                      width="80"
                                    >
                                      <template slot-scope="scope">
                                        <el-button
                                          type="text"
                                          size="small"
                                          @click="
                                            $router.push({
                                              name: 'Flotte',
                                              params: {
                                                etat_veh: scope.row.idEtat
                                              }
                                            })
                                          "
                                          >Details</el-button
                                        >
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </el-card>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="nbVeh"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="lienFlotte()"
                              size="medium"
                              style="width: 100%"
                              >Flotte</el-button
                            >
                          </el-badge>
                        </v-flex>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbMarqu"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuMarque()"
                              size="medium"
                              style="width: 100%"
                              >Marques</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbBesoins"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="modalBesoin()"
                              size="medium"
                              style="width: 100%"
                              >Besoins Travaux</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- UTILISATEUR -->
                    <v-flex
                      md6
                      style="padding: 10px"
                      v-if="
                        droitAcces.webservice_consommation_index ||
                          droitAcces.intervention ||
                          droitAcces.list_dmdeur_intervention
                      "
                    >
                      <el-button type="primary" size="medium" class="btnV"
                        >UTILISATEUR</el-button
                      >

                      <v-layout row justify>
                        <v-flex xs12 style="padding: 10px">
                          <el-card class="box-card">
                            <el-collapse accordion>
                              <el-collapse-item name="1">
                                <template slot="title">
                                  Statistique des conducteurs
                                  <i class="header-icon el-icon-info"></i>
                                </template>
                                <div>
                                  <el-table
                                    :data="tableStatCond"
                                    style="width: 100%"
                                    height="330"
                                  >
                                    <el-table-column
                                      prop="etatCond"
                                      label="Etat"
                                      width="100"
                                    >
                                      <template slot-scope="scope">
                                        <el-tag
                                          :type="scope.row.color"
                                          disable-transitions
                                          >{{ scope.row.etatCond }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="nbCond"
                                      label="Nb Conducteur"
                                      width="150"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                      fixed="right"
                                      prop="action"
                                      label="Action"
                                      width="80"
                                    >
                                      <template slot-scope="scope">
                                        <el-button
                                          type="text"
                                          size="small"
                                          @click="
                                            loadListConducteur(scope.row.idEtat)
                                          "
                                          >Details</el-button
                                        >
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </el-card>
                        </v-flex>
                      </v-layout>

                      <v-layout row justify>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="nbCond"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuConducteur()"
                              size="medium"
                              style="width: 100%"
                              >Conducteur</el-button
                            >
                          </el-badge>
                        </v-flex>
                        <!--<v-flex md6 style="padding: 10px">-->
                        <!--<el-badge :value="0" class="item" style="width: 100%">-->
                        <!--<el-button @click="modalMission()" size="medium" style="width: 100%">Mission</el-button>-->
                        <!--</el-badge>-->
                        <!--</v-flex>-->
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout row justify>
                    <!-- LOCATION -->
                    <v-flex
                      md6
                      style="padding: 10px"
                      v-if="
                        droitAcces.webservice_consommation_index ||
                          droitAcces.intervention ||
                          droitAcces.list_dmdeur_intervention
                      "
                    >
                      <el-button type="success" size="medium" class="btnV"
                        >LOCATION</el-button
                      >

                      <v-layout row justify>
                        <v-flex xs12 style="padding: 10px">
                          <el-card class="box-card">
                            <el-collapse accordion>
                              <el-collapse-item name="1">
                                <template slot="title">
                                  Statistique des contrats
                                  <i class="header-icon el-icon-info"></i>
                                </template>
                                <div>
                                  <el-table
                                    :data="tableStatContrat"
                                    style="width: 100%"
                                    height="330"
                                  >
                                    <el-table-column
                                      prop="etatInterv"
                                      label="Etat"
                                      width="100"
                                    >
                                      <template slot-scope="scope">
                                        <el-tag
                                          :type="scope.row.color"
                                          disable-transitions
                                          >{{ scope.row.etatCont }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="nbContr"
                                      label="Nb Contrat"
                                      width="150"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                      fixed="right"
                                      prop="action"
                                      label="Action"
                                      width="80"
                                    >
                                      <template slot-scope="scope">
                                        <el-button
                                          type="text"
                                          size="small"
                                          @click="
                                            loadListContrat(scope.row.idEtat)
                                          "
                                          >Details</el-button
                                        >
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </el-card>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex md4 style="padding: 10px">
                          <el-badge
                            :value="nbContrat"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuContrat()"
                              size="medium"
                              style="width: 100%"
                              >Contrats</el-button
                            >
                          </el-badge>
                        </v-flex>
                        <v-flex md4 style="padding: 10px">
                          <el-badge
                            :value="this.nbClient"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuClient()"
                              size="medium"
                              style="width: 100%"
                              >Clients</el-button
                            >
                          </el-badge>
                        </v-flex>
                        <v-flex md4 style="padding: 10px">
                          <el-badge
                            :value="this.nbTarif"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="modalTarifs()"
                              size="medium"
                              style="width: 100%"
                              >Tarifs</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex md4 style="padding: 10px">
                          <el-badge :value="0" class="item" style="width: 100%">
                            <el-button
                              @click="modalCalend()"
                              size="medium"
                              style="width: 100%"
                              >Calendrier</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- CONSOMMATION -->
                    <v-flex md6 style="padding: 10px">
                      <el-button type="warning" size="medium" class="btnV"
                        >CONSOMMATION</el-button
                      >

                      <v-layout row justify>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbCarburan"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuConsommation()"
                              size="medium"
                              style="width: 100%"
                              >Carburants</el-button
                            >
                          </el-badge>
                        </v-flex>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbCarteCar"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuCarte()"
                              size="medium"
                              style="width: 100%"
                              >Carte Carburants</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                        <v-layout row v-if="droitAcces.intervention">
                        <v-flex md12 style="padding: 10px">
                          <el-badge
                            :value="nbDemandCarbu"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="modalDmdCarb()"
                              size="medium"
                              style="width: 100%"
                              >Demande de carburant</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout row justify>
                    <!-- ADMINISTRATION -->
                    <v-flex
                      md6
                      style="padding: 10px"
                      v-if="
                        droitAcces.webservice_consommation_index ||
                          droitAcces.intervention ||
                          droitAcces.list_dmdeur_intervention
                      "
                    >
                      <el-button type="primary" size="medium" class="btnV"
                        >ADMINISTRATION</el-button
                      >

                      <v-layout row justify>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbVisiteTech"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuVisiteTechnique()"
                              size="medium"
                              style="width: 100%"
                              >Visites technique</el-button
                            >
                          </el-badge>
                        </v-flex>

                          <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbVidang"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuVidange()"
                              size="medium"
                              style="width: 100%"
                              >Vidanges</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>

                      <v-layout row justify>
                        <v-flex md6 style="padding: 10px">
                          <el-badge
                            :value="this.nbAssur"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="menuAssurance()"
                              size="medium"
                              style="width: 100%"
                              >Assurances</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- INTERVENTION -->
                    <v-flex md6 style="padding: 10px">
                      <el-button type="danger" size="medium" class="btnV"
                        >MAINTENANCE</el-button
                      >

                      <v-layout row justify>
                        <v-flex xs12 style="padding: 10px">
                          <el-card class="box-card">
                            <el-collapse accordion>
                              <el-collapse-item name="1">
                                <template slot="title">
                                  Statistique des maintenances
                                  <i class="header-icon el-icon-info"></i>
                                </template>
                                <div>
                                  <el-table
                                    :data="tableStatInterv"
                                    style="width: 100%"
                                    height="330"
                                  >
                                    <el-table-column
                                      prop="etatInterv"
                                      label="Etat"
                                      width="100"
                                    >
                                      <template slot-scope="scope">
                                        <el-tag
                                          :type="scope.row.color"
                                          disable-transitions
                                          >{{ scope.row.etatInterv }}</el-tag
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="nbInterv"
                                      label="Nb Intervention"
                                      width="150"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                      fixed="right"
                                      prop="action"
                                      label="Action"
                                      width="80"
                                    >
                                      <template slot-scope="scope">
                                        <el-button
                                          type="text"
                                          size="small"
                                          @click="
                                            loadListIntervention(
                                              scope.row.idEtat
                                            )
                                          "
                                          >Details</el-button
                                        >
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </el-card>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="droitAcces.intervention">
                        <v-flex md12 style="padding: 10px">
                          <el-badge
                            :value="nbDemand"
                            class="item"
                            style="width: 100%"
                          >
                            <el-button
                              @click="modalInterv()"
                              size="medium"
                              style="width: 100%"
                              >Demandes</el-button
                            >
                          </el-badge>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-col>

        <!-- MENU DE DROIT -->
        <el-col
          :span="6"
          v-if="droitAcces.intervention || droitAcces.list_dmdeur_intervention"
        >
          <el-card class="box-card">
            <v-flex md12 class="text-xs-left">
              <v-chip text-color="white" label color="red" class="btnV">
                COÛT TOTAL : {{ detailCout.totalCout }} FCFA<v-icon right
                  >monetization_on</v-icon
                >
              </v-chip>
            </v-flex>
            <br /><br />

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width:100%"
                >
                  CHARGES FIXES : {{ detailCout.montantChargeFixe }} FCFA
                </v-chip>
              </div>

              <v-chip outline color="secondary" style="width:100%"
                >Achat : {{ detailCout.montantAchat }} FCFA</v-chip
              >
              <v-chip outline color="secondary" style="width:100%"
                >Location : {{ detailCout.montantLocation }} FCFA</v-chip
              >
              <v-chip outline color="secondary" style="width:100%"
                >Assurances : {{ detailCout.montantAssur }} FCFA</v-chip
              >
              <v-chip outline color="secondary" style="width:100%"
                >Visites techniques :
                {{ detailCout.montantVistech }} FCFA</v-chip
              >
              <v-chip outline color="secondary" style="width:100%"
                >Vidanges : {{ detailCout.montantVid }} FCFA</v-chip
              >
            </el-card>
            <br />

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <v-chip
                  text-color="white"
                  label
                  color="green"
                  style="width:100%"
                >
                  CHARGES VARIABLES :
                  {{ detailCout.montantChargeVariable }} FCFA
                </v-chip>
              </div>

              <v-chip outline color="secondary" style="width:100%"
                >Caburant : {{ detailCout.montantCarburant }} FCFA</v-chip
              >
              <v-chip outline color="secondary" style="width:100%"
                >Interventions : {{ detailCout.montantInterv }} FCFA</v-chip
              >
            </el-card>
          </el-card>
        </el-col>
      </el-row>
    </v-card-text>

    <!-- MODAL LISTE DES INTERVENTIONS -->
    <v-dialog
      v-model="dialogIntervention"
      max-width="100%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Liste des interventions </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogIntervention = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip
              text-color="white"
              label
              color="primary"
              style="width: 100%"
            >
              INTERVENTIONS
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="green"
                :disabled="disabledBtnDmd"
                @click.stop="imprimeListeDemande('PDF')"
                dark
                >Imprimer PDF <v-icon right>add</v-icon></v-btn
              >
              Imprimer en PDF
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="warning"
                :disabled="disabledBtnDmd"
                @click.stop="imprimeListeDemande('EXC')"
                dark
                >Imprimer EXCEL <v-icon right>add</v-icon></v-btn
              >
              Imprimer en Excel
            </v-tooltip>

            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newIntervention"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter une nouvelle intervention
            </v-tooltip>
          </div>
          <v-container fluid grid-list-md>
            <data-tables :data="listIntervention" style="width: 100%">
              <el-table-column
                prop="vehicule"
                label="Véhicule"
                width="280"
                fixed="left"
              >
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.vehicule }}
                    <v-icon right>directions_car</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="Date" width="200">
                <template slot-scope="scope">
                  <v-chip outline label text-color="primary" color="primary">
                    {{ scope.row.date }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type" width="160">
                <template slot-scope="scope">
                  <v-chip
                    v-if="scope.row.type == 'Curative'"
                    label
                    text-color="white"
                    color="red"
                  >
                    CURATIVE
                  </v-chip>
                  <v-chip v-else label text-color="white" color="orange">
                    PREVENTIVE
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="demandeur"
                label="Demandeur"
                width="180"
              ></el-table-column>
              <el-table-column prop="etat" label="Etat / Etape" width="220">
                <template slot-scope="scope">
                  <v-chip
                    v-if="scope.row.etat == 0"
                    label
                    text-color="white"
                    color="primary"
                  >
                    EN ATTENTE DE VALIDATION
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 1"
                    label
                    text-color="white"
                    color="primary"
                  >
                    EN ATTENTE DE VALIDATION DU DEVIS
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 2"
                    label
                    text-color="white"
                    color="red"
                  >
                    INTERVENTION REFUSE
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 3"
                    label
                    text-color="white"
                    color="green"
                  >
                    DEVIS VALIDE
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 4"
                    label
                    text-color="white"
                    color="red"
                  >
                    DIVIS REFUSE
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 5"
                    label
                    text-color="white"
                    color="green"
                  >
                    INTERVENTION TERNIME
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action" fixed="right" width="150">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        v-if="scope.row.etape == 6"
                        slot="activator"
                        @click="showIntervention(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <!-- && droitAcces.intervention -->
                      <v-btn
                        v-if="scope.row.etape < 6"
                        slot="activator"
                        @click="showIntervention(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>

                    <v-tooltip top>
                      <v-btn
                        v-if="droitAcces.intervention"
                        slot="activator"
                        @click.stop="
                          dialogSupr = true;
                          InterId = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>

                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="imprimerDemande(scope.row)"
                        fab
                        dark
                        small
                        color="orange"
                      >
                        <v-icon dark>print</v-icon>
                      </v-btn>
                      Imprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogIntervention = false" color="orange" dark
            >Annuler <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES PARAMARQUES -->
    <v-dialog
      v-model="dialogParaMarque"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Liste Marques, Modeles et Series </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogParaMarque = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text fluid grid-list-md>
          <p align="center">
            <v-chip
              text-color="white"
              label
              color="primary"
              style="width: 100%"
            >
              LISTE DES MARQUES, MODELES ET SERIES
            </v-chip>
          </p>

          <v-layout row>
            <!--MARQUE -->
            <v-flex md6>
              <v-chip label color="orange" text-color="white"
                >LISTE DES MARQUES
              </v-chip>

              <v-flex xs3>
                <el-col :span="2">
                  <el-popover
                    ref="popover5"
                    placement="top"
                    width="180"
                    trigger="hover"
                  >
                    <p>Veuillez choisir le format d'impression ?</p>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        type="success"
                        size="mini"
                        @click="imprimeListeMarque('PDF')"
                        >PDF</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="imprimeListeMarque('EXC')"
                        >EXCEL</el-button
                      >
                    </div>
                  </el-popover>
                  <div>
                    <el-button
                      v-popover:popover5
                      type="warning"
                      :disabled="disabledBtnMarq"
                      icon="el-icon-printer"
                      >Imprimer la liste
                    </el-button>
                  </div>
                </el-col>
              </v-flex>
              <br /><br />

              <!-- BTN AJOUT -->
              <v-spacer></v-spacer>
              <div class="text-xs-right">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    icons
                    color="primary"
                    @click.stop="newMarque()"
                    dark
                    >Ajouter <v-icon right>add</v-icon></v-btn
                  >
                  Ajouter une nouvelle marque
                </v-tooltip>
              </div>

              <data-tables :data="listMarque" style="width: 100%">
                <el-table-column prop="logo" label="Logo">
                  <template slot-scope="scope">
                    <v-avatar>
                      <!-- <img :src="worklogCourant.urlImage" alt="avatar"/> -->
                      <img
                        v-if="scope.row.url"
                        :src="scope.row.url"
                        class="lazy"
                        alt=""
                      />
                      <img
                        v-else
                        src="/static/avatar-marque.png"
                        class="lazy"
                        alt=""
                      />
                    </v-avatar>
                  </template>
                </el-table-column>
                <el-table-column prop="libelle" label="Libelle">
                  <template slot-scope="scope">
                    <v-chip outline label text-color="primary" color="primary">
                      {{ scope.row.libelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column label="Action">
                  <template slot-scope="scope">
                    <div class="text-xs-center">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click="editMarque(scope.row)"
                          fab
                          dark
                          small
                          color="primary"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                        Modifier
                      </v-tooltip>
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="
                            dialogSuprMarq = true;
                            idMarque = scope.row.id;
                          "
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                        Supprimer
                      </v-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </data-tables>
            </v-flex>
            <!-- FIN MARQUE  -->

            <!--MODELE-->
            <v-flex md6>
              <v-chip label color="orange" text-color="white">
                LISTE DES MODELES
              </v-chip>

              <!-- BTN AJOUT -->
              <v-spacer></v-spacer>

              <v-flex xs3>
                <el-col :span="2">
                  <el-popover
                    ref="popover5"
                    placement="top"
                    width="180"
                    trigger="hover"
                  >
                    <p>Veuillez choisir le format d'impression ?</p>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        type="success"
                        size="mini"
                        @click="imprimeListeModele('PDF')"
                        >PDF</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="imprimeListeModele('EXC')"
                        >EXCEL</el-button
                      >
                    </div>
                  </el-popover>
                  <div>
                    <el-button
                      v-popover:popover5
                      type="warning"
                      :disabled="disabledBtnMod"
                      icon="el-icon-printer"
                      >Imprimer la liste
                    </el-button>
                  </div>
                </el-col>
              </v-flex>
              <br /><br />

              <div class="text-xs-right">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    icons
                    color="primary"
                    @click.stop="newModele()"
                    dark
                    >Ajouter <v-icon right>add</v-icon></v-btn
                  >
                  Ajouter un nouveau modele
                </v-tooltip>
              </div>

              <data-tables :data="listModele" style="width: 100%">
                <el-table-column prop="marque" label="Marque">
                  <template slot-scope="scope">
                    <v-chip outline label text-color="primary" color="primary">
                      {{ scope.row.marqLibelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column prop="modele" label="Modele">
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="indigo">
                      {{ scope.row.libelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column label="Action">
                  <template slot-scope="scope">
                    <div class="text-xs-center">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click="editModele(scope.row)"
                          fab
                          dark
                          small
                          color="primary"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                        Modifier
                      </v-tooltip>
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="
                            dialogSuprModel = true;
                            idModele = scope.row.id;
                          "
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                        Supprimer
                      </v-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </data-tables>
            </v-flex>
            <!-- FIN MODELE-->
          </v-layout>

          <v-layout row>
            <!--SERIE-->
            <v-flex md6>
              <v-chip label color="orange" text-color="white"
                >LISTE DES SERIES
              </v-chip>

              <v-flex xs3>
                <el-col :span="2">
                  <el-popover
                    ref="popover5"
                    placement="top"
                    width="180"
                    trigger="hover"
                  >
                    <p>Veuillez choisir le format d'impression ?</p>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        type="success"
                        size="mini"
                        @click="imprimeListeSerie('PDF')"
                        >PDF</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="imprimeListeSerie('EXC')"
                        >EXCEL</el-button
                      >
                    </div>
                  </el-popover>
                  <div>
                    <el-button
                      v-popover:popover5
                      type="warning"
                      :disabled="disabledBtnSerie"
                      icon="el-icon-printer"
                      >Imprimer la liste
                    </el-button>
                  </div>
                </el-col>
              </v-flex>
              <br /><br />

              <!-- BTN AJOUT -->
              <v-spacer></v-spacer>
              <div class="text-xs-right">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    icons
                    color="primary"
                    @click.stop="newSerie()"
                    dark
                    >Ajouter <v-icon right>add</v-icon></v-btn
                  >
                  Ajouter une nouvelle serie
                </v-tooltip>
              </div>

              <data-tables :data="listSerie" style="width: 100%">
                <el-table-column prop="modele" label="Modele">
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.ModeleLibelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column prop="serie" label="Serie">
                  <template slot-scope="scope">
                    <v-chip outline label text-color="primary" color="primary">
                      {{ scope.row.libelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column label="Action">
                  <template slot-scope="scope">
                    <div class="text-xs-center">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click="editSerie(scope.row)"
                          fab
                          dark
                          small
                          color="primary"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                        Modifier
                      </v-tooltip>
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="
                            dialogSuprSeri = true;
                            idSerie = scope.row.id;
                          "
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                        Supprimer
                      </v-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </data-tables>
            </v-flex>
            <!-- FIN SERIE-->
          </v-layout>

          <v-btn @click="dialogParaMarque = false" color="orange" dark
            >Annuler <v-icon right>remove_circle</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES CONTRATS -->
    <v-dialog
      v-model="dialogContrat"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span>Liste des contrats de locations </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogContrat = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text :loading="loading">
          <Loading :value="loading"></Loading>
          <p align="center">
            <v-chip text-color="white" label color="green" style="width: 100%">
              LISTE DES CONTRATS DE LOCATION DE VEHICULE
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-flex xs3>
              <el-col :span="2">
                <el-popover
                  ref="popover5"
                  placement="top"
                  width="180"
                  trigger="hover"
                >
                  <p>Veuillez choisir le format d'impression ?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="success"
                      size="mini"
                      @click="imprimeListeContrat('PDF')"
                      >PDF</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="imprimeListeContrat('EXC')"
                      >EXCEL</el-button
                    >
                  </div>
                </el-popover>
                <div>
                  <el-button
                    v-popover:popover5
                    type="warning"
                    :disabled="disabledBtnCont"
                    icon="el-icon-printer"
                    >Imprimer la liste
                  </el-button>
                </div>
              </el-col>
            </v-flex>
            <br /><br />

            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newContrat"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter un nouveau contrat
            </v-tooltip>
          </div>
          <v-container fluid grid-list-md>
            <data-tables :data="listContrat" style="width: 100%">
              <el-table-column
                prop="ref"
                label="Référence"
                width="100"
                fixed="left"
              ></el-table-column>
              <el-table-column
                prop="vehicule"
                label="Véhicule"
                width="300"
                fixed="left"
              >
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.vehicule }}
                    <v-icon right>directions_car</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="client" label="Client" width="180">
                <template slot-scope="scope">
                  <v-chip text-color="white" color="primary">
                    {{ scope.row.client }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="dateD"
                label="Date début et Fin"
                width="200"
              >
                <template slot-scope="scope">
                  <v-chip outline label text-color="primary" color="primary">
                    {{ scope.row.dateD }} - {{ scope.row.dateF }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="montantTotal" label="Montant" width="200">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="orange">
                    {{ scope.row.montantTotalFormat }} FCFA
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdUser"
                label="Enregistrer par"
                width="180"
              >
                <template slot-scope="scope">
                  <v-chip text-color="white" color="primary">
                    {{ scope.row.createdUser }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="etat" label="Type" width="160">
                <template slot-scope="scope">
                  <v-chip
                    v-if="scope.row.etat == 0"
                    label
                    text-color="white"
                    color="orange"
                  >
                    RESERVE
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 1"
                    label
                    text-color="white"
                    color="green"
                  >
                    ACTIVE
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 2"
                    label
                    text-color="white"
                    color="red"
                  >
                    TERMINE
                  </v-chip>
                  <v-chip
                    v-else-if="scope.row.etat == 3"
                    label
                    text-color="white"
                    color="red"
                  >
                    RESILIE
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action" fixed="right" width="200">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="showContrat(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        v-if="scope.row.etat == 0"
                        slot="activator"
                        @click="editContrat(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        v-if="scope.row.etat == 1"
                        slot="activator"
                        @click="closeContrat(scope.row)"
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>close</v-icon>
                      </v-btn>
                      Mettre fin au contrat
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        v-if="scope.row.etat != 0"
                        slot="activator"
                        @click="impmerFacture(scope.row)"
                        fab
                        dark
                        small
                        color="orange"
                      >
                        <v-icon dark>print</v-icon>
                      </v-btn>
                      Imprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogContrat = false" color="orange" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>


       <!-- MODAL LISTE DES DEMANDES DE FOND DE TYPE CARBURANTS -->
    <v-dialog
      v-model="dialogShowListDfon"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span>Liste des demandes de fonds en carburant </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowListDfon = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text :loading="loading">
          <Loading :value="loading"></Loading>
          <p align="center">
            <v-chip text-color="white" label color="green" style="width: 100%">
              LISTE DES DEMANDES DE FONDS EN CARBURANT
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
           <!-- BTN AJOUT -->
          <v-layout row>
              <v-flex class="mb-1 " xs4 md4>
              <v-card-text class="text-xs-center">
                  <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:100%">
                      <span class="subheading">Montant Total: </span> <span class="title"> {{mntTotal}} Fcfa </span>
                  </v-chip>
              </v-card-text>
              </v-flex>

              <v-flex class="mb-1 " xs4 md4 >
                  <v-card-text class="">
                  <v-chip color="orange" text-color="white" style="font-size:18px">
                  <v-avatar  class="orange darken-4">{{totalDmd}}</v-avatar>
                  Demandes
              </v-chip>
                </v-card-text>
              </v-flex>
          </v-layout>

          <v-spacer></v-spacer>
          <v-container fluid grid-list-md>
            <data-tables :data="listeDemandes">
                  <el-table-column prop="dateFormat" label="Date" > </el-table-column>
                  <el-table-column prop="demandeur" label="Nom du demandeur" ></el-table-column>
                  <el-table-column prop="montantFormat" label="Montant (Fcfa)" > </el-table-column>
                  <el-table-column prop="libStatut" label="Statut" >
                  <template slot-scope="scope">
                      <el-tag v-if="scope.row.statut == 0" type="danger">  {{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 1" >{{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 2" type="info" >{{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 3" type="success" >{{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 4" type="success" >{{scope.row.libStatut}}</el-tag>
                      <el-tag v-if="scope.row.statut == 5" type="info" >{{scope.row.libStatut}}</el-tag>
                  </template>
                  </el-table-column>
                  <el-table-column prop="caissePaie" label="Caisse paiement" >
                      <template slot-scope="scope">
                      <el-tag type="info" >{{scope.row.caissePaie}}</el-tag>
                      </template>
                  </el-table-column>
                  <el-table-column prop="carte" label="Carte" >
                      <template slot-scope="scope">
                      <el-tag v-if="scope.row.carte" type="info" >{{scope.row.carte}}</el-tag>
                      </template>
                  </el-table-column>

                  <el-table-column label="Action" align="center" fixed="right"  >
                  <template slot-scope="scope">
                      <v-tooltip top>
                      <v-btn  slot="activator" @click="modalImpDmd(scope.row)" fab dark small color="grey">
                          <v-icon dark>list</v-icon>
                          </v-btn>
                              Detail
                      </v-tooltip>
                  </template>
                  </el-table-column>
              </data-tables>
          </v-container>

          <v-btn @click="dialogShowListDfon = false" color="orange" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES CLIENT -->
    <v-dialog
      v-model="dialogClientLocation"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span>Liste des clients </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogClientLocation = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip text-color="white" label color="green" style="width: 100%">
              LISTE DES CLIENTS
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-flex xs3>
              <el-col :span="2">
                <el-popover
                  ref="popover5"
                  placement="top"
                  width="180"
                  trigger="hover"
                >
                  <p>Veuillez choisir le format d'impression ?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="success"
                      size="mini"
                      @click="imprimeListeClient('PDF')"
                      >PDF</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="imprimeListeClient('EXC')"
                      >EXCEL</el-button
                    >
                  </div>
                </el-popover>
                <div>
                  <el-button
                    v-popover:popover5
                    type="warning"
                    :disabled="disabledBtnCli"
                    icon="el-icon-printer"
                    >Imprimer la liste
                  </el-button>
                </div>
              </el-col>
            </v-flex>
            <br /><br />

            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newClientLocation"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter une nouveau client
            </v-tooltip>
          </div>
          <v-container fluid grid-list-md>
            <data-tables :data="listClientLocation" style="width: 100%">
              <el-table-column prop="nom" label="Nom et Prenom" width="300">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.nomPrenom }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="piece"
                label="Type de personne"
                width="200"
              >
                <template slot-scope="scope">
                  <v-chip
                    v-if="scope.row.type == 'Personne physique'"
                    label
                    text-color="white"
                    color="indigo"
                  >
                    {{ scope.row.type }}
                  </v-chip>
                  <v-chip v-else label text-color="white" color="primary">
                    {{ scope.row.type }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="contact" label="Contact">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="orange">
                    {{ scope.row.contact }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="showLocationClient(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editClientLocation(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprClientLocation = true;
                          idClientLoc = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogClientLocation = false" color="orange" dark
            >Annuler <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES CONDUCTEURS -->
    <v-dialog
      v-model="dialogConducteur"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Liste des conducteurs </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogConducteur = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip
              text-color="white"
              label
              color="primary"
              style="width: 100%"
            >
              LISTE DES CONDUCTEURS
            </v-chip>
          </p>

          <v-flex xs3>
            <el-col :span="2">
              <el-popover
                ref="popover5"
                placement="top"
                width="180"
                trigger="hover"
              >
                <p>Veuillez choisir le format d'impression ?</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    type="success"
                    size="mini"
                    @click="imprimeListeConducteur('PDF')"
                    >PDF</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="imprimeListeConducteur('EXC')"
                    >EXCEL</el-button
                  >
                </div>
              </el-popover>
              <div>
                <el-button
                  v-popover:popover5
                  type="warning"
                  :disabled="disabledBtnCond"
                  icon="el-icon-printer"
                  >Imprimer la liste
                </el-button>
              </div>
            </el-col>
          </v-flex>
          <br /><br />

          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <input
              name="fileInputExcel"
              type="file"
              style="display:none"
              ref="fileInputExcel"
              accept="image/*"
              @change="onFileExcelPicked"
            />
            <el-dropdown @command="handleFileExcel">
              <el-button type="success">
                Fichier excel<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0"
                  >Importer fichier excel</el-dropdown-item
                >
                <el-dropdown-item command="1"
                  >Générer un modèle</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="text-xs-right">
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newConducteur"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter une nouveau conducteur
            </v-tooltip>
          </div>
          <v-container fluid grid-list-md>
            <data-tables :data="listConducteur" style="width: 100%">
              <el-table-column prop="url" label="Photo" width="100">
                <template slot-scope="scope">
                  <v-avatar>
                    <img
                      v-if="scope.row.url"
                      :src="scope.row.url"
                      class="lazy"
                      alt=""
                    />
                    <img
                      v-else
                      src="/static/avatar-conducteur.png"
                      class="lazy"
                      alt=""
                    />
                  </v-avatar>
                </template>
              </el-table-column>
              <el-table-column prop="nomPren" label="Conducteur" width="300">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.nomPren }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="date"
                label="Date validité du permis"
                width="200"
              >
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.dateValPmi }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="montant" label="Disponibilité">
                <template slot-scope="scope">
                  <v-chip
                    v-if="scope.row.disponibilite === 'Disponible'"
                    color="green"
                    text-color="white"
                  >
                    <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                    {{ scope.row.disponibilite }}
                  </v-chip>
                  <v-chip
                    v-if="scope.row.disponibilite === 'En activite'"
                    color="orange"
                    text-color="white"
                  >
                    <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                    {{ scope.row.disponibilite }}
                  </v-chip>
                  <v-chip
                    v-if="scope.row.disponibilite === 'Absent'"
                    color="red"
                    text-color="white"
                  >
                    <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                    {{ scope.row.disponibilite }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="ficheConducteur(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editConducteur(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="ImprimerConducteur(scope.row)"
                        fab
                        dark
                        small
                        color="orange"
                      >
                        <v-icon dark>print</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprCond = true;
                          idConducteur = scope.row.idCond;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogConducteur = false" color="orange" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES VIdangeS -->
    <v-dialog
      v-model="dialogVidange"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Liste des vidanges </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogVidange = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip
              text-color="white"
              label
              color="primary"
              style="width: 100%"
            >
              LISTE DES VIDANGES
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-flex xs3>
              <el-col :span="2">
                <el-popover
                  ref="popover5"
                  placement="top"
                  width="180"
                  trigger="hover"
                >
                  <p>Veuillez choisir le format d'impression ?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="success"
                      size="mini"
                      @click="imprimeListeVign('PDF')"
                      >PDF</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="imprimeListeVign('EXC')"
                      >EXCEL</el-button
                    >
                  </div>
                </el-popover>
                <div>
                  <el-button
                    v-popover:popover5
                    type="warning"
                    :disabled="disabledBtnAllVidn"
                    icon="el-icon-printer"
                    >Imprimer la liste
                  </el-button>
                </div>
              </el-col>
            </v-flex>
            <br /><br />

            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newVida"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter une nouvelle vidange
            </v-tooltip>
          </div>
          <v-container fluid grid-list-md>
            <data-tables :data="listVidn" style="width: 100%">
              <el-table-column prop="numero" label="Numéro vidange" width="100">
                <template slot-scope="scope">
                  {{ scope.row.numero }}
                </template>
              </el-table-column>
              <el-table-column prop="vehicule" label="Véhicule" width="300">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.vehicule }}
                    <v-icon right>directions_car</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="jourRenouvel"
                label="A renouveler dans"
                width="200"
              >
                <template slot-scope="scope">
                  <v-chip v-if="scope.row.jourRenouvel > 0 " label text-color="white" color="primary">
                    {{ scope.row.jourRenouvel }} JOURS
                  </v-chip>
                   <v-chip v-else label text-color="white" color="warning">
                      EXPIRÉ Y'A {{ Math.abs(scope.row.jourRenouvel)}} JOURS
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="montant" label="Montant (FCFA)">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="orange">
                    {{ scope.row.montSepar }} FCFA
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <div>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="showVign(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editVign(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="ImprimerVidange(scope.row)"
                        fab
                        dark
                        small
                        color="orange"
                      >
                        <v-icon dark>print</v-icon>
                      </v-btn>
                      Imprimer
                    </v-tooltip>
                    <v-tooltip top v-if="scope.row.statut == false">
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprVign = true;
                          idVign = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogVidange = false" color="orange" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES VISITES TECHNIQUES -->
    <v-dialog
      v-model="dialogVisite"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Liste des visites techniques </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogVisite = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip
              text-color="white"
              label
              color="primary"
              style="width: 100%"
            >
              LISTE DES VISITES TECHNIQUES
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <!-- <v-flex xs3>
              <el-col :span="2">
                <el-popover
                  ref="popover5"
                  placement="top"
                  width="180"
                  trigger="hover"
                >
                  <p>Veuillez choisir le format d'impression ?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="success"
                      size="mini"
                      @click="imprimeListeVisitTechnik('PDF')"
                      >PDF</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="imprimeListeVisitTechnik('EXC')"
                      >EXCEL</el-button
                    >
                  </div>
                </el-popover>
                <div>
                  <el-button
                    v-popover:popover5
                    type="warning"
                    :disabled="disabledBtnVisT"
                    icon="el-icon-printer"
                    >Imprimer la liste
                  </el-button>
                </div>
              </el-col>
            </v-flex> -->
            <br /><br />

            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newVisit"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter une nouvelle visite technique
            </v-tooltip>
          </div>
          <v-container fluid grid-list-md>
            <data-tables :data="listVisite" style="width: 100%">
              <el-table-column prop="ref" label="Référence" width="100">
                <template slot-scope="scope">
                  {{ scope.row.reference }}
                </template>
              </el-table-column>
              <el-table-column prop="vehicule" label="Véhicule" width="300">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.VehMat }} <v-icon right>directions_car</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="date"
                label="Date début et fin"
                width="200"
              >
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.dateDebut }} - {{ scope.row.dateFin }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="montant" label="Montant (FCFA)">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="orange">
                    {{ scope.row.montSepar }} FCFA
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="showVisit(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editVisit(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="ImprimerVisite(scope.row)"
                        fab
                        dark
                        small
                        color="orange"
                      >
                        <v-icon dark>print</v-icon>
                      </v-btn>
                      Imprimer
                    </v-tooltip>
                    <v-tooltip top v-if="scope.row.statut == false">
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprVisit = true;
                          idVisit = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogVisite = false" color="orange" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL LISTE DES ASSURANCES -->
    <v-dialog
      v-model="dialogAssurance"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Liste des assurances </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAssurance = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip
              text-color="white"
              label
              color="primary"
              style="width: 100%"
            >
              LISTE DES ASSURANCES
            </v-chip>
          </p>
          <!-- BTN AJOUT -->
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-flex xs3>
              <el-col :span="2">
                <el-popover
                  ref="popover5"
                  placement="top"
                  width="180"
                  trigger="hover"
                >
                  <p>Veuillez choisir le format d'impression ?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="success"
                      size="mini"
                      @click="imprimeListeAssur('PDF')"
                      >PDF</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="imprimeListeAssur('EXC')"
                      >EXCEL</el-button
                    >
                  </div>
                </el-popover>
                <div>
                  <el-button
                    v-popover:popover5
                    type="warning"
                    :disabled="this.nbAssur  == 0 "
                    @click="imprimeListeAssur('PDF')"
                    icon="el-icon-printer"
                    >Imprimer la liste
                  </el-button>
                </div>
              </el-col>
            </v-flex>
            <br /><br />

            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newAssu"
                dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
              Ajouter une nouvelle assurance
            </v-tooltip>
          </div>

          <v-container fluid grid-list-md>
            <data-tables :data="listAssu" style="width: 100%">
              <el-table-column prop="Société" label="Société" width="140">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.societe }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="vehMatricule" label="Véhicule" width="300">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.vehMatricule }} {{ scope.row.vehMarque }}
                    <v-icon right>directions_car</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="dateFn" label="Date de fin" width="200">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.dateFn }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="mntAssur" label="Montant (FCFA)">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="orange">
                    {{ scope.row.mntAssur }} FCFA
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="showAssu(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editAssu(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top v-if="scope.row.statut == false">
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprAssu = true;
                          idAssu = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-container>

          <v-btn @click="dialogAssurance = false" color="orange" dark
            >Annuler <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL CONSOMMATIONS -->
    <v-dialog
      persistent
      v-model="dialogConsommationCarburant"
      v-if="!droitAcces.liste_consomation"
      max-width="80%"
      fullscreen
      :overlay="true"
      scrollable
      :loading="loading"
    >
      <v-card>
        <v-toolbar card dark color="orange">
          <v-toolbar-title>Consommation de carburant</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogConsommationCarburant = false">
            <v-icon>close</v-icon></v-btn
          >
        </v-toolbar>

        <v-card-text>
          <v-card-title>
            <v-chip label color="orange" text-color="white">
              LISTE DES CONSOMMATION DE CARBURANTS
            </v-chip>

            <v-flex xs3>
              <el-col :span="2">
                <el-popover
                  ref="popover5imprimeListeConsPDF"
                  placement="top"
                  width="180"
                  trigger="hover"
                >
                  <p>Veuillez choisir le format d'impression ?</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="success"
                      size="mini"
                      @click="imprimeListeConsPDF()"
                      >PDF</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="imprimeListeCarburant('EXC')"
                      >EXCEL</el-button
                    >
                  </div>
                </el-popover>
                <div>
                  <el-button
                    v-popover:popover5
                    type="warning"
                    :disabled="disabledBtnCarbu"
                    icon="el-icon-printer"
                    >Imprimer la liste
                  </el-button>
                </div>
              </el-col>
            </v-flex>
            <br /><br />

            <v-spacer></v-spacer>
            <!--Bouton ajouter consommation-->
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="newConsom()"
                dark
              >
                Ajouter <v-icon center>add</v-icon>
              </v-btn>
              Ajouter une nouvelle comsommation de carburant
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-chip outline text-color="primary" label color="primary">
              MONTANT TOTAL : {{ mntTotCons }} FCFA
              <v-icon right>monetization_on</v-icon>
            </v-chip>
            <v-chip outline text-color="primary" label color="primary">
              QUANTITE CONSOMME (L) : {{ quantTotCons }} L
            </v-chip>
            <v-chip outline text-color="primary" label color="primary">
              QDISTANCE PARCOURUE (KM) : {{ distParcTot }} Km
            </v-chip>

            <div class="text-xs-right ">
              <span class="demonstration">Période</span>
              <el-date-picker
                v-model="periode"
                type="datetimerange"
                range-separator="à"
                format="d-MM-yyyy HH:mm"
                value-format="yyyy-MM-d HH:mm"
                start-placeholder="Date de début"
                end-placeholder="Date de fin"
              >
              </el-date-picker>
              <el-button
                @click.stop="filtrePeriode"
                type="primary"
                icon="el-icon-search"
                circle
              ></el-button>
            </div>

            <data-tables :data="listConsommation" style="width: 100%">
              <el-table-column prop="station" label="Fournisseur">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.station }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="vehicule"
                label=" Vehicule"
              ></el-table-column>
              <el-table-column
                prop="quantite"
                label="Quantite"
              ></el-table-column>
              <el-table-column prop="dateAchat" label="Date d'achat">
                <template slot-scope="scope">
                  <v-chip label text-color="white" color="primary">
                    {{ scope.row.dateAchat }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="carteID" label="Carte"></el-table-column>
              <el-table-column
                prop="typeCons"
                label="Moyen de paiement"
              ></el-table-column>

              <el-table-column prop="mntConsFormat" label="Montant (FCFA)">
                <template slot-scope="scope">
                  <v-chip color="green" text-color="white">
                    {{ scope.row.mntConsFormat }} FCFA
                    <v-icon right>monetization_on</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdUser"
                label="Enregistré par"
              ></el-table-column>
              <el-table-column
                prop="kiloCons"
                label="Kilometrage"
                width="70"
              ></el-table-column>
              <el-table-column
                prop="distParcourCons"
                label="Distance parcourue"
              ></el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        v-if="scope.row.imageRecu"
                        @click.stop="imprimerRecu(scope.row.imageRecu)"
                        fab
                        dark
                        icons
                        small
                        color="cyan"
                      >
                        <v-icon dark>photo</v-icon>
                      </v-btn>
                      Pièce jointe (Recu de paiement)
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editCarburant(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="
                          idConsommation = scope.row.id;
                          dialogSuppCarburant = true;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </v-card-text>

          <v-btn
            icons
            color="orange"
            @click="dialogConsommationCarburant = false"
            dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DES INTERVENTIONS -->
    <v-dialog
      v-model="dialogAjoutIntervention"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Ajouter une nouvelle intervention </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutIntervention = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-stepper v-model="etape">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="etape > 1"
                >Détail de la demande</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="etape > 2"
                >Validation de l'intervention</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="etape > 3"
                >Diagnostique et dévis</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step step="4" :complete="etape > 4"
                >Interventions</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step step="5" :complete="etape > 5"
                >Fin des interventions</v-stepper-step
              >
              <v-stepper-step
                v-if="interventionCourant.etape === 5"
                step="6"
                :complete="etape > 6"
                >Bilan</v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-container fluid grid-list-md>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="width: 100%"
                    >
                      AJOUT D'UNE NOUVELLE INTERVENTION
                    </v-chip>
                  </p>
                  <v-form
                    v-model="valid"
                    ref="formIntervention"
                    lazy-validation
                    id="formIntervention"
                  >
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Véhicule concerné *</span>
                          <el-select
                            filterable
                            clearable
                            v-model="selectVehicule"
                            placeholder="Véhicule concerné"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                          >
                            <el-option
                              v-for="item in listVehicule"
                              :key="item.idVeh"
                              :label="item.libelle"
                              :value="item.idVeh"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Catégorie *</span>
                          <el-select
                            clearable
                            v-model="selectCategorie"
                            placeholder="Catégorie"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                          >
                            <el-option
                              v-for="item in categorie"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Type de demande *</span>
                          <el-select
                            clearable
                            v-model="selectType"
                            placeholder="Type de demande"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                          >
                            <el-option
                              v-for="item in type"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Gravité *</span>
                          <el-select
                            clearable
                            v-model="selectGravite"
                            placeholder="Gravité"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                          >
                            <el-option
                              v-for="item in gravite"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Priorité *</span>
                          <el-select
                            clearable
                            v-model="selectPriorite"
                            placeholder="Priorité"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                          >
                            <el-option
                              v-for="item in priorite"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Date de la demande *</span
                          >
                          <el-date-picker
                            v-model="dateInter"
                            name="dateInter"
                            type="datetime"
                            placeholder="Date de la demande"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md4 v-if="selectCategorie == 'Autre'">
                        <div class="block">
                          <span class="demonstration">Autre catégorie *</span>
                          <el-input
                            name="autre"
                            placeholder="Autre catégorie"
                            v-model="autre"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Motif de la demande *</span
                          >
                          <el-input
                            type="textarea"
                            name="motif"
                            placeholder="Motif de la demande"
                            v-model="motif"
                            style="width:100%"
                            :disabled="interventionCourant.etat != 0"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />

                    <v-layout>
                      <v-btn
                        icons
                        color="orange"
                        @click="dialogAjoutIntervention = false"
                        dark
                        >Annuler <v-icon right>close</v-icon></v-btn
                      >

                      <v-btn
                        v-if="dialogEdit == false && etape == 1"
                        color="primary"
                        @click="submitIntervention(2)"
                        dark
                        >Ajouter <v-icon right>add</v-icon></v-btn
                      >

                      <v-btn
                        v-if="
                          dialogEdit == true && interventionCourant.etape == 2
                        "
                        color="primary"
                        @click="submitIntervention(2)"
                        dark
                        >Modifier <v-icon right>edit</v-icon></v-btn
                      >

                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="
                          dialogEdit == false &&
                            (etape == 1 || etape > 1) &&
                            droitAcces.intervention
                        "
                        color="primary"
                        @click="submitIntervention(2)"
                        dark
                        >Ajouter & Continuer
                        <v-icon right>keyboard_arrow_right</v-icon></v-btn
                      >

                      <!--  -->
                      <v-btn
                        v-if="
                          dialogEdit == true &&
                            (interventionCourant.etape == 2 ||
                              interventionCourant.etape > 2) &&
                            droitAcces.intervention
                        "
                        icons
                        color="primary"
                        @click="etape += 1"
                        dark
                      >
                        Continuer
                        <v-icon right>keyboard_arrow_right</v-icon></v-btn
                      >
                    </v-layout>
                  </v-form>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-container fluid grid-list-md>
                  <p align="center">
                    <v-chip
                      v-if="interventionCourant.etat == 2"
                      text-color="white"
                      label
                      color="red"
                      style="font-size:22px; width:100%"
                    >
                      DEMANDE REFUSER ET FERME <v-icon right>clear</v-icon>
                    </v-chip>
                    <v-chip
                      v-if="interventionCourant.etat == 1"
                      text-color="white"
                      label
                      color="green"
                      style="font-size:22px; width:100%"
                    >
                      DEMANDE VALIDE
                    </v-chip>
                  </p>

                  <v-form
                    v-model="valid"
                    ref="formValidInter"
                    lazy-validation
                    id="formValidInter"
                  >
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Véhicule concerné </span>
                          <el-input
                            :value="interventionCourant.vehicule"
                            :disabled="true"
                            v-model="interventionCourant.vehicule"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Catégorie</span>
                          <el-input
                            :value="interventionCourant.categorie"
                            :disabled="true"
                            v-model="interventionCourant.categorie"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Type de demande</span>
                          <el-input
                            :value="interventionCourant.type"
                            :disabled="true"
                            v-model="interventionCourant.type"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <!-- <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Demandeur</span>

                                                    <el-select clearable v-model="interventionCourant.demandeur" placeholder="demandeur" style="width:100%" :disabled="true">
                                                        <el-option v-for="item in listDemandeur" :key="item.value" :label="item.label" :value="item.id">
                                                        </el-option>
                                                    </el-select>

                                                </div>
                                            </v-flex> -->
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Gravité</span>
                          <el-input
                            :value="interventionCourant.gravite"
                            :disabled="true"
                            v-model="interventionCourant.gravite"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Priorité</span>
                          <el-input
                            :value="interventionCourant.priorite"
                            :disabled="true"
                            v-model="interventionCourant.priorite"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Date de la demande</span>
                          <el-input
                            :value="interventionCourant.date"
                            :disabled="true"
                            v-model="interventionCourant.date"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md8>
                        <div class="block">
                          <span class="demonstration">Motif de la demande</span>
                          <el-input
                            :value="interventionCourant.dateInter"
                            type="textarea"
                            name="motif"
                            placeholder="Motif de la demande"
                            v-model="interventionCourant.dateInter"
                            style="width:100%"
                            :disabled="true"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="primary"
                        style="font-size:22px; width:100%; margin: 10px"
                      >
                        VALIDATION DE LA DEMANDE D'INTERVENTION
                      </v-chip>
                    </p>

                    <v-layout row>
                      <v-flex md4 v-if="interventionCourant.etat <= 1">
                        <div class="block">
                          <span class="demonstration"
                            >Réponse de la demande *</span
                          >
                          <el-select
                            clearable
                            v-model="selectReponse"
                            placeholder="Réponse de la demande"
                            style="width:100%"
                            :disabled="interventionCourant.etat == 1"
                          >
                            <el-option
                              v-for="item in reponse"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4 v-if="interventionCourant.etat > 1">
                        <div class="block">
                          <span class="demonstration"
                            >Réponse de la demande **</span
                          >
                          <el-input
                            :disabled="true"
                            value="Valider"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md8>
                        <div class="block">
                          <span class="demonstration"
                            >Motif de la réponse ?</span
                          >
                          <el-input
                            :disabled="interventionCourant.etat >= 1"
                            name="remarque"
                            type="textarea"
                            placeholder="Motif de la demande"
                            v-model="remarque"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />
                  </v-form>
                </v-container>

                <v-layout>
                  <v-btn
                    icons
                    color="orange"
                    @click="dialogAjoutIntervention = !dialogAjoutIntervention"
                    dark
                    >Annuler <v-icon right>close</v-icon></v-btn
                  >
                  <v-btn
                    v-if="interventionCourant.etat == 0"
                    color="green"
                    @click="submitValideIntervention(3)"
                    dark
                    >Réponse <v-icon right>done_all</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn icons color="primary" @click="etape -= 1" dark>
                    <v-icon right>keyboard_arrow_left</v-icon>Précédent
                  </v-btn>
                  <v-btn
                    v-if="interventionCourant.etat >= 1"
                    icons
                    color="blue"
                    @click="etape += 1"
                    dark
                  >
                    Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn
                  >
                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-container fluid grid-list-md>
                  <p align="center">
                    <v-chip
                      v-if="interventionCourant.etat == 1"
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width:100%"
                    >
                      ENREGISTREMENT DU DIAGNOSTIQUE UN DEVIS
                    </v-chip>
                    <v-chip
                      v-if="interventionCourant.etat == 3"
                      text-color="white"
                      label
                      color="green"
                      style="font-size:22px; width:100%"
                    >
                      VOTRE DEVIS FINAL EST VALIDE
                    </v-chip>
                    <v-chip
                      v-if="interventionCourant.etat == 4"
                      text-color="white"
                      label
                      color="red"
                      style="font-size:22px; width:100%"
                    >
                      VOTRE DEVIS FINAL EST REFUSE. VEUILLEZ DONC SOUMETTRE UN
                      AUTRE DEVIS
                    </v-chip>
                  </p>

                  <v-form
                    v-model="valid"
                    ref="formDiagnostique"
                    lazy-validation
                    id="formDiagnostique"
                  >
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Prestataire *</span>
                          <el-select
                            filterable
                            clearable
                            v-model="selectPrestataire"
                            placeholder="Prestataire"
                            style="width:100%"
                            :disabled="interventionCourant.etat >= 3"
                          >
                            <el-option
                              v-for="item in listPrestataire"
                              :key="item.idPres"
                              :label="item.libelle"
                              :value="item.idPres"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Main d'oeuvre (FCFA) *</span
                          >
                          <el-input
                            type="number"
                            :min="0"
                            name="maindoeuvre"
                            v-model="maindoeuvre"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Caisse *</span>
                          <el-select
                            clearable
                            v-model="selectCaisse"
                            placeholder="Caisse *"
                            style="width:100%"
                            :disabled="interventionCourant.etat >= 3"
                          >
                            <el-option
                              v-for="item in listCaisse"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Date de paiement *</span>
                          <el-date-picker
                            v-model="datePaiement"
                            name="datePaiement"
                            value-format="dd-MM-yyyy"
                            type="date"
                            placeholder="Date de fin *"
                            style="width: 100%"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md8>
                        <div class="block">
                          <span class="demonstration"
                            >Diagnostique de l'intervention *</span
                          >
                          <el-input
                            type="textarea"
                            name="diagnostique"
                            v-model="diagnostique"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex md6>
                        <v-avatar
                          :tile="true"
                          size="140px"
                          height="120px"
                          color="grey lighten-4"
                        >
                          <img :src="imageDevis" alt="avatar" />
                        </v-avatar>

                        <v-layout row>
                          <input
                            name="fileDevis"
                            type="file"
                            style="display:none"
                            ref="fileDevis"
                            accept="image/*"
                            @change="onFileDevPicked"
                          />
                          <v-btn
                            color="primary"
                            class="white--text"
                            required
                            @click.native="$refs.fileDevis.click()"
                          >
                            Devis <v-icon right dark>cloud_upload</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="primary"
                        style="font-size:22px; width:100%"
                      >
                        DEVIS LIE AU DIAGNOSTIQUE
                      </v-chip>
                    </p>

                    <v-layout
                      row
                      v-for="(option, index) in devis"
                      :key="option.key"
                      :prop="'option.' + index + '.value'"
                      :indexProd="option"
                    >
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Désignation *</span>
                          <el-autocomplete
                            @select="handleChangePrix"
                            class="inline-input"
                            v-model="option.libelle"
                            required
                            :fetch-suggestions="querySearch"
                            placeholder="Désignation"
                            :trigger-on-focus="true"
                            style="width: 100%"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-autocomplete>
                        </div>
                      </v-flex>
                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Quantité *</span>
                          <el-input
                            v-model="option.qte"
                            @change="calculTotalDevis"
                            type="number"
                            min="1"
                            placeholder="Quantité"
                            style="width: 100%"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Unité</span>
                          <el-input
                            class="inline-input"
                            v-model="option.unite"
                            required
                            placeholder="Unité"
                            style="width: 100%"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Prix unitaire *</span>
                          <el-input
                            v-model="option.cout"
                            @change="calculTotalDevis"
                            type="number"
                            min="0"
                            placeholder="Prix unitaire"
                            style="width: 100%"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">TVA</span>
                          <el-input
                            v-model="option.tva"
                            @change="calculTotalDevis"
                            type="number"
                            min="0"
                            max="18"
                            placeholder="TVA"
                            style="width: 100%"
                            :disabled="interventionCourant.etat >= 3"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">TOTAL TTC</span>
                          <el-input
                            v-model="option.total"
                            type="number"
                            placeholder="TOTAL TTC"
                            style="width: 100%"
                            :disabled="true"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md1>
                        <v-tooltip top>
                          <v-btn
                            v-if="
                              interventionCourant.etat != 3 &&
                                interventionCourant.etape <= 3
                            "
                            slot="activator"
                            fab
                            dark
                            small
                            color="red"
                            @click="suppressionDevis(index)"
                          >
                            <v-icon dark>delete</v-icon>
                          </v-btn>
                          Supprimer
                        </v-tooltip>
                      </v-flex>
                    </v-layout>

                    <br />
                    <v-layout row>
                      <v-flex md10>
                        <v-chip
                          outline
                          text-color="primary"
                          label
                          color="primary"
                          style="font-size:25px; width:100%"
                        >
                          MONTANT HT : {{ ht }} FCFA
                        </v-chip>
                      </v-flex>

                      <v-spacer></v-spacer>
                      <v-flex md2>
                        <v-tooltip top>
                          <v-btn
                            v-if="
                              interventionCourant.etat != 3 &&
                                interventionCourant.etape <= 3
                            "
                            slot="activator"
                            @click="devisLigne"
                            fab
                            dark
                            small
                            color="blue"
                          >
                            <v-icon icon dark>add</v-icon>
                          </v-btn>
                          Ajouter
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md10>
                        <v-chip
                          outline
                          text-color="primary"
                          label
                          color="primary"
                          style="font-size:25px; width:100%"
                        >
                          MONTANT TVA : {{ tva }} FCFA
                        </v-chip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md10>
                        <v-chip
                          outline
                          text-color="orange"
                          label
                          color="orange"
                          style="font-size:25px; width:100%"
                        >
                          MONTANT TTC : {{ total }} FCFA
                        </v-chip>
                      </v-flex>
                    </v-layout>
                    <br />
                  </v-form>
                </v-container>

                <v-layout>
                  <v-btn
                    icons
                    color="orange"
                    @click="dialogAjoutIntervention = !dialogAjoutIntervention"
                    dark
                    >Annuler <v-icon right>close</v-icon></v-btn
                  >
                  <v-btn
                    v-if="
                      (interventionCourant.etat == 1 ||
                        interventionCourant.etat == 4) &&
                        interventionCourant.etape == 3
                    "
                    color="primary"
                    @click="submitDiagnostique(3)"
                    dark
                    >Ajouter <v-icon right>add</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      interventionCourant.etatDevis != 0 &&
                        (interventionCourant.etat == 1 ||
                          interventionCourant.etat == 4)
                    "
                    color="green"
                    @click="newValiderDevis(interventionCourant)"
                    dark
                    >Réponse <v-icon right>done_all</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn icons color="primary" @click="etape -= 1" dark>
                    <v-icon right>keyboard_arrow_left</v-icon>Précédent
                  </v-btn>
                  <v-btn
                    v-if="
                      interventionCourant.etat != 4 &&
                        interventionCourant.etat > 2
                    "
                    icons
                    color="blue"
                    @click="etape += 1"
                    dark
                  >
                    Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn
                  >
                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-container fluid grid-list-md>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width:100%"
                    >
                      PROGRAMMATION DE L'INTERVENTION
                    </v-chip>
                  </p>

                  <v-form
                    v-model="valid"
                    ref="formProgrammation"
                    lazy-validation
                    id="formProgrammation"
                  >
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Prestataire </span>
                          <el-input
                            :disabled="true"
                            :value="interventionCourant.fournisseur"
                            v-model="interventionCourant.fournisseur"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Main d'oeuvre (FCFA)
                          </span>
                          <el-input
                            :disabled="true"
                            :value="interventionCourant.fournisseur"
                            v-model="interventionCourant.maindoeuvre"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Diagnostique de l'intervention
                          </span>
                          <el-input
                            :disabled="true"
                            :value="interventionCourant.diagnostique"
                            v-model="interventionCourant.diagnostique"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Date et heure de début *</span
                          >
                          <el-date-picker
                            v-if="interventionCourant.etat != 5"
                            v-model="dateD"
                            name="dateD"
                            type="datetime"
                            placeholder="Date et heure de début"
                            style="width:100%"
                            :disabled="interventionCourant.etat == 5"
                          ></el-date-picker>
                          <el-input
                            :value="interventionCourant.dateD"
                            v-model="interventionCourant.dateD"
                            style="width:100%"
                            :disabled="interventionCourant.etat == 5"
                            v-if="interventionCourant.etat == 5"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Date et heure de fin *</span
                          >
                          <el-date-picker
                            v-if="interventionCourant.etat != 5"
                            v-model="dateF"
                            name="dateF"
                            type="datetime"
                            placeholder="Date et heure de fin"
                            style="width:100%"
                            :disabled="interventionCourant.etat == 5"
                          ></el-date-picker>
                          <el-input
                            :value="interventionCourant.dateF"
                            v-model="interventionCourant.dateF"
                            style="width:100%"
                            :disabled="interventionCourant.etat == 5"
                            v-if="interventionCourant.etat == 5"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Kilométrage *</span>
                          <el-input
                            type="number"
                            :min="0.0"
                            placeholder="Kilométrage"
                            name="kilometrage"
                            v-model="kilometrage"
                            style="width:100%"
                            :disabled="interventionCourant.etat == 5"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />
                  </v-form>
                </v-container>

                <v-layout>
                  <v-btn
                    icons
                    color="orange"
                    @click="dialogAjoutIntervention = !dialogAjoutIntervention"
                    dark
                    >Annuler <v-icon right>close</v-icon></v-btn
                  >
                  <v-btn color="primary" @click="submitProgrammation(5)" dark
                    >Ajouter <v-icon right>add</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn icons color="primary" @click="etape -= 1" dark>
                    <v-icon right>keyboard_arrow_left</v-icon>Précédent
                  </v-btn>
                  <v-btn
                    v-if="interventionCourant.etape > 4"
                    icons
                    color="blue"
                    @click="etape += 1"
                    dark
                  >
                    Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn
                  >
                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="5">
                <v-container fluid grid-list-md>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width:100%"
                    >
                      MARQUER LA FIN DE L'INTERVENTION
                    </v-chip>
                  </p>

                  <v-form
                    v-model="valid"
                    ref="formFinIntervention"
                    lazy-validation
                    id="formFinIntervention"
                  >
                    <v-layout row>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Remarque *</span>
                          <el-input
                            :disabled="interventionCourant.etat == 5"
                            :rows="5"
                            type="textarea"
                            name="remarque"
                            v-model="remarqueFin"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration"
                            >Joindre des documents
                          </span>
                          <el-upload
                            :disabled="interventionCourant.etat == 5"
                            class="upload-demo"
                            name="fichier"
                            :action="fichier.url"
                            ref="uploadIntervention"
                            :auto-upload="false"
                            :file-list="fileFin"
                            list-type="picture"
                            multiple
                          >
                            <el-button size="small" type="primary"
                              >CLIQUER ICI <i class="el-icon-picture"></i
                            ></el-button>
                          </el-upload>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />
                  </v-form>
                </v-container>

                <v-layout>
                  <v-btn
                    icons
                    color="orange"
                    @click="dialogAjoutIntervention = false"
                    dark
                    >Annuler <v-icon right>close</v-icon></v-btn
                  >
                  <v-btn
                    v-if="interventionCourant.etat == 3"
                    color="primary"
                    @click="submitFinIntervention(5)"
                    dark
                    >Ajouter <v-icon right>add</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn icons color="primary" @click="etape -= 1" dark>
                    <v-icon right>keyboard_arrow_left</v-icon>Précédent
                  </v-btn>
                  <v-btn
                    v-if="interventionCourant.etat == 5"
                    icons
                    color="blue"
                    @click="etape += 1"
                    dark
                  >
                    Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn
                  >
                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="6">
                <v-card-text>
                  <v-container fluid grid-list-md>
                    <el-row>
                      <v-layout row>
                        <v-flex md6>
                          <el-card class="box-card" style="background:#FFF">
                            <div slot="header" class="carte-header">
                              <v-flex
                                text-xs-center
                                layout
                                align-center
                                justify-center
                                style="font-size: 21px; font-weight: bold; color: #D53A35"
                              >
                                ETAPE DE LA DEMANDE
                              </v-flex>
                            </div>
                            <div class="text item">
                              <v-layout row justify>
                                <v-flex md6>
                                  <p>
                                    <b>Véhicule concerné : </b>
                                    {{ interventionCourant.vehicule }}
                                  </p>
                                  <p>
                                    <b>Catégorie : </b>
                                    {{ interventionCourant.categorie }}
                                  </p>
                                  <p>
                                    <b>Type de demande : </b
                                    >{{ interventionCourant.type }}
                                  </p>
                                  <p>
                                    <b>Demandeur : </b>
                                    {{ interventionCourant.nomDemandeur }}
                                  </p>
                                </v-flex>
                                <v-flex md6>
                                  <p>
                                    <b>Gravité : </b>
                                    {{ interventionCourant.gravite }}
                                  </p>
                                  <p>
                                    <b>Priorité :</b>
                                    {{ interventionCourant.priorite }}
                                  </p>
                                  <p>
                                    <b>Date de la demande :</b>
                                    {{ interventionCourant.date }}
                                  </p>
                                  <p>
                                    <b>Motif de la demande :</b>
                                    {{ interventionCourant.motif }}
                                  </p>
                                </v-flex>
                              </v-layout>
                            </div>
                          </el-card>
                        </v-flex>

                        <v-flex md6>
                          <el-card class="box-card" style="background:#FFF">
                            <div slot="header" class="carte-header">
                              <v-flex
                                text-xs-center
                                layout
                                align-center
                                justify-center
                                style="font-size: 21px; font-weight: bold; color: #D53A35"
                              >
                                ETAPE VALIDATION DE L'INTERVENTION
                              </v-flex>
                            </div>
                            <div class="text item">
                              <v-layout row>
                                <v-flex md6>
                                  <p>
                                    <b>Réponse de la demande : </b>
                                    <v-chip
                                      v-if="interventionCourant.etat != 2"
                                      text-color="white"
                                      label
                                      color="red"
                                    >
                                      VALIDE
                                    </v-chip>
                                    <v-chip
                                      v-if="interventionCourant.etat == 2"
                                      text-color="white"
                                      label
                                      color="red"
                                    >
                                      REFUSE
                                    </v-chip>
                                  </p>
                                </v-flex>
                                <v-flex md6>
                                  <p>
                                    <b>Motif de la réponse :</b>
                                    {{ interventionCourant.remarque }}
                                  </p>
                                </v-flex>
                              </v-layout>
                            </div>
                          </el-card>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex md6>
                          <el-card class="box-card" style="background:#FFF">
                            <div slot="header" class="carte-header">
                              <v-flex
                                text-xs-center
                                layout
                                align-center
                                justify-center
                                style="font-size: 21px; font-weight: bold; color: #D53A35"
                              >
                                ETAPE DU DIAGNOSTIQUE ET DEVIS
                              </v-flex>
                            </div>
                            <div class="text item">
                              <v-layout row>
                                <v-flex md6>
                                  <p>
                                    <b>Prestataire : </b>
                                    {{ interventionCourant.fournisseur }}
                                  </p>
                                  <p>
                                    <b>Main d'oeuvre : </b>
                                    {{ interventionCourant.maindoeuvre }} FCFA
                                  </p>
                                </v-flex>
                                <v-flex md6>
                                  <p>
                                    <b>Diagnostique :</b>
                                    {{ interventionCourant.diagnostique }}
                                  </p>
                                </v-flex>
                              </v-layout>
                              <v-layout row>
                                <v-flex md12>
                                  <el-table
                                    :data="interventionCourant.devis"
                                    style="width:100%"
                                  >
                                    <el-table-column
                                      prop="libelle"
                                      label="Désignation"
                                      width="230"
                                      fixed
                                    ></el-table-column>
                                    <el-table-column
                                      prop="cout"
                                      label="Prix Unitaire"
                                      width="150"
                                    ></el-table-column>
                                    <el-table-column
                                      prop="qte"
                                      label="Quantité"
                                      width="100"
                                    ></el-table-column>
                                    <el-table-column
                                      prop="unite"
                                      label="Unité"
                                      width="100"
                                    ></el-table-column>
                                    <el-table-column
                                      prop="tva"
                                      label="TVA"
                                      width="100"
                                    ></el-table-column>
                                    <el-table-column
                                      prop="total"
                                      label="TOTAL TTC"
                                      width="150"
                                    ></el-table-column>
                                  </el-table>
                                </v-flex>
                              </v-layout>
                            </div>
                          </el-card>
                        </v-flex>

                        <v-flex md6>
                          <el-card class="box-card" style="background:#FFF">
                            <div slot="header" class="carte-header">
                              <v-flex
                                text-xs-center
                                layout
                                align-center
                                justify-center
                                style="font-size: 21px; font-weight: bold; color: #D53A35"
                              >
                                ETAPE PROGRAMMATION DE L'INTERVENTION
                              </v-flex>
                            </div>
                            <div class="text item">
                              <v-layout row justify>
                                <v-flex md6>
                                  <p>
                                    <b>Date et heure de début :</b>
                                    {{ interventionCourant.dateD }}
                                  </p>
                                  <p>
                                    <b>Kilométrage :</b>
                                    {{ interventionCourant.kilometrage }}
                                  </p>
                                </v-flex>
                                <v-flex md6>
                                  <p>
                                    <b>Date et heure de fin : </b>
                                    {{ interventionCourant.dateF }}
                                  </p>
                                </v-flex>
                              </v-layout>
                            </div>
                          </el-card>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex md6>
                          <el-card class="box-card" style="background:#FFF">
                            <div slot="header" class="carte-header">
                              <v-flex
                                text-xs-center
                                layout
                                align-center
                                justify-center
                                style="font-size: 21px; font-weight: bold; color: #D53A35"
                              >
                                ETAPE FIN DE L'INTERVENTION
                              </v-flex>
                            </div>
                            <div class="text item">
                              <v-layout row>
                                <v-flex md6>
                                  <p>
                                    <b>Remarque : </b>
                                    {{ interventionCourant.remarqueFin }}
                                  </p>
                                </v-flex>
                              </v-layout>

                              <v-layout row>
                                <v-flex md6>
                                  <el-upload
                                    class="upload-demo"
                                    action=""
                                    ref="uploadIntervention"
                                    :auto-upload="false"
                                    :file-list="fileFin"
                                    list-type="picture"
                                    multiple
                                  >
                                  </el-upload>
                                </v-flex>
                              </v-layout>
                            </div>
                          </el-card>
                        </v-flex>

                        <v-flex md6>
                          <el-card class="box-card" style="background:#FFF">
                            <div slot="header" class="carte-header">
                              <v-flex
                                text-xs-center
                                layout
                                align-center
                                justify-center
                                style="font-size: 21px; font-weight: bold; color: #D53A35"
                              >
                                SYNTHESE DE L'INTERVENTION
                              </v-flex>
                            </div>
                            <div class="text item">
                              <v-layout row>
                                <v-flex md6>
                                  <p>
                                    <b>Statut de la demande :</b>
                                    <v-chip
                                      v-if="interventionCourant.etat == 0"
                                      label
                                      text-color="white"
                                      color="primary"
                                    >
                                      EN ATTENTE DE VALIDATION
                                    </v-chip>
                                    <v-chip
                                      v-else-if="interventionCourant.etat == 1"
                                      label
                                      text-color="white"
                                      color="primary"
                                    >
                                      EN ATTENTE DE DIAGNOSTIQUE
                                    </v-chip>
                                    <v-chip
                                      v-else-if="interventionCourant.etat == 2"
                                      label
                                      text-color="white"
                                      color="red"
                                    >
                                      INTERVENTION REFUSE
                                    </v-chip>
                                    <v-chip
                                      v-else-if="interventionCourant.etat == 3"
                                      label
                                      text-color="white"
                                      color="green"
                                    >
                                      DEVIS VALIDE
                                    </v-chip>
                                    <v-chip
                                      v-else-if="interventionCourant.etat == 4"
                                      label
                                      text-color="white"
                                      color="red"
                                    >
                                      DIVIS REFUSE
                                    </v-chip>
                                    <v-chip
                                      v-else-if="interventionCourant.etat == 5"
                                      label
                                      text-color="white"
                                      color="green"
                                    >
                                      INTERVENTION TERNIME
                                    </v-chip>
                                  </p>
                                  <p>
                                    <b>Etat de la demande :</b>
                                    <v-chip
                                      v-if="
                                        interventionCourant.etat == 5 &&
                                          interventionCourant.etape == 5
                                      "
                                      outline
                                      text-color="red"
                                      label
                                      color="red"
                                    >
                                      FERMER <v-icon right>clear</v-icon>
                                    </v-chip>
                                    <v-chip
                                      v-else
                                      outline
                                      text-color="green"
                                      label
                                      color="green"
                                    >
                                      OUVERT
                                      <v-icon right>insert_emoticon</v-icon>
                                    </v-chip>
                                  </p>
                                  <p>
                                    <b> COÛT TOTAL :</b>
                                    <v-chip
                                      text-color="white"
                                      label
                                      color="primary"
                                      style="font-size:15px"
                                    >
                                      {{ interventionCourant.total }} FCFA
                                    </v-chip>
                                  </p>
                                </v-flex>
                                <v-flex md6>
                                  <p>
                                    <b>Date d'enrégistrement : </b>
                                    {{ interventionCourant.created }}
                                  </p>
                                  <p>
                                    <b>Date de modification :</b>
                                    {{ interventionCourant.modified }}
                                  </p>
                                </v-flex>
                              </v-layout>
                            </div>
                          </el-card>
                        </v-flex>
                      </v-layout>
                    </el-row>
                  </v-container>
                  <br />
                </v-card-text>

                <v-layout>
                  <v-btn
                    icons
                    color="orange"
                    @click="dialogAjoutIntervention = false"
                    dark
                    >Annuler <v-icon right>close</v-icon></v-btn
                  >

                  <v-spacer></v-spacer>
                  <v-btn icons color="primary" @click="etape -= 1" dark>
                    <v-icon right>keyboard_arrow_left</v-icon>Précédent
                  </v-btn>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click="imprimerDemande(interventionCourant)"
                      dark
                      color="orange"
                    >
                      <v-icon dark>print</v-icon>
                      Imprimer
                    </v-btn>
                    Imprimer
                  </v-tooltip>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DES CONTRATS -->
    <v-dialog
      v-model="dialogAjoutContrat"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit == false">Ajouter un nouveau contrat </span>
            <span v-if="dialogEdit"
              >Modifier le contrat de {{ contratCourant.client }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutContrat = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                text-color="white"
                label
                color="primary"
                style="width: 100%"
              >
                AJOUT D'UN NOUVEAU CONTRAT
              </v-chip>
              <v-chip
                v-if="selectVehicule != '' && listTrarification.length == 0"
                text-color="white"
                label
                color="orange"
                style="width: 100%"
              >
                CET VEHICULE N'A AUCUNE PLAGE TARIFAIRE ENREGISTRER A SON NOM
              </v-chip>
            </p>

            <v-form
              v-model="valid"
              ref="formContrat"
              lazy-validation
              id="formContrat"
            >
              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Client concerné *</span>
                    <el-select
                      filterable
                      clearable
                      v-model="selectClient"
                      placeholder="Client concerné"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <el-option
                        v-for="item in listClient"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Véhicule concerné *</span>
                    <el-select
                      v-on:change="loadTarification()"
                      v-if="dialogEdit == false"
                      filterable
                      clearable
                      v-model="selectVehicule"
                      placeholder="Véhicule concerné"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <el-option
                        v-for="item in listVehiculeDispo"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-on:change="loadTarification()"
                      v-if="dialogEdit && contratCourant.etat == 0"
                      filterable
                      clearable
                      v-model="selectVehicule"
                      placeholder="Véhicule concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listVehiculeDispo"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      v-if="dialogEdit && contratCourant.etat >= 1"
                      v-model="contratCourant.vehicule"
                      :disabled="true"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Tarification *</span>
                    <el-select
                      filterable
                      clearable
                      v-on:change="loadPrixLocation()"
                      v-model="selectTarification"
                      placeholder="Tarification"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <el-option-group
                        v-for="group in listTrarification"
                        :key="group.value"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Montant de la location *</span>
                    <el-input
                      :disabled="true"
                      v-model="montantLocationFormat"
                      placeholder="Montant de la location"
                      :value="montantLocationFormat"
                      style="width:100%; font-size: 22px"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration"
                      >Nombre (Jour, Mois, Année)
                    </span>
                    <el-input
                      type="number"
                      :min="1"
                      @change="calculContrat"
                      v-model="nbr"
                      placeholder="Nombre (Jour, Mois, Année)"
                      name="nbr"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Remise (%) </span>
                    <el-input
                      type="number"
                      :min="0"
                      @change="calculContrat"
                      v-model="remise"
                      placeholder="Remise"
                      name="remise"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Tva (%) </span>
                    <el-input
                      type="number"
                      :min="0"
                      @change="calculContrat"
                      v-model="tvaCont"
                      placeholder="Tva"
                      name="tva"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  TERMES DU CONTRAT
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Avance à la location (%)</span>
                    <el-input
                      type="number"
                      :min="0"
                      name="avance"
                      v-model="avance"
                      placeholder="Avance à la location (%)"
                      :disabled="contratCourant.etat >= 1"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de signature *</span>
                    <el-date-picker
                      v-model="dateS"
                      name="dateS"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de fin *"
                      style="width: 100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Durée du contrat *</span>
                    <el-date-picker
                      v-if="dialogEdit == false || contratCourant.etat == 0"
                      name="duree"
                      range-separator="à"
                      value-format="dd-MM-yyyy"
                      v-model="dateD"
                      type="daterange"
                      start-placeholder="Date de début"
                      end-placeholder="Date de fin"
                      style="width:100%"
                    ></el-date-picker>
                    <el-input
                      v-if="dialogEdit && contratCourant.etat >= 1"
                      v-model="contratCourant.dateIntervalFormat"
                      :value="contratCourant.dateIntervalFormat"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Type de contrat *</span>
                    <el-input
                      name="typeContrat"
                      v-model="typeContrat"
                      placeholder="Type de contrat"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  SUPLEMENT DU CONTRAT
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Activer le contrat *</span>
                    <el-select
                      v-model="selectEtat"
                      placeholder="Activer le contrat *"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <el-option
                        v-for="item in etatContrat"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration"
                      >Penalité en cas de retard (%)</span
                    >
                    <el-input
                      type="number"
                      :min="0"
                      name="penalite"
                      v-model="penalite"
                      placeholder="Penalité en cas de retard"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Kilométrage à la sortie </span>
                    <el-input
                      type="number"
                      :min="0"
                      name="kilometrage"
                      v-model="kilometrage"
                      placeholder="Kilométrage à la sortie"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Attribuer un conducteur *</span>
                    <el-select
                      v-model="attribuer"
                      placeholder="Attribuer un conducteur *"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <el-option label="OUI" :value="true"></el-option>
                      <el-option label="NON" :value="false"></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Caisse *</span>
                    <el-select
                      clearable
                      v-model="selectCaisse"
                      placeholder="Caisse *"
                      style="width:100%"
                      :disabled="contratCourant.etat > 1"
                    >
                      <el-option
                        v-for="item in listCaisse"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de paiement *</span>
                    <el-date-picker
                      v-model="datePaiement"
                      name="datePaiement"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de fin *"
                      style="width: 100%"
                      :disabled="interventionCourant.etat >= 3"
                    ></el-date-picker>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md4 v-if="attribuer == true">
                  <div class="block">
                    <span class="demonstration">Conducteur *</span>
                    <el-select
                      v-if="dialogEdit == false"
                      filterable
                      clearable
                      v-model="selectConducteur"
                      placeholder="Conducteur *"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listConducteurDispo"
                        :key="item.id"
                        :label="item.nomPren"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-if="dialogEdit == true && contratCourant.etat == 0"
                      filterable
                      clearable
                      v-model="selectConducteur"
                      placeholder="Conducteur *"
                      style="width:100%"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <el-option
                        v-for="item in listConducteurDispo"
                        :key="item.id"
                        :label="item.nomPren"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      v-if="dialogEdit == true && contratCourant.etat >= 1"
                      v-model="contratCourant.conducteur"
                      :value="contratCourant.conducteur"
                      style="width:100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER DE PARAMETRES SUPLEMENTAIRES A LA FACTURE
                </v-chip>
              </p>

              <v-layout
                row
                v-for="(option, index) in optionContrat"
                :key="option.key"
              >
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Désignation *</span>
                    <el-input
                      class="inline-input"
                      v-model="option.libelle"
                      placeholder="Désignation"
                      style="width: 100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Prix unitaire *</span>
                    <el-input
                      v-model="option.cout"
                      @change="calculContrat"
                      type="number"
                      min="0"
                      placeholder="Prix unitaire"
                      style="width: 100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Quantité *</span>
                    <el-input
                      v-model="option.qte"
                      @change="calculContrat"
                      type="number"
                      min="1"
                      placeholder="Quantité"
                      style="width: 100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Unité</span>
                    <el-input
                      class="inline-input"
                      :disabled="contratCourant.etat >= 1"
                      v-model="option.unite"
                      :prop="'optionCommande.' + index + '.unite'"
                      required
                      placeholder="Unité"
                      :trigger-on-focus="true"
                      style="width: 100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">TVA</span>
                    <el-input
                      v-model="option.tva"
                      @change="calculContrat"
                      type="number"
                      min="0"
                      max="18"
                      placeholder="TVA"
                      style="width: 100%"
                      :disabled="contratCourant.etat >= 1"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">TOTAL TTC</span>
                    <el-input
                      v-model="option.total"
                      type="number"
                      placeholder="TOTAL TTC"
                      style="width: 100%"
                      :disabled="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md1>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      fab
                      dark
                      small
                      color="red"
                      @click="deleteOptionContrat(index)"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <br />
              <v-layout row>
                <v-flex md6>
                  <v-chip
                    outline
                    text-color="primary"
                    label
                    color="primary"
                    style="font-size:25px; width:100%"
                  >
                    MONTANT HT : {{ ht }} FCFA
                  </v-chip>
                </v-flex>

                <v-spacer></v-spacer>
                <v-flex md2>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click="contratLigne"
                      fab
                      dark
                      small
                      color="blue"
                      :disabled="contratCourant.etat >= 1"
                    >
                      <v-icon icon dark>add</v-icon>
                    </v-btn>
                    Ajouter
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md6>
                  <v-chip
                    outline
                    text-color="primary"
                    label
                    color="primary"
                    style="font-size:25px; width:100%"
                  >
                    MONTANT REMISE : {{ totalRemise }} FCFA
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md6>
                  <v-chip
                    outline
                    text-color="primary"
                    label
                    color="primary"
                    style="font-size:25px; width:100%"
                  >
                    MONTANT TVA : {{ tva }} FCFA
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md6>
                  <v-chip
                    outline
                    text-color="orange"
                    label
                    color="orange"
                    style="font-size:25px; width:100%"
                  >
                    MONTANT TTC : {{ total }} FCFA
                  </v-chip>
                </v-flex>
              </v-layout>
              <br />
            </v-form>

            <v-btn icons color="orange" @click="dialogAjoutContrat = false" dark
              >Annuler <v-icon right>close</v-icon></v-btn
            >
            <v-btn
              v-if="dialogEdit == false"
              color="primary"
              @click="submitContrat()"
              dark
              >Enregistrer <v-icon right>save</v-icon></v-btn
            >
            <v-btn
              v-if="dialogEdit"
              color="primary"
              @click="submitContrat()"
              dark
              >Enregistrer <v-icon right>save</v-icon></v-btn
            >
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE CLIENT -->
    <v-dialog
      persistent
      v-model="dialogAjoutClientLocation"
      :overlay="true"
      max-width="80%"
      scrollable
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajout d'une nouvelle location client</span
            >
            <span v-if="dialogEdit"
              >Modification du client {{ clientLocationCourant.nomPrenom }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutClientLocation = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formClientLocation"
            lazy-validation
            id="formClientLocation"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="green"
                  style="width: 100%"
                >
                  AJOUTER UN NOUVEAU CLIENT
                </v-chip>
                <v-chip
                  v-if="dialogEdit == true"
                  text-color="white"
                  label
                  color="green"
                  style="width: 100%"
                >
                  MODIFICATION DU CLIENT {{ clientLocationCourant.nom }}
                  {{ clientLocationCourant.prenom }}
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md2>
                  <el-upload
                    v-if="dialogEdit != true"
                    class="upload-demo"
                    list-type="picture-card"
                    :limit="1"
                    name="photo"
                    action=""
                    ref="upload"
                    :auto-upload="false"
                    :multiple="false"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>

                  <el-upload
                    v-if="dialogEdit"
                    class="upload-demo"
                    list-type="picture-card"
                    name="photo"
                    action=""
                    ref="upload"
                    :limit="1"
                    :multiple="false"
                    :auto-upload="false"
                  >
                    <img
                      height="142"
                      width="142"
                      v-if="clientLocationCourant.url"
                      :src="clientLocationCourant.url"
                      class="lazy"
                      alt=""
                    />
                    <img
                      height="142"
                      width="142"
                      v-else
                      src="/static/avatar-conducteur.png"
                      class="lazy"
                      alt=""
                    />
                  </el-upload>
                </v-flex>

                <v-flex md10>
                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Type de personne *</span>
                        <el-select
                          v-model="formClientLocation.type"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in listTypeClient"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Nom *</span>
                        <el-input
                          name="nom"
                          placeholder="Nom"
                          v-model="formClientLocation.nom"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Prenom *</span>
                        <el-input
                          name="prenom"
                          placeholder="Prenom"
                          v-model="formClientLocation.prenom"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Profession *</span>
                        <el-input
                          name="profession"
                          placeholder="Profession"
                          v-model="formClientLocation.profession"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration"
                          >Contact * </span
                        >
                        <el-input
                          name="contact"
                          placeholder="Contact"
                          v-model="formClientLocation.contact"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Adresse</span>
                        <el-input
                          name="adresse"
                          placeholder="Adresse"
                          v-model="formClientLocation.adresse"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Email</span>
                        <el-input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Email"
                          v-model="formClientLocation.email"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration"
                          >Fixe </span
                        >
                        <el-input
                          name="fixe"
                          placeholder="Telephone fixe"
                          v-model="formClientLocation.fixe"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration"
                          >Date d'expiration de la piece *</span
                        >
                        <el-date-picker
                          v-model="formClientLocation.DateExpirPiece"
                          name="dateExpirPiece"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date d'expiration de la piece"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Type de la piece *</span>
                        <el-input
                          name="typePiece"
                          placeholder="Type de piece"
                          v-model="formClientLocation.piece"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Numero de la piece *</span>
                        <el-input
                          name="numPiece"
                          placeholder="Numero de piece"
                          v-model="formClientLocation.numPiece"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration"
                          >Date de delivrance de la piece *</span
                        >
                        <el-date-picker
                          v-model="formClientLocation.DateDelivrPiece"
                          name="dateDelivrPiece"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de delivrance de la piece"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Personne signataire *</span>
                        <el-input
                          name="persoSignataire"
                          placeholder="Personne signataire"
                          v-model="formClientLocation.persoSignataire"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>

                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="green"
                      style="width: 100%"
                    >
                      INFORMATIONS SUR LA PERSONNE A CONTACTER EN CAS D'URGENCE
                    </v-chip>
                  </p>

                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Nom *</span>
                        <el-input
                          name="nomPers"
                          placeholder="Nom"
                          v-model="formClientLocation.nomPersoContact"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Prenom *</span>
                        <el-input
                          name="prenPers"
                          placeholder="Prenom"
                          v-model="formClientLocation.prenomPersoContact"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Affinite *</span>
                        <el-select
                          v-model="formClientLocation.affinite"
                          placeholder="Affinite"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in affinite"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration"
                          >Contact * </span
                        >
                        <el-input
                          name="telPers"
                          placeholder="Contact"
                          v-model="formClientLocation.telPersoContact"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <br />

              <v-btn
                color="orange"
                @click.stop="dialogAjoutClientLocation = false"
                dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitClientLocation()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE MARQUE -->
    <v-dialog
      persistent
      v-model="dialogAjoutMarq"
      :overlay="true"
      max-width="50%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajout d'une nouvelle marque</span>
            <span v-if="dialogEdit">Modification d'une nouvelle marque</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutMarq = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formMarque"
            lazy-validation
            id="formMarque"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  Ajouter une nouvelle marque
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                    <img :src="logoMarque" alt="avatar"/></v-avatar
                  ><br />
                  <input
                    name="logo"
                    type="file"
                    style="display:none"
                    ref="fileLogo"
                    accept="image/*"
                    @change="onFileImageLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileLogo.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </v-flex>

                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Libelle</span>
                    <el-input
                      name="libelle"
                      placeholder="Nom de la marque"
                      v-model="formMarque.libelle"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutMarq = false" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitMarq()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE MODELE -->
    <v-dialog persistent v-model="dialogAjoutMod" max-width="50%">
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajout d'un nouveau modèle</span>
            <span v-if="dialogEdit">Modification du modèle </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutMod = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formModele"
            lazy-validation
            id="formModele"
          >
            <v-container fluid grid-list-md>
              <p>
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  Ajouter un nouveau Modèle
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Libelle*</span>
                    <el-input
                      name="libelle"
                      placeholder="Nom du modele"
                      v-model="formModele.libelle"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Marque *</span>
                    <el-autocomplete
                      v-model="selectMarque"
                      :fetch-suggestions="loadListMarq"
                      placeholder="Marque"
                      :trigger-on-focus="true"
                      style="width: 100%"
                    ></el-autocomplete>
                  </div>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutMod = false" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitModele()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE SERIE -->
    <v-dialog persistent v-model="dialogAjoutSerie" max-width="50%">
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajout d'une nouvelle serie</span>
            <span v-if="dialogEdit">Modification de la serie </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutSerie = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formSerie"
            lazy-validation
            id="formSerie"
          >
            <v-container fluid grid-list-md>
              <p>
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  Ajouter une nouvelle serie
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Libelle*</span>
                    <el-input
                      name="libelle"
                      placeholder="Nom de la marque"
                      v-model="formSerie.libelle"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Modèle*</span>
                    <el-select
                      v-model="selectSerie"
                      placeholder="Le Modèle"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listModele"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutSerie = false" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitSerie()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT ASSURANCE -->
    <v-dialog
      persistent
      v-model="dialogAjoutAssu"
      :overlay="true"
      max-width="60%"
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit == false"
              >Ajout d'une nouvelle assurance</span
            >
            <span v-if="dialogEdit == true">Modification d'une assurance </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutAssu = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formAssu" lazy-validation id="formAssu">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  Ajouter une nouvelle assurance
                </v-chip>
                <v-chip
                  v-if="dialogEdit"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DE L'ASSURANCE
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                    <img :src="logoAssur" alt="avatar"/></v-avatar
                  ><br />
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileAssur"
                    accept="image/*"
                    @change="onFileImageAssurLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileAssur.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </v-flex>
                <v-flex md9>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">N° Attestation *</span>
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          name="attestation"
                          id="attestation"
                          placeholder="Attestation"
                          v-model="formAssu.attestation"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">N° Police *</span>
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          name="police"
                          id="police"
                          placeholder="Police"
                          v-model="formAssu.police"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Montant TTC de l'assurance *</span
                        >
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          type="number"
                          min="0"
                          name="montant"
                          id="montant"
                          placeholder="Montant de l'assurance"
                          v-model="formAssu.montant"
                        ></el-input>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date d'achat l'assurance *</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateAssu"
                          name="dateAssurance"
                          id="dateAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de l'assurance"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Compagnie *</span>
                         <el-select   :disabled="assuranceCourant.statut == true" clearable allow-create filterable v-model="selectCompagnLib" placeholder="La Compagnie"    style="width:100%">
                             <el-option v-for="item in listCompagn" :key="item.idPres" :label="item.libelle" :value="item.idPres">
                             </el-option>
                        </el-select>

                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <span class="demonstration">Parc *</span>
                      <el-select
                        name="valeurSelect"
                        id="valeurSelect"
                         clearable
                        v-model="selectParc"
                         :disabled="assuranceCourant.statut == true"
                        v-on:change="loadTypeParc(selectParc)"
                        placeholder="Parc auto"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listParc"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Vehicule *</span>
                        <el-select
                         clearable
                          :disabled="assuranceCourant.statut == true"
                          v-model="selectVehicule"
                          placeholder="Vehicule"
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in listVehicule"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de debut de l'assurance *</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateDebutAssu"
                          name="dateDebutAssurance"
                          id="dateDebutAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de debut"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de fin de l'assurance *</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateFinAssu"
                          name="dateFinAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de fin"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Activé l'assurance *</span>
                        <el-select
                          v-model="formAssu.statut"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in statutAssu"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de renouvellement</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateRenAssu"
                          id="dateRenAssurance"
                          name="dateRenAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de renouvellement"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md12>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          name="description"
                          id="description"
                          type="textarea"
                          :rows="3"
                          v-model="formAssu.description"
                          required
                          style="width: 100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutAssu = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitAssu()" dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE VIdange -->
    <v-dialog
      persistent
      v-model="dialogAjoutVign"
      :overlay="true"
      max-width="60%"
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEditVign == true"
              >Ajout d'une nouvelle vidange</span
            >
            <span v-if="dialogEditVign ==false"
              >Modification de la {{ vidangeCourant.ref }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutVign = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formVidn" lazy-validation id="formVidn">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEditVign == true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER UNE NOUVELLE VIDANGE
                </v-chip>
                <v-chip
                  v-if="dialogEditVign != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DE LA VIDANGE DU VEHICULE  {{ vidangeCourant.vehicule }}
                </v-chip>
              </p>

              <v-layout row>
                 <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                     <img :src="logoVidange" alt="avatar"/>
                  </v-avatar>
                  <br/>
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileVidange"
                    accept="image/*"
                    @change="onFileImageVidangeLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileVidange.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  >
                  <br />
                </v-flex>
                <v-flex md9>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Numero de la vidange *</span
                        >
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          name="numero"
                          placeholder="Numero"
                          v-model="formVidn.numero"
                        ></el-input>
                      </div>
                    </v-flex>
                     <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Numero facture proforma</span
                        >
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          name="numFacture"
                          placeholder="Numero"
                          v-model="formVidn.numFacture"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                   <v-layout row>
                    <v-flex md6>
                      <span class="demonstration">Parc *</span>
                      <el-select
                        name="valeurSelect"
                        id="valeurSelect"
                        v-model="selectParc"
                         clearable
                        :disabled="vidangeCourant.statut == true"
                        v-on:change="loadTypeParc(selectParc)"
                        placeholder="Parc auto"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listParc"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Vehicule *</span>
                        <el-select
                         clearable
                          :disabled="vidangeCourant.statut == true"
                          v-model="selectVehicule"
                          placeholder="Vehicule"
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in listVehicule"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Date de la vidange * </span>
                        <el-date-picker
                          :readonly="vidangeCourant.statut == true"
                          v-model="formVidn.dateDebt"
                          id="dateVidange"
                          name="dateVidange"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de la vidange"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>

                     <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Kilométrage actuel *</span>
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          type="number"
                          min:0
                          name="kiloActu"
                          placeholder="Kilométrage actuel"
                          v-model="formVidn.kiloActu"
                        ></el-input>
                      </div>
                    </v-flex>

                     <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Kilométrage prochain *</span>
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          type="number"
                          min:0
                          name="kiloProch"
                          placeholder="Kilométrage prochain "
                          v-model="formVidn.kiloProch"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                       <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Montant *</span>
                        <el-input
                          :readonly="vidangeCourant.statut == true" min="0"
                          type="number"
                          name="montant"
                          placeholder="Montant"
                          v-model="formVidn.montant"
                        ></el-input>
                      </div>
                    </v-flex>

                      <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de renouvellement
                        </span>

                        <el-date-picker
                          v-model="formVidn.dateRen"
                          :readonly="vidangeCourant.statut == true"
                          id="dateRen"
                          name="dateRen"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de renouvellement"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                       <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Activé la vidange *</span>
                        <el-select
                          v-model="formVidn.statut"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in statutVign"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                      <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          name="description"
                          type="textarea"
                          :rows="3"
                          v-model="formVidn.description"
                          required
                          style="width: 100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutVign = false" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitVign()" dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE VISITE -->
    <v-dialog
      v-model="dialogAjoutVisit"
      max-width="60%"
      :persistent="true"
      :loading="loading"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajout d'une nouvelle visite</span>
            <span v-if="dialogEdit"
              >Modification de la visite du {{ visiteCourant.dateDebut }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutVisit = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formVisite"
            lazy-validation
            id="formVisite"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER UNE NOUVELLE VISITE TECHNIQUE
                </v-chip>
                <v-chip
                  v-if="dialogEdit"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DE LA VISITE TECHNIQUE
                  {{ visiteCourant.dateDebut }}
                </v-chip>
              </p>

              <v-layout row>
                 <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                     <img :src="logoVisite" alt="avatar"/>
                  </v-avatar>
                  <br/>
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileVisite"
                    accept="image/*"
                    @change="onFileImageVisiteLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileVisite.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  >
                  <br />
                </v-flex>

                <v-flex md9>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Numero de la visite *</span>
                        <el-input
                          :readonly="visiteCourant.statut == true ? true :false"
                          name="numero"
                          placeholder="Numero"
                          v-model="formVisite.numero"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                      <v-layout row>
                      <v-flex md6>
                        <span class="demonstration">Parc *</span>
                        <el-select
                          name="valeurSelect"
                          id="valeurSelect"
                           clearable
                          v-model="selectParc"
                          :disabled="visiteCourant.statut == true ? true :false"
                          v-on:change="loadTypeParc(selectParc)"
                          placeholder="Parc auto"
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in listParc"
                            :key="item.id"
                            :label="item.libelle"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </v-flex>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Vehicule *</span>
                          <el-select
                            :disabled="visiteCourant.statut == true ? true :false"
                            v-model="selectVehicule"
                             clearable
                            placeholder="Vehicule"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listVehicule"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                    </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Date de la visite *</span>
                        <el-date-picker
                          :readonly="visiteCourant.statut == true ? true :false"
                          v-model="formVisite.dateDebut"
                          name="dateDebut"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de la visite"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date fin de la visite *</span
                        >
                        <el-date-picker
                          :readonly="visiteCourant.statut  == true ? true :false"
                          v-model="formVisite.dateFin"
                          name="dateFin"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date fin"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Montant TTC*</span>
                        <el-input
                          :min="0"
                          :readonly="visiteCourant.statut  == true ? true :false"
                          type="number"
                          name="montant"
                          placeholder="Montant"
                          v-model="formVisite.montant"
                        ></el-input>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de renouvellement
                        </span>
                        <el-date-picker
                          :readonly="visiteCourant.statut  == true ? true :false"
                          v-model="formVisite.dateRen"
                          name="dateRen"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de renouvellement"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Activé la visite *</span>
                        <el-select
                          v-model="formVisite.statut"
                          placeholder="Activé la visite"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in statutVisit"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          name="description"
                          type="textarea"
                          :rows="3"
                          v-model="formVisite.description"
                          required
                          style="width: 100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <br />

              <v-btn color="orange" @click.stop="dialogAjoutVisit = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitVisit()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

     <!-- MODAL AJOUT VEHICULE A UN CONDUCTEUR -->
    <v-dialog v-model="dialogAjoutVehiConducteur" max-width="60%" :persistent="true" :loading="loading" scrollable>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Attribuer un véhicule au conducteur {{ conducteurCourant.nom }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutVehiConducteur = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="formAttribueCondu" lazy-validation id="formAttribueCondu">
            <v-container fluid grid-list-md>
             <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Parc concerné *</span>
                    <el-select
                      name="valeurSelect"
                      id="valeurSelect"
                      v-model="formAttribueCondu.parc"
                      v-on:change="loadTypeParc(formAttribueCondu.parc)"
                      placeholder="Sélectionnez un parc"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listParc"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Véhicule concerné *</span>
                    <el-select
                      v-model="formAttribueCondu.vehicule"
                      placeholder="Véhicule concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listVehicule"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br />
              <v-btn color="orange" @click.stop="dialogAjoutVehiConducteur = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn>
              <v-btn icons color="primary" @click="submitAttribution()" dark
                >Enrregistrer <v-icon right>save</v-icon></v-btn>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE CONDUCTEUR -->
    <v-dialog
      persistent
      v-model="dialogAjoutCond"
      :overlay="true"
      max-width="80%"
      :loading="loading"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajout d'un nouveau conducteur</span>
            <span v-if="dialogEdit">Modification du conducteur </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutCond = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formConducteur"
            lazy-validation
            id="formConducteur"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER UN NOUVEAU CONDUCTEUR
                </v-chip>
                <v-chip
                  v-if="dialogEdit == true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DU CONDUCTEUR {{ conducteurCourant.nom }} -
                  {{ conducteurCourant.prenom }}
                </v-chip>
              </p>

              <el-row :gutter="20">
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <el-card class="box-card" style="background:#fff">
                      <div>
                        <v-flex md6>
                          <v-avatar
                            :tile="true"
                            size="140px"
                            height="120px"
                            color="grey lighten-4"
                          >
                            <img :src="imageChauf" alt="avatar"/></v-avatar
                          ><br />
                          <input
                            name="photo"
                            type="file"
                            style="display:none"
                            ref="imageChauf"
                            accept="image/*"
                            @change="onFileImageChauffPicked"
                          />
                          <v-btn
                            color="primary"
                            class="white--text"
                            required
                            @click.native="$refs.imageChauf.click()"
                            >Photo
                            <v-icon right dark>cloud_upload</v-icon></v-btn
                          ><br />
                        </v-flex>
                      </div>
                    </el-card>
                  </div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content" style="padding:3px">
                    <el-row>
                      <el-col>
                        <div class="grid-content bg-purple">
                          <el-card class="box-card" style="background:#fff">
                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Matricule</span>
                                  <el-input
                                    name="matricule"
                                    id="matricule"
                                    placeholder="Matricule"
                                    v-model="formConducteur.matricule"
                                  ></el-input>
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Nom *</span>
                                  <el-input
                                    name="nom"
                                    id="nom"
                                    placeholder="Nom"
                                    v-model="formConducteur.nom"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Prenom *</span>
                                  <el-input
                                    name="prenom"
                                    id="prenom"
                                    placeholder="Prenom"
                                    v-model="formConducteur.prenom"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Date de naissance *</span
                                  >
                                  <el-date-picker
                                    v-model="formConducteur.dateNaiss"
                                    name="dateNaiss"
                                    value-format="dd-MM-yyyy"
                                    id="dateNaiss"
                                    type="date"
                                    placeholder="Date de naissance"
                                    style="width: 100%"
                                  ></el-date-picker>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Lieu de naissaance *</span
                                  >
                                  <el-input
                                    name="lieuNaiss"
                                    id="lieuNaiss"
                                    placeholder="Lieu de naissance"
                                    v-model="formConducteur.lieuNaiss"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Telephone 1 *</span
                                  >
                                  <el-input
                                    name="tel1"
                                    id="tel1"
                                    placeholder="Telephone 1"
                                    v-model="formConducteur.phone1"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Telephone 2
                                  </span>
                                  <el-input
                                    name="tel2"
                                    id="tel2"
                                    placeholder="Telephone 2"
                                    v-model="formConducteur.phone2"
                                  ></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Adresse </span>
                                  <el-input
                                    name="adresse"
                                    id="adresseConducteur"
                                    placeholder="Adresse"
                                    v-model="formConducteur.adresse"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Email</span>
                                  <el-input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    v-model="formConducteur.email"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Fonction *</span>
                                  <el-input
                                    name="fonction"
                                    id="fonction"
                                    placeholder="Fonction"
                                    v-model="formConducteur.fonction"
                                  ></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <!-- <v-flex md4>
                                                                <div class="block">
                                                                    <span class="demonstration">Date d'embauche</span>
                                                                    <el-date-picker v-model="formConducteur.dateEmbauch" name="dateEmbauch" value-format="dd-MM-yyyy" id="dateEmbauch" type="date" placeholder="Date d'embauche" style="width: 100%"></el-date-picker>
                                                                </div>
                                                            </v-flex> -->
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Numero du permis *</span
                                  >
                                  <el-input
                                    name="numPermis"
                                    id="numPermis"
                                    placeholder="Numero du permis"
                                    v-model="formConducteur.numPermis"
                                    style="width: 100%"
                                  ></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Type de permis *</span
                                  >
                                  <el-select
                                    v-model="typedePermis"
                                    multiple
                                    id="typedePermis"
                                    :placeholder="this.detailsPermis !='' ? this.detailsPermis:'' "
                                    style="width: 100%"
                                  >
                                    <el-option
                                      v-for="item in listTypePermis"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration"
                                    >Date de validite du permis</span
                                  >
                                  <el-date-picker
                                    v-model="formConducteur.dateValPermis"
                                    id="dateValPermis"
                                    name="dateValPermis"
                                    value-format="dd-MM-yyyy"
                                    type="date"
                                    placeholder="Date de validite du permis"
                                    style="width: 100%"
                                  ></el-date-picker>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <el-select
                                    v-model="formConducteur.disponibilite"
                                    placeholder="Disponibilite"
                                    style="width: 100%"
                                  >
                                    <el-option
                                      v-for="item in listDisponibilite"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>
                            </v-layout>
                          </el-card>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <br />
                </el-col>
              </el-row>

              <v-btn color="orange" @click.stop="dialogAjoutCond = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="primary"
                @click.prevent="submitConducteur()"
                dark
                >Enrregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE CONSOMMATION -->
    <v-dialog
      persistent
      v-model="dialogAjoutCons"
      :loading="loading"
      :overlay="true"
      max-width="60%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Ajouter ou modifier une consommation</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutCons = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            v-model="valid"
            ref="formConsomm"
            lazy-validation
            id="formConsomm"
          >
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Parc concerné *</span>
                    <el-select
                      name="valeurSelect"
                      id="valeurSelect"
                      v-model="selectParc"
                      v-on:change="loadTypeParc(selectParc)"
                      placeholder="Sélectionnez un parc"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listParc"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Véhicule concerné *</span>
                    <el-select
                      v-model="formAjoutCons.vehicule"
                      placeholder="Véhicule concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listVehicule"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Type consommation *</span>
                    <el-select
                      v-model="formAjoutCons.typeCons"
                      placeholder="Type consommation"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4 v-if="formAjoutCons.typeCons == 'Carte'">
                  <div class="block">
                    <span class="demonstration">Liste des cartes</span>
                    <el-select
                      filterable
                      style="width:100%"
                      v-model="formAjoutCons.identifiant"
                      placeholder="Selectionner une carte"
                    >
                      <el-option
                        v-for="item in cartes"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.identifiant"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Station *</span>
                    <el-input
                      name="station"
                      placeholder="Station *"
                      v-model="formAjoutCons.station"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Quantité *</span>
                    <el-input
                      :min="0"
                      type="number"
                      name="quantite"
                      placeholder="Quantité"
                      v-model="formAjoutCons.quantite"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Montant *</span>
                    <el-input
                      :min="0"
                      type="number"
                      name="mntCons"
                      placeholder="Montant"
                      v-model="formAjoutCons.montant"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Kilomètrage *</span>
                    <el-input
                      :min="0"
                      type="number"
                      name="kiloCons"
                      placeholder="Montant"
                      v-model="formAjoutCons.kiloCons"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Distance parcourue </span>
                    <el-input
                      :min="0"
                      type="number"
                      name="distParcourCons"
                      placeholder="Distance parcourue"
                      v-model="formAjoutCons.distParcourCons"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date d'achat *</span>
                    <el-date-picker
                      v-model="formAjoutCons.dateAchat"
                      id="dateAchat"
                      name="dateAchat"
                      value-format="yyyy-MM-d HH:mm"
                      type="datetime"
                      format="d-MM-yyyy HH:mm"
                      placeholder="Date d'achat"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>

                <!--<v-flex md4>-->
                <!--<v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="imageConsom" alt="avatar">-->
                <!--</v-avatar>-->

                <!--<v-layout row>-->
                <!--<input name="fichConsom" type="file" style="display:none" ref="fichConsom" accept="image/*" @change="onFileConsomPicked"/>-->
                <!--<v-btn color="primary" class="white&#45;&#45;text" required @click.native=" $refs.fichConsom.click()">-->
                <!--Recu <v-icon right dark>cloud_upload</v-icon>-->
                <!--</v-btn>-->
                <!--</v-layout>-->
                <!--</v-flex>-->
                <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                    <img :src="imageConsom" alt="avatar"/></v-avatar
                  ><br />
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="imageConsom"
                    accept="image/*"
                    @change="onFileConsomPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.imageConsom.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </v-flex>
              </v-layout>
              <br />

              <v-btn color="orange" @click.stop="dialogAjoutCons = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                icons
                color="primary"
                @click.prevent="submitCarburant()"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDATION DU DEVIS -->
    <v-dialog
      v-model="dialogValiderDevis"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Validation du dévis </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogValiderDevis = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                text-color="white"
                label
                color="green"
                style="font-size:22px; width:100%"
              >
                VALIDATION DU DEVIS
              </v-chip>
            </p>

            <v-form
              v-model="valid"
              ref="formValiderDevis"
              lazy-validation
              id="formValiderDevis"
            >
              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Réponse *</span>
                    <el-select
                      filterable
                      clearable
                      v-model="selectReponseDevis"
                      placeholder="Prestataire"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in reponseDevis"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md8>
                  <div class="block">
                    <span class="demonstration">Remarque </span>
                    <el-input
                      type="textarea"
                      name="remarque"
                      v-model="remarqueValider"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn
                icons
                color="orange"
                @click="dialogValiderDevis = false"
                dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn color="primary" @click="submitValiderDevis(4)" dark
                >Enrregistrer <v-icon right>save</v-icon>
              </v-btn>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL METTRE FIN A UN CONTRAT -->
    <v-dialog
      v-model="dialogCloseContrat"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="red">
          <v-toolbar-title>
            <span
              >Marquer la fin du contrat de location de
              {{ contratCourant.client }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogCloseContrat = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                text-color="white"
                label
                color="red"
                style="font-size:22px; width:100%"
              >
                METTRE FIN AU CONTRAT DE LOCATION
              </v-chip>
            </p>

            <v-form
              v-model="valid"
              ref="formCloseContrat"
              lazy-validation
              id="formCloseContrat"
            >
              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration"
                      >Valider la fin du contrat *</span
                    >
                    <el-select
                      v-model="selectClose"
                      placeholder="Valider la fin du contrat"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in close"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Date de retour *</span>
                    <el-date-picker
                      v-model="dateR"
                      name="dateR"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de retour *"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Kilométrage au retour </span>
                    <el-input
                      type="number"
                      :min="0"
                      name="kilometrage"
                      v-model="kilometrage"
                      placeholder="Kilométrage au retour"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Remarque </span>
                    <el-input
                      type="textarea"
                      name="remarque"
                      v-model="remarque"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn
                icons
                color="orange"
                @click="dialogCloseContrat = false"
                dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn color="primary" @click="submitCloseContrat()" dark
                >Enrregistrer <v-icon right>save</v-icon>
              </v-btn>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW DE CONTRAT -->
    <v-dialog
      persistent
      v-model="dialogShowContrat"
      max-width="75%"
      scrollable
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span>Details du contrat {{ contratCourant.client }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowContrat = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-flex md4>
              <p><b>Réference : </b> {{ contratCourant.ref }}</p>
              <p><b>Client : </b> {{ contratCourant.client }}</p>
              <p><b>Véhicule : </b> {{ contratCourant.vehicule }}</p>
              <p>
                <b>Montant total : </b>
                <v-chip label text-color="white" color="green">
                  {{ contratCourant.montantTotalFormat }} FCFA
                </v-chip>
              </p>
              <p><b>Date de début : </b> {{ contratCourant.dateDFormat }}</p>
            </v-flex>
            <v-flex md4>
              <p><b>Date de fin : </b> {{ contratCourant.dateSFormat }}</p>
              <p><b>Type de contrat : </b> {{ contratCourant.libelle }}</p>
              <p>
                <b>Nombre de (Jour, Mois, Année) : </b> {{ contratCourant.nbr }}
              </p>
              <p><b>Remise : </b> {{ contratCourant.remise }}</p>
              <p>
                <b>Avance à la location : </b> {{ contratCourant.avance }} %
              </p>
            </v-flex>
            <v-flex md4>
              <p>
                <b>Etat du contrat : </b>
                <v-chip
                  v-if="contratCourant.etat == 0"
                  label
                  text-color="white"
                  color="red"
                >
                  RESERVE
                </v-chip>
                <v-chip
                  v-if="contratCourant.etat == 1"
                  label
                  text-color="white"
                  color="green"
                >
                  ACTIF
                </v-chip>
                <v-chip
                  v-if="contratCourant.etat == 2"
                  label
                  text-color="white"
                  color="orange"
                >
                  TERMINE
                </v-chip>
                <v-chip
                  v-if="contratCourant.etat == 3"
                  label
                  text-color="white"
                  color="red"
                >
                  RESILIE
                </v-chip>
              </p>
              <p>
                <b>Kilometrage à la sortie : </b>
                {{ contratCourant.kilomSorti }} Km
              </p>
              <p>
                <b>Conducteur : </b>
                <span v-if="contratCourant.idCond != ''">{{
                  contratCourant.conducteur
                }}</span>
                <span v-else>Aucun conducteur attribué</span>
              </p>
              <p>
                <b>Date d'enrégistrement : </b> {{ contratCourant.created }}
              </p>
              <p><b>Enregistré par: </b> {{ contratCourant.createdUser }}</p>
              <p>
                <b>Date de modification : </b> {{ contratCourant.modified }}
              </p>
            </v-flex>
          </v-layout>
          <br />

          <v-btn color="orange" @click.stop="dialogShowContrat = false" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
          <v-btn icons color="primary" @click="editContrat(contratCourant)" dark
            >Modifier <v-icon right>edit</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW DE CLIENT -->
    <v-dialog
      persistent
      v-model="dialogShowClientLocation"
      scrollable
      max-width="65%"
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span
              >Details de la location client
              {{ clientLocationCourant.nomPrenom }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowClientLocation = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-flex md2>
              <img
                height="142"
                width="142"
                v-if="clientLocationCourant.url"
                :src="clientLocationCourant.url"
                class="lazy"
                alt=""
              />
              <img
                height="142"
                width="142"
                v-else
                src="/static/avatar-conducteur.png"
                class="lazy"
                alt=""
              />
            </v-flex>
            <v-flex md5>
              <p><b>Référence : </b> {{ clientLocationCourant.ref }}</p>
              <p>
                <b>Nom et Prenom : </b> {{ clientLocationCourant.nomPrenom }}
              </p>
              <p>
                <b>Type de personne : </b>
                <v-chip
                  v-if="clientLocationCourant.type == 'Personne physique'"
                  label
                  text-color="white"
                  color="indigo"
                >
                  {{ clientLocationCourant.type }}
                </v-chip>
                <v-chip v-else label text-color="white" color="primary">
                  {{ clientLocationCourant.type }}
                </v-chip>
              </p>
              <p><b>Type de piece : </b> {{ clientLocationCourant.idPiece }}</p>
              <p>
                <b>Numero de la piece : </b>
                {{ clientLocationCourant.numPiece }}
              </p>
              <p><b>Contact : </b> {{ clientLocationCourant.contact }}</p>
              <p><b>Email : </b> {{ clientLocationCourant.email }}</p>
              <p><b>Adresse : </b> {{ clientLocationCourant.adresse }}</p>
            </v-flex>
            <v-flex md5>
              <p><b>Type : </b> {{ clientLocationCourant.type }}</p>
              <p><b>Profession : </b> {{ clientLocationCourant.profession }}</p>
              <p><b>Affinite : </b> {{ clientLocationCourant.affinite }}</p>
              <p><b>Telephone fixe : </b> {{ clientLocationCourant.fixe }}</p>
              <p>
                <b>Personne signataire : </b>
                {{ clientLocationCourant.persoSignataire }}
              </p>
              <p>
                <b>Personne à contacter en cas d'urgence : </b>
                {{ clientLocationCourant.nomPersoContact }} -
                {{ clientLocationCourant.prenomPersoContact }}
              </p>
              <p>
                <b>Affinité avec personne à contacter : </b>
                {{ clientLocationCourant.nomPeraffinitesoContact }}
              </p>
              <p>
                <b>Contact de la personne à contacter : </b>
                {{ clientLocationCourant.telPersoContact }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout row>
            <el-tabs type="border-card" style="width:100%">
              <el-tab-pane label="Vos contrats">
                <data-tables
                  :data="clientLocationCourant.contrat"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="ref"
                    label="Référence"
                    width="100"
                    fixed="left"
                  ></el-table-column>
                  <el-table-column prop="vehicule" label="Véhicule" width="300">
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.vehicule }}
                        <v-icon right>directions_car</v-icon>
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="dateD"
                    label="Date début et Fin"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <v-chip
                        outline
                        label
                        text-color="primary"
                        color="primary"
                      >
                        {{ scope.row.dateD }} - {{ scope.row.dateF }}
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="montantTotal"
                    label="Montant"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="orange">
                        {{ scope.row.montantTotalFormat }} FCFA
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="etat" label="Type" width="160">
                    <template slot-scope="scope">
                      <v-chip
                        v-if="scope.row.etat == 0"
                        label
                        text-color="white"
                        color="orange"
                      >
                        RESERVE
                      </v-chip>
                      <v-chip
                        v-else-if="scope.row.etat == 1"
                        label
                        text-color="white"
                        color="green"
                      >
                        ACTIVE
                      </v-chip>
                      <v-chip
                        v-else-if="scope.row.etat == 2"
                        label
                        text-color="white"
                        color="red"
                      >
                        TERMINE
                      </v-chip>
                      <v-chip
                        v-else-if="scope.row.etat == 3"
                        label
                        text-color="white"
                        color="red"
                      >
                        RESILIE
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column label="Action" fixed="right" width="200">
                    <template slot-scope="scope">
                      <div class="text-xs-center">
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            @click="showContrat(scope.row)"
                            fab
                            dark
                            small
                            color="green"
                          >
                            <v-icon dark>folder_open</v-icon>
                          </v-btn>
                          Détails
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn
                            v-if="scope.row.etat == 0"
                            slot="activator"
                            @click="editContrat(scope.row)"
                            fab
                            dark
                            small
                            color="primary"
                          >
                            <v-icon dark>edit</v-icon>
                          </v-btn>
                          Modifier
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn
                            v-if="scope.row.etat == 1"
                            slot="activator"
                            @click="closeContrat(scope.row)"
                            fab
                            dark
                            small
                            color="red"
                          >
                            <v-icon dark>close</v-icon>
                          </v-btn>
                          Mettre fin au contrat
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn
                            v-if="scope.row.etat != 0"
                            slot="activator"
                            @click="impmerFacture(scope.row)"
                            fab
                            dark
                            small
                            color="orange"
                          >
                            <v-icon dark>print</v-icon>
                          </v-btn>
                          Imprimer
                        </v-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </data-tables>
              </el-tab-pane>
              <el-tab-pane label="Vos factures">
                <data-tables
                  :data="clientLocationCourant.facture"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="ref"
                    label="Référence"
                    width="100"
                    fixed="left"
                  ></el-table-column>
                  <el-table-column
                    prop="refContrat"
                    label="Contrat concerné"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="primary">
                        {{ scope.row.refContrat }}
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="montantTotal"
                    label="Montant"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <v-chip label text-color="white" color="orange">
                        {{ scope.row.montantTotalFormat }} FCFA
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="etatGlobal" label="Etat" width="200">
                    <template slot-scope="scope">
                      <v-chip
                        v-if="scope.row.etatGlobal == 0"
                        label
                        text-color="white"
                        color="red"
                      >
                        IMPAYE
                      </v-chip>
                      <v-chip
                        v-else-if="scope.row.etatGlobal == 1"
                        label
                        text-color="white"
                        color="green"
                      >
                        SOLDE
                      </v-chip>
                      <v-chip
                        v-else-if="scope.row.etatGlobal == 2"
                        label
                        text-color="white"
                        color="primary"
                      >
                        EN ATTENTE DE PAIEMENT
                      </v-chip>
                      <v-chip
                        v-else-if="scope.row.etatGlobal == 3"
                        label
                        text-color="white"
                        color="orange"
                      >
                        EN COURS DE PAIEMENT
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="created"
                    label="Date de création"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <v-chip
                        outline
                        label
                        text-color="primary"
                        color="primary"
                      >
                        {{ scope.row.created }}
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column label="Action" fixed="right" width="100">
                    <template slot-scope="scope">
                      <div class="text-xs-center">
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            @click="impmerFacture(scope.row)"
                            fab
                            dark
                            small
                            color="orange"
                          >
                            <v-icon dark>print</v-icon>
                          </v-btn>
                          Imprimer
                        </v-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </data-tables>
              </el-tab-pane>
            </el-tabs>
          </v-layout>
          <br />

          <v-btn
            color="orange"
            @click.stop="dialogShowClientLocation = false"
            dark
            >Annuler <v-icon right>close</v-icon></v-btn
          >
          <v-btn
            icons
            color="primary"
            @click="editClientLocation(clientLocationCourant)"
            dark
            >Modifier <v-icon right>edit</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW DE VISITE -->
    <v-dialog
      persistent
      v-model="dialogShowVisit" max-width="55%">
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span
              >Details de la visite technique
              {{ visiteCourant.dateDebut }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowVisit = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-flex md2>
              <img
                height="142"
                width="142"
                v-if="visiteCourant.url"
                :src="visiteCourant.url"
                class="lazy"
                alt=""
              />
              <img
                height="142"
                width="142"
                v-else
                src="/static/img-doc.png"
                class="lazy"
                alt=""
              />
            </v-flex>
            <v-flex md5>
              <p><b>Réference : </b> {{ visiteCourant.reference }}</p>
              <p><b>Numero : </b> {{ visiteCourant.numero }}</p>
              <p><b>Véhicule : </b> {{ visiteCourant.VehMat }}</p>
              <p><b>Date de début : </b> {{ visiteCourant.dateDebut }}</p>
              <p><b>Date de fin : </b> {{ visiteCourant.dateFin }}</p>
              <p>
                <b>Date de rénouvellement : </b> {{ visiteCourant.dateRen }}
              </p>
            </v-flex>
            <v-flex md5>
              <p><b>Montant : </b> {{ visiteCourant.montSepar }} Fcfa</p>
              <p>
                <b>Statut : </b>
                <v-chip label text-color="white" color="orange">
                  {{ visiteCourant.statutLabel }}
                </v-chip>
              </p>
              <p><b>Numéro de la visite : </b> {{ visiteCourant.numero }}</p>
              <p>
                <b>Description de la visite : </b>
                {{ visiteCourant.description }}
              </p>
            </v-flex>
          </v-layout>
          <br />

          <v-btn color="orange" @click.stop="dialogShowVisit = false" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
          <v-btn icons color="primary" @click="editVisit(visiteCourant)" dark
            >Modifier <v-icon right>edit</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW ASSURANCE -->
    <v-dialog persistent v-model="dialogShowAssu" max-width="50%">
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Details de l'assurance</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowAssu = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form>
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md6>
                  <p>
                    <b>N° Attestation : </b> {{ assuranceCourant.numAttes }}
                  </p>
                  <p><b>N° Police : </b> {{ assuranceCourant.numPolice }}</p>
                  <p>
                    <b>Montant de l'assurance : </b>
                    {{ assuranceCourant.mntAssur }} FCFA
                  </p>
                  <p>
                    <b>Date de l'assurance : </b>
                    {{ assuranceCourant.dateAssu }}
                  </p>
                  <p><b>Compagnie : </b> {{ assuranceCourant.societe }}</p>
                  <p>
                    <b>Statut : </b>
                    <v-chip label text-color="white" color="orange">
                      {{ assuranceCourant.statutLabel }}
                    </v-chip>
                  </p>
                </v-flex>
                <v-flex md6>
                  <p>
                    <b>Vehicule : </b> {{ assuranceCourant.vehMatricule }}
                    {{ assuranceCourant.vehMarque }}
                  </p>
                  <p><b>Date de debut : </b> {{ assuranceCourant.dateDbt }}</p>
                  <p><b>Date de fin : </b> {{ assuranceCourant.dateFn }}</p>
                  <p>
                    <b>Date de renouvellement : </b>
                    {{ assuranceCourant.dateRenouv }}
                  </p>
                  <p>
                    <b>Description : </b> {{ assuranceCourant.descripAssur }}
                  </p>
                </v-flex>
              </v-layout>
              <br />

              <v-btn color="orange" @click.stop="dialogShowAssu = false" dark
                >Fermer <v-icon right>close</v-icon></v-btn
              >
              <v-btn
                color="primary"
                @click.stop="editAssu(assuranceCourant)"
                dark
                >Modifier <v-icon right>edit</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW DE VIdange -->
    <v-dialog
      persistent
      v-model="dialogShowVign"
      :overlay="true"
      scrollable
      max-width="55%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Details de la vidange du {{ vidangeCourant.date }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowVign = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row justify>
            <v-flex md2>
              <img
                height="142"
                width="142"
                v-if="vidangeCourant.url"
                :src="vidangeCourant.url"
                class="lazy"
                alt=""
              />
              <img
                height="142"
                width="142"
                v-else
                src="/static/img-doc.png"
                class="lazy"
                alt=""
              />
            </v-flex>
            <v-flex md5>
              <p><b>Réference : </b> {{ vidangeCourant.numVid }}</p>
              <p><b>Véhicule : </b> {{ vidangeCourant.vehicule }}</p>
              <p><b>Date de la vidange : </b> {{ vidangeCourant.dateDebt }}</p>
              <!-- <p><b>Date de fin : </b> {{ vidangeCourant.dateFin }}</p> -->
              <p>
                <b>Date de rénouvellement : </b> {{ vidangeCourant.dateRen }}
              </p>
            </v-flex>
            <v-flex md5>
              <p><b>Montant : </b> {{ vidangeCourant.montSepar }} Fcfa</p>
              <p>
                <b>Statut : </b>
                <v-chip label text-color="white" color="orange">
                  {{ vidangeCourant.statutLabel }}
                </v-chip>
              </p>
              <p>
                <b>Numéro de la vidange : </b> {{ vidangeCourant.numero }}
              </p>
              <p>
                <b>Description de la vidange : </b>
                {{ vidangeCourant.description }}
              </p>
            </v-flex>
          </v-layout>
          <br />

          <v-btn color="orange" @click.stop="dialogShowVign = false" dark
            >Annuler <v-icon right>close</v-icon></v-btn
          >
          <v-btn icons color="primary" @click="editVign(vidangeCourant)" dark
            >Modifier <v-icon right>edit</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>



    <!-- MODAL DETAIL MISSION -->
    <v-dialog
      persistent
      v-model="dialogShowCondMission"
      :overlay="true"
      scrollable
      max-width="55%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Details de la mission</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowCondMission = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row justify>
            <v-flex md5>
              <p><b>Itineraire: </b> {{ detailMission.itineraire }}</p>
              <p><b>Demandeur : </b>
                <v-chip label text-color="white" color="primary">
                  {{ detailMission.demandeur }}
                </v-chip>
              </p>
            </v-flex>
            <v-flex md5>
              <p> <b>Description</b>
                 <el-input type="textarea" :row="4"
                  :readonly="true"
                  :value="detailMission.description"
                    style="width: 100%">
                </el-input>
              </p>
            </v-flex>
          </v-layout>
          <br />
          <v-btn color="orange" @click.stop="dialogShowCondMission = false" dark
            >Fermer <v-icon right>close</v-icon></v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- MODAL FICHE DE CONDUCTEUR -->
    <v-dialog
      persistent
      v-model="dialogFicheCond"
      :overlay="true"
      scrollable
      max-width="70%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Fiche conducteur </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogFicheCond = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-container>
            <v-layout row>
              <v-flex md4>
                <v-avatar :tile="true" size="180px" color="grey lighten-4">
                  <img
                    v-if="conducteurCourant.url == null ||conducteurCourant.url == '' "
                    src="/static/avatar-conducteur.png"
                    alt="avatar"
                  />
                  <img v-else :src="conducteurCourant.url" alt="avatar" />
                </v-avatar>
                <br />
                <p align="center">
                    <v-chip
                      v-if="conducteurCourant.disponibilite === 'Disponible'"
                      color="green"
                      text-color="white"
                    >
                      <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                      {{ conducteurCourant.disponibilite }}
                    </v-chip>
                    <v-chip
                      v-if="conducteurCourant.disponibilite === 'En activite'"
                      color="orange"
                      text-color="white"
                    >
                      <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                      {{ conducteurCourant.disponibilite }}
                    </v-chip>
                    <v-chip
                      v-if="conducteurCourant.disponibilite === 'Absent'"
                      color="red"
                      text-color="white"
                    >
                      <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                      {{ conducteurCourant.disponibilite }}
                    </v-chip>
                </p>
              </v-flex>
              <v-flex md4>
                <p><b>Matricule : </b> {{ conducteurCourant.matricule }}</p>
                <p>
                  <b>Nom et prénoms : </b> {{ conducteurCourant.nom }}
                  {{ conducteurCourant.prenom }}
                </p>
                <p>
                  <b>Date de naissance : </b> {{ conducteurCourant.dateNs }}
                </p>
                <p>
                  <b>Lieu de naissance : </b> {{ conducteurCourant.lieuNaiss }}
                </p>
                <p>
                  <b>Contacts : </b> {{ conducteurCourant.phone1 }} /
                  {{ conducteurCourant.phone2 }}
                </p>
                <p><b>Adresse : </b> {{ conducteurCourant.adresse }}</p>
              </v-flex>
              <v-flex md4>
                <p><b>Fonction : </b> {{ conducteurCourant.fonction }}</p>
                <p><b>Date d'embauche : </b> {{ conducteurCourant.dateEmb }}</p>
                <p>
                  <b>Type de permis : </b> {{ conducteurCourant.typePermis }}
                </p>
                <p>
                  <b>Numéro de permis : </b> {{ conducteurCourant.numPermis }}
                </p>
                <p>
                  <b>Date de validite du permis : </b>
                  {{ conducteurCourant.dateVp }}
                </p>
              </v-flex>
            </v-layout>

            <!--tabs menu-->
            <v-layout row>
              <v-flex xs12>
                <v-tabs
                  icons-and-text
                  centered
                  dark
                  color="primary"
                  class="elevation-2"
                  @input="selectTab"
                >
                  <v-tabs-slider color="yellow"></v-tabs-slider>
                  <v-tab href="#tab-1">
                    <v-icon>airline_seat_recline_normal</v-icon>
                    Historique
                  </v-tab>
                  <v-tab href="#tab-2">
                    <v-icon>description</v-icon>
                    En cours
                  </v-tab>
                  <v-tab href="#tab-5">
                    <v-icon right>directions_car</v-icon>
                    Véhicules
                  </v-tab>

                  <v-tab-item id="tab-1">
                    <!-- TABLEAU DE L'HISTORIQUE DES MISSIONS -->
                    <v-card>
                      <div>
                        <v-card-title>
                          <v-chip text-color="white" label color="primary">
                            LISTE DE MISSIONS PASSEES
                            <v-icon right>terrain</v-icon>
                          </v-chip>
                        </v-card-title>

                        <v-card-text>
                          <data-tables
                            :data="listCondMission"
                            style="width: 100%"
                          >
                            <el-table-column
                              prop="ref"
                              label="Référence"
                              width="100"
                            ></el-table-column>
                            <el-table-column
                              prop="vehMat"
                              label="Véhicule"
                              width="300"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  label
                                  text-color="white"
                                  color="primary"
                                >
                                  {{ scope.row.vehMat }}
                                  <v-icon right>directions_car</v-icon>
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="dateMiss"
                              label="Date"
                              width="100"
                            ></el-table-column>
                            <el-table-column
                              prop="dateSortie"
                              label="Date sortie et retour"
                              width="200"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  label
                                  text-color="white"
                                  color="primary"
                                >
                                  {{ scope.row.dateSortie }} -
                                  {{ scope.row.dateEntrePrevue }}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="activite" label="Activité">
                              <template slot-scope="scope">
                                <v-chip label text-color="white" color="orange">
                                  {{ scope.row.activite }}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column label="Action">
                              <template slot-scope="scope">
                                <div class="text-xs-center">
                                  <v-tooltip top>
                                    <v-btn
                                      slot="activator"
                                      @click="showCondMission(scope.row)"
                                      fab
                                      dark
                                      small
                                      color="green"
                                    >
                                      <v-icon dark>folder_open</v-icon>
                                    </v-btn>
                                    Détails
                                  </v-tooltip>
                                </div>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-tab-item>

                  <!-- TABLEAU DES MISSIONS ENCOURS -->
                  <v-tab-item id="tab-2">
                    <v-card>
                      <div>
                        <v-card-title>
                          <v-chip text-color="white" label color="primary">
                            LISTE DE MISSIONS EN COURS
                            <v-icon right>terrain</v-icon>
                          </v-chip>
                        </v-card-title>

                        <v-card-text>
                          <data-tables
                            :data="listCondMissEnCours"
                            style="width: 100%"
                          >
                            <el-table-column
                              prop="ref"
                              label="Référence"
                              width="100"
                            ></el-table-column>
                            <el-table-column
                              prop="vehMat"
                              label="Véhicule"
                              width="300"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  label
                                  text-color="white"
                                  color="primary"
                                >
                                  {{ scope.row.vehMat }}
                                  <v-icon right>directions_car</v-icon>
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="dateMiss"
                              label="Date"
                              width="100"
                            ></el-table-column>
                            <el-table-column
                              prop="dateSortie"
                              label="Date sortie et retour"
                              width="200"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  label
                                  text-color="white"
                                  color="primary"
                                >
                                  {{ scope.row.dateSortie }} -
                                  {{ scope.row.dateEntrePrevue }}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="activite" label="Activité">
                              <template slot-scope="scope">
                                <v-chip label text-color="white" color="orange">
                                  {{ scope.row.activite }}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column label="Action">
                              <template slot-scope="scope">
                                <div class="text-xs-center">
                                  <v-tooltip top>
                                    <v-btn
                                      slot="activator"
                                      @click="showCondMission(scope.row)"
                                      fab
                                      dark
                                      small
                                      color="green"
                                    >
                                      <v-icon dark>folder_open</v-icon>
                                    </v-btn>
                                    Détails
                                  </v-tooltip>
                                </div>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-tab-item>

                   <!-- TABLEAU DES VEHICULE AFFECTER AU CONDUCTEUR -->
                  <v-tab-item id="tab-5">
                    <v-card>
                      <div>
                        <v-card-title>
                          <v-chip text-color="white" label color="primary">
                            LISTE DES VEHICULES AFFECTES
                            <v-icon right>terrain</v-icon>
                          </v-chip>
                        </v-card-title>
                        <v-flex xs12 class="text-xs-right">
                          <v-tooltip top>
                              <v-btn
                                slot="activator"
                                icons
                                color="primary"
                                @click.stop="newAttrCondu"
                                dark
                                >Ajouter <v-icon right>add</v-icon></v-btn
                              >
                              Affecter un vehicule a ce conducteur
                            </v-tooltip>
                        </v-flex>
                        <v-card-text>
                          <data-tables
                            :data="listVehiculeAffecte"
                            style="width: 100%"
                          >
                            <el-table-column
                              prop="parc"
                              label="Parc"
                              width="100"
                            ></el-table-column>
                            <el-table-column
                              prop="matricule"
                              label="Immatriculation/Marque"
                              width="300"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  label
                                  text-color="white"
                                  color="primary"
                                >
                                 {{ scope.row.matricule }} / {{scope.row.marque}}
                                </v-chip>
                              </template>
                            </el-table-column>
                             <el-table-column prop="marque" label="Modèle / Série">
                                <template slot-scope="scope">
                                  <v-chip outline label text-color="primary" color="primary">
                                    {{scope.row.modele}} / {{scope.row.serie}}
                                  </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column label="Action">
                              <template slot-scope="scope">
                                <div class="text-xs-center">
                                  <v-tooltip top>
                                    <v-btn
                                      slot="activator"
                                      @click="deleteVehiCondu(scope.row)"
                                      fab
                                      dark
                                      small
                                      color="red"
                                    >
                                      <v-icon dark>delete</v-icon>
                                    </v-btn>
                                    Supprimer
                                  </v-tooltip>
                                </div>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
            </v-layout>
            <br />
            <v-btn color="orange" @click.stop="dialogFicheCond = false" dark
              >Fermer <v-icon right>close</v-icon></v-btn>
          </v-container>
        </v-card>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSupr"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette intervention ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteIntervention" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION MARQUE -->
    <v-dialog
      v-model="dialogSuprMarq"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer cette marque ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprMarq = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteMarq" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION MODELE -->
    <v-dialog
      v-model="dialogSuprModel"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer ce modele ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprModel = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteModel" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION SERIE -->
    <v-dialog
      v-model="dialogSuprSeri"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer cette serie ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprSeri = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteSeri" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION CONDUCTEUR -->
    <v-dialog
      v-model="dialogSuprCond"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer ce conducteur ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprCond = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteConducteur" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION DE LOCATIONS DE CLIENT (CLIENTLOCATION) -->
    <v-dialog
      v-model="dialogSuprClientLocation"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette location client ?
          </h6>
          <p align="center">
            <v-btn
              @click.native="dialogSuprClientLocation = false"
              color="orange"
              dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteClientLocation" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION ASSURANCE -->
    <v-dialog
      v-model="dialogSuprAssu"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette assurance ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprAssu = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteAssu" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION ASSURANCE -->
    <v-dialog
      v-model="dialogSuprVign"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette vidange ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprVign = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteVign" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION VISITE -->
    <v-dialog
      v-model="dialogSuprVisit"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette visite technique ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprVisit = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteVisit" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION CARBURANT-->
    <v-dialog
      v-model="dialogSuppCarburant"
      width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="text-xs-center">
          <h3 class="headline mb-0">Supprimer une consommation</h3>

          <v-flex xs12>
            <v-alert
              outline
              color="orange darken-1"
              icon="warning"
              :value="true"
            >
              La suppression d'une consommation est irréversible.
            </v-alert>
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogSuppCarburant = false">Annuler</v-btn>
          <v-btn icons color="red" @click.stop="deleteCarburant()" dark
            >Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL TARIFS LOCATIONS -->
    <ModalTarifLocation
      :show="showModalTarif"
      @close="showModalTarif = false"
    ></ModalTarifLocation>
    <!-- FIN MODAL TARIFS LOCATIONS -->

    <!-- MODAL CALENDRIER CONTRATS -->
    <ModalCalendContrat
      :show="showModalCalendContrat"
      @close="showModalCalendContrat = false"
    ></ModalCalendContrat>
    <!-- MODAL CALENDRIER CONTRATS -->

    <!-- Intervention index -->
    <InterventionIndex
      :show="showModalInterv"
      @close="showModalInterv = false"
    ></InterventionIndex>
    <!-- Intervention index -->

    <!-- Carte carburants index -->
    <CarteCarburantIndex
      :show="showDialogCarcurant"
      @close="showDialogCarcurant = false"
    ></CarteCarburantIndex>
    <!-- Carte carburants  index -->

    <!-- Carte carburants index -->
    <BesoinTravaux
      :show="showModalBesoin"
      @close="showModalBesoin = false"
    ></BesoinTravaux>
    <!-- Carte carburants  index -->

    <loadConducteurExcel
      @close="
        showModalLoadConducteur = false;
        loadConducteur();
      "
      :show="showModalLoadConducteur"
      :listeConducteur="lstConducteur"
    ></loadConducteurExcel>

     <!-- Detail de la demande de fonds -->
      <ModalValidationDmdFond :valider=false :demandeDetail = demandeDetailFond :logistique = true :show = showModalDetailDmdFond @close="showDialogDmdFondAfter" ></ModalValidationDmdFond>
      <!-- Detail de la demande de maintenance -->
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/pie");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

//Importation des modals
import ModalTarifLocation from "@/components/location/TarifLocation";
import InterventionIndex from "@/components/intervention/Intervention_index";
import ModalCalendContrat from "@/components/calendrier/ModalCalendContrat";
import CarteCarburantIndex from "@/components/carteCarburant/CarteCarburant_index";
import BesoinTravaux from "@/components/besoin/besoinTravaux.vue";
import LoadConducteurExcel from "@/components/parc/loadConducteur.vue";
import Loading from "@/components/Loading";
import ModalValidationDmdFond from '@/components/validationDG/ModalValidationDmdFond'

export default {
  components: {
    LoadConducteurExcel,
    ModalTarifLocation,
    Loading,
    ModalCalendContrat,
    InterventionIndex,
    CarteCarburantIndex,
    BesoinTravaux,
    ModalValidationDmdFond
  },

  name: "app",
  data() {
    return {
      loading: false,
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        { path: "/parc/auto", text: "Parc auto", disabled: true }
      ],
      valid: true,
      dialogEdit: false,
      dialogIntervention: false,
      dialogAjoutIntervention: false,
      dialogConsommationCarburant: false,
      dialogValiderDevis: false,
      dialogAjoutVisit: false,
      dialogAjoutVehiConducteur: false,
      dialogSuprVisit: false,
      dialogVisite: false,
      dialogShowVign: false,
      dialogVidange: false,
      dialogAssurance: false,
      dialogConducteur: false,
      dialogContrat: false,
      dialogAjoutContrat: false,
      dialogShowContrat: false,
      dialogAjoutMarq: false,
      logoAssur: "/static/img-doc.png",

      dialogAjoutMod: false,
      dialogAjoutSerie: false,
      dialogClientLocation: false,
      showModalMission: false,
      showModalTarif: false,
      dialogShowClientLocation: false,
      dialogAjoutClientLocation: false,
      dialogSuprClientLocation: false,
      dialogCloseContrat: false,
      dialogParaMarque: false,
      showModalCalendContrat: false,
      showCompagnLib: "",
      InterId: "",
      dialogSupr: false,
      etape: 0,
      listIntervention: [],
      listDemandeur: [],
      kilometrage: 0,
      periode: "",
      selectPriorite: "",
      priorite: [
        { value: "Moins urgent", label: "Moins urgent" },
        { value: "Urgent", label: "Urgent" },
        { value: "Très urgent", label: "Très urgent" }
      ],
      selectType: "",
      type: [
        { value: "Curative", label: "Curative" },
        { value: "Préventive", label: "Préventive" }
      ],
      selectGravite: "",
      gravite: [
        { value: "Moins grave", label: "Moins grave" },
        { value: "Grave", label: "Grave" },
        { value: "Très grave", label: "Très grave" }
      ],
      selectCategorie: "",
      categorie: [
        { value: "Carrosserie", label: "Carrosserie" },
        { value: "Lavage", label: "Lavage" },
        { value: "Parallélisme", label: "Parallélisme" },
        { value: "Pneumatique", label: "Pneumatique" },
        { value: "Réparation", label: "Réparation" },
        { value: "Vidange", label: "Vidange" },
        { value: "Autre", label: "Autre" }
      ],
      motif: "",
      dateInter: "",
      selectVehicule: "",
      selectVehiculeId:"",
      listVehicule: [],
      interventionCourant: [],
      selectReponse: "",
      reponse: [{ value: 1, label: "Valider" }, { value: 2, label: "Refuser" }],
      selectReponseDevis: "",
      reponseDevis: [
        { value: 1, label: "Valider" },
        { value: 2, label: "Refuser" }
      ],
      remarque: "",
      remarqueValider: "",
      devis: [
        {
          key: Date.now(),
          libelle: "",
          cout: 0,
          qte: 1,
          tva: 0,
          total: 0,
          id: ""
        }
      ],
      devis: [],
      ht: 0,
      totalRemise: 0,
      tva: 0,
      total: 0,
      totalF: 0,
      totalTtc: 0,
      listProduit: [],
      totComLigneTTC: 0,
      maindoeuvre: 0,
      diagnostique: "",
      selectPrestataire: "",
      listPrestataire: [],
      dialogAjoutCons: false,
      listConsommation: [],
      listOldConsommation: [],
      mntTotCons: 0,
      quantTotCons: 0,
      distParcTot: 0,
      menuDateAchat: "",
      listType: [
        { value: "Espèce", label: "Espèce" },
        { value: "Carte", label: "Carte" }
      ],
      idConsommation: "",
      formAjoutCons: {
        station: "",
        dateAchat: "",
        distParcourCons: "",
        vehicule: "",
        typeCons: "",
        montant: "",
        quantite: "",
        kiloCons: ""
      },
      dialogSuppCarburant: false,
      dateD: "",
      dateF: "",
      dialogShowVisit: false,
      showCompagnLib: "",
      showVehLib: "",
      visiteCourant: [],
      idVisit: "",
      formAttribueCondu:{
        parc:'',
        vehicule:''
      },
      formVisite: {
        libelle: "",
        numero: "",
        dateDebut: null,
        dateFin: null,
        dateRen: null,
        montant: "",
        description: "",
        vehMat: ""
      },
      fileLogo: [{ name: "", url: "" }],
      listVisite: [],
      dialogAjoutVign: false,
      dialogEditVign: false,
      dialogSuprVign: false,
      vidangeCourant: [],
      tableStatVeh: [],
      tableStatCond: [],
      tableStatInterv: [],
      tableStatContrat: [],
      idVign: "",
      listParc: "",
      listVidn: [],
      listCompagn: [],
      formVidn: {
        numero: "",
        date: null,
        dateDebt: null,
        dateRen: null,
        montant: "",
        document: "",
        vehMat: "",
        statut: ""
      },
      compagnCourant: [],
      idCompagn: "",
      nbVeh: "",
      nbMarqu: "",
      nbCond: "",
      nbDemand: "",
      nbBesoins: "",
      nbContrat: "",

      nbCarburan: "",

      nbCarteCar: "",
      nbVisiteTech: "",
      nbVidang: "",
      nbAssur: "",
      nbTarif: "",
      nbClient: "",

      listAssu: [],
      typeParc: [],
      selectParc: "",
      selectCompagnLib: "",
      formAssu: {
        attestation: "",
        police: "",
        montant: "",
        description: "",
        dateAssu: null,
        dateDebutAssu: null,
        dateFinAssu: null,
        dateRenAssu: null
      },
      dialogShowAssu: false,
      dialogAjoutAssu: false,
      dialogSuprAssu: false,
      assuranceCourant: [],
      idAssu: "",
      etatAssurance: true,
      etatCompagnie: false,
      etatSerie: false,
      dialogShowCondMission: false,
      dialogFicheCond: false,
      dialogAjoutCond: false,
      dialogSuprCond: false,
      dialogSuprMarq: false,
      dialogSuprModel: false,
      dialogSuprSeri: false,
      conducteurCourant: [],
      condMissionCourant: [],
      dispoCond: "",
      idConducteur: "",
      listConducteur: [],
      listCondMission: [],
      listCondMissEnCours: [],
      listVehiculeAffecte: [],
      detailMission: [],
      idCondCours: "",
      listTypePermis: [
        {
          value: "A",
          label: "A"
        },
        {
          value: "B",
          label: "B"
        },
        {
          value: "C",
          label: "C"
        },
        {
          value: "D",
          label: "D"
        },
        {
          value: "E",
          label: "E"
        },
        {
          value: "F",
          label: "F"
        }
      ],
      listDisponibilite: [
        { value: 0, label: "Disponible" },
        { value: 1, label: "Activite" },
        { value: 2, label: "Absent" }
      ],
      listMarque: [],
      formConducteur: {
        nom: "",
        prenom: "",
        lieuNaiss: "",
        matricule: "",
        fonction: "",
        dateNaiss: "",
        dateEmbauch: "",
        typePermis: "",
        numPermis: "",
        dateValPermis: "",
        phone1: "",
        phone2: "",
        adresse: "",
        email: "",
        disponibilite: ""
        // imageUrl: ''
      },
      remarqueFin: "",
      fichier: { url: "" },
      fileFin: [{ name: "", url: "" }],
      statutVign: [
        {
          value: 1,
          label: "Activé"
        },
        {
          value: 0,
          label: "Desactivé"
        }
      ],
      statutVisit: [
        { value: 1, label: "Activé" },
        { value: 0, label: "Desactivé" }
      ],
      listContrat: [],
      contratCourant: [],
      listClient: [],
      selectClient: "",
      montantLocation: 0,
      montantLocationFormat: 0,
      dateS: "",
      avance: "",
      penalite: 0,
      selectEtat: 2,
      etatContrat: [
        { value: 1, label: "Activé le contrat immédiatement" },
        { value: 0, label: "Réserver le véhicule" }
      ],
      selectConducteur: "",
      attribuer: false,
      listConducteurDispo: [],
      listCaisse: [],
      selectCaisse: "",
      typeContrat: "Contrat de location",
      optionContrat: [
        {
          key: Date.now(),
          libelle: "",
          cout: 0,
          qte: 1,
          tva: 0,
          total: 0,
          id: ""
        }
      ],
      listTrarification: [],
      selectTarification: "",
      remise: 0,
      tvaCont: 0,
      nbr: 1,
      listVehiculeDispo: [],
      detailCout: {},
      listClientLocation: [],
      formClientLocation: {
        nom: "",
        prenom: "",
        piece: "",
        numPiece: "",
        type: "",
        contact: "",
        adresse: "",
        type: "",
        profession: "",
        affinite: "",
        fixe: "",
        email: "",
        nomPersoContact: "",
        prenomPersoContact: "",
        telPersoContact: "",
        persoSignataire: "",
        DateDelivrPiece: "",
        DateExpirPiece: ""
      },
      clientLocationCourant: [],
      idClientLoc: "",
      datePaiement: "",
      statsMarque: [],
      statsMarqueData: [],
      selectClose: "",
      close: [{ value: 2, label: "Terminé" }, { value: 3, label: "Résilier" }],
      dateR: "",
      autre: "",
      nbrContratExpireDay: 0,
      consommationCourant: [],
      statutAssu: [
        { value: 1, label: "Activé" },
        { value: 0, label: "Desactivé" }
      ],
      listTypeClient: [
        { value: "Personne physique", label: "Personne physique" },
        { value: "Personne morale", label: "Personne morale" }
      ],
      typedePermis: [],
      detailsPermis:'',
      affinite: [
        { value: "Parents", label: "Parents" },
        { value: "Partenaire", label: "Partenaire" },
        { value: "Amie", label: "Ami(e)" },
        { value: "Collègue", label: "Collègue" },
        { value: "Autre", label: "Autre" }
      ],
      listSerie: [],
      listModele: [],
      formMarque: {
        libelle: ""
      },
      formModele: {
        libelle: ""
      },
      formSerie: {
        libelle: ""
      },
      logo: "",
      selectMarque: "",
      selectSerie: "",
      marqueCourant: [],
      modeleCourant: [],
      serieCourant: [],
      logoMarque: "/static/img-doc.png",
      logoVignet: "/static/img-doc.png",
      logoVidange: "/static/img-doc.png",
      logoVisite: "/static/img-doc.png",
      imageDevis: "/static/img-doc.png",
      imageChauf: "/static/img-doc.png",
      fileDevis: "",
      fileConsom: "",
      imageConsom: "/static/img-doc.png",
      statConsom: [],
      statQutConsom: [],
      totCarb: 0,
      totMntCarb: 0,
      disabledBtnMod: false,
      disabledBtnSerie: false,
      disabledBtnMarq: false,
      disabledBtnCond: false,
      disabledBtnCarbu: false,
      disabledBtnCont: false,
      disabledBtnCli: false,
      disabledBtnVisT: false,
      disabledBtnAllVidn: false,
      disabledBtnAssur: false,
      disabledBtnDmd: false,

      //modal intervention
      showModalInterv: false,

      //modal carte
      showDialogCarcurant: false,
      listeCarte: [],

      //BESOIN TRAVAUX
      nbBesoin: 0,
      showModalBesoin: false,
      showModalLoadConducteur: false,

      //Importer fichier excel
      fileExcel: [],
      lstConducteur: [],

      nbDemandCarbu:'',
      showModalDetailDmdFond: false,
      dialogShowListDfon: false,
      demandeDetailFond: {},
      listeDemandes:[],
      dialogConfirmRefus:false,
      dialogConfirm: false,
      demandeDetail:'',
      mntTotal:0,
      totalDmd:0,
      formRefus:{},
          ruleFormRefus: {
            rapportRefus: [
                { required: true, message: 'Veuillez saisir' },
            ],
        }
    };
  },
  methods: {
    handleFileExcel(
      command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0": //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1": //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel() {
      let url = this.domaine + "conducteur/generer/modele";
      window.open(url);
    },
    onFileExcelPicked() {
      this.fileExcel.splice(0, 1);
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      let url = this.domaine + "parc/load_conducteur/excel";
      let data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);

      this.$http.post(url, data).then(
        resp => {
          this.loading = false;

          this.$notify({
            title: "Chargement liste conducteur",
            message: "Chargement effectué",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.lstConducteur = resp.body.lstConducteur;
          this.showModalLoadConducteur = true;
        },
        resp => {
          this.loading = false;
          this.$message.error("Erreur lors de l'importation du fichier");
        }
      );
    },
    //MODAL BESOIN
    modalBesoin() {
      this.showModalBesoin = true;
      this.loadBesoinVehAvalider()
    },
    //enregistrement des images
    onFileImageLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoMarque = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoMarque = files[0];
    },
    loadCarte() {
      let url = this.domaine + "carteCarburant/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.cartes = response.body.cartes;
        }
      });
    },
    modalInterv() {
      this.showModalInterv = true;
    },
    handleChangePrix(item) {
      //this.loading = true
    },
    loadPage() {
      this.loading = true;
    },
    loadCout() {
      let url = this.domaine + "parc/dashboard/cout";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.detailCout = response.body.detailCout;
        }
      });
    },
    loadClientLocation() {
      this.loading = true;
      let url = this.domaine + "client/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listClientLocation = response.body.clients;
          this.nbClient = response.body.nbClient;

          if (
            this.listClientLocation === undefined ||
            this.listClientLocation.length == 0
          ) {
            this.disabledBtnCli = true;
          } else {
            this.disabledBtnCli = false;
          }
          this.loading = false;
        }
      });
    },
    loadCaisse() {
      let url = this.domaine + "caisse/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCaisse = response.body.caisse;
        }
      });
    },
    loadConducteur() {
      this.loading = true;
      let url = this.domaine + "conducteur/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listConducteur = response.body.conducteur;
          if (
            this.listConducteur === undefined ||
            this.listConducteur.length == 0
          ) {
            this.disabledBtnCond = true;
          } else {
            this.disabledBtnCond = false;
          }
          this.nbCond = response.body.nbCond;
          this.tableStatCond = response.body.statCond;
          this.loading = false;
        }
      });
    },
    loadListConducteur(item) {
      let url = this.domaine + "conducteur/search/" + item;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listConducteur = response.body.conducteur;
          this.dialogConducteur = true;
        }
      });
    },
    loadListIntervention(item) {
      let url = this.domaine + "intervention/search/" + item;
      // let url = this.domaine + 'intervention/search/'+item
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listIntervention = response.body.intervention;
          this.dialogIntervention = true;
        }
      });
    },
    loadListContrat(item) {
      let url = this.domaine + "contrat/search/" + item;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listContrat = response.body.contrat;
          this.dialogContrat = true;
        }
      });
    },
    loadConducteurDispo() {
      let url = this.domaine + "contrat/index/conducteur/dispo";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listConducteurDispo = response.body.conducteur;
        }
      });
    },
    loadForfait() {
      let url = this.domaine + "tarification/forfait";
      this.$http.get(url).then(response => {
        this.nbTarif = response.body.nbTarif;
      });
    },
    loadClient() {
      let url = this.domaine + "contrat/index/client/location";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listClient = response.body.client;
        }
      });
    },
    loadBesoinVehAvalider() {
      // this.loading = true
      let url = this.domaine + "besoin/vehicule";
      this.$http.get(url).then(response => {
        this.nbBesoins = response.body.besoins.length;
        // this.loading = false;
      });
    },
    loadTarification() {
      this.loading = true;
      this.selectTarification = "";
      this.listTrarification = [];
      this.montantLocation = 0;
      this.montantLocationFormat = 0;
      if (this.selectVehicule != "") {
        let url = this.domaine + "contrat/tarification/index/" + this.selectVehicule;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTrarification = response.body.tarif;
            this.loading = false;
            this.calculContrat();
          }
        });
      } else {
        this.loading = false;
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner le véhicule concerné.",
          type: "warning"
        });
      }
    },
    loadPrixLocation() {
      this.loading = true;
      this.montantLocation = 0;
      this.montantLocationFormat = 0;
      if (this.selectTarification != "") {
        let url =
          this.domaine + "contrat/prix/location/" + this.selectTarification;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.montantLocation = response.body.montant;
            this.montantLocationFormat = response.body.montantFormat;
            this.calculContrat();
            this.loading = false;
          }
        });
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner le tarif concerné.",
          type: "warning"
        });
        this.calculContrat();
        this.loading = false;
      }
    },
    loadCondMission(ligne) {
      let url = this.domaine + "conducteur/load/mission/" + ligne.idCond;
      this.idCondCours = ligne.idCond;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCondMission = response.body.missionsCond;
        }
      });
    },
    loadAssu() {
      let url = this.domaine + "parc/index/assurance";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listAssu = response.body.assurance;
          this.nbAssur = response.body.nbAssur;
          if (this.nbAssur == 0) {
            this.disabledBtnAssur = false;
          } else {
            this.disabledBtnAssur = true;
          }
          // this.loading = false;

          let notife = this.$vs;
          let thise = this;


          if (this.notif === "active" && response.body.compteur > 0 && this.droitAcces.intervention) {
            this.$vs.notify({
              title: "ASSURANCE",
              text:
                "Vous avez " +
                response.body.compteur +
                " assurance(s) qui expirent dans moins d'une semaine",
              type: "warning",
              position: "top-right",
              icon: "description",
              time: 10000
            });
          }

          let detail = this.notif
          this.listAssu.forEach(function(item) {
            if ( item.expire == true && detail === "active" && this.droitAcces.intervention) {
              notife.notify({
                title: "ASSURANCE EXPIRE",
                text:
                  "L'assurance' du véhicule " +
                  item.VehMat +
                  " a expirée depuis le " +
                  item.dateFnReel,
                color: "danger",
                position: "top-right",
                icon: "description",
                //time:10000,
                fixed: true,
                click: () => {
                  thise.showAssu(item);
                }
              });
            }
          });

        }
      });
    },
    loadDemandeCarburan(){
      this.loading = true;
      let url = this.domaine + "demandeFond/index/type/carburant";
      this.$http.get(url ).then(response => {
        this.loading = false;
        this.listeDemandes = response.body.listeDemandes
        this.nbDemandCarbu = this.listeDemandes.length
        if(this.nbDemandCarbu >0){
            this.$notify({
            title: "DEMANDES DE FONDS EN CARBURANT",
            message: "VOUS AVEZ DES DEMANDES DE FONDS EN CARBURANT EN ATTENTE DE VALIDATION",
            type: "warning",
            position: "top-right",
            duration: 5000
          });
        }
        this.mntTotal = response.body.montantTotal
        this.totalDmd = this.listeDemandes.length
        // //       let totalDmdCour = this.listeDemandes.filter( function(element) {
        // //       return  element.statut == 1;
        // // } )
        // this.totalDmdCour = totalDmdCour.length
      },
      error => {
          this.loading = false;
            this.$message.error("Une erreur est survenue lors du chargement des demandes de fonds")
      })
    },
    loadCompagnie() {
      let url = this.domaine + "fournisseur/indexFournisseur";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCompagn = response.body.prestataire;
        }
      });
    },
    loadDevis() {
      let url = this.domaine + "product/load-product-stock";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProduit = response.body;
        }
      });
    },
    loadPrestaire() {
      let url = this.domaine + "fournisseur/indexPrestataire";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listPrestataire = response.body.prestataire;
        }
      });
    },
    loadVisite() {
      this.loading = true;
      let url = this.domaine + "visite/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listVisite = response.body.visite;
          this.nbVisiteTech = response.body.nbVisiteTech;
          if (this.listVisite === undefined || this.listVisite.length == 0) {
            this.disabledBtnVisT = true;
          } else {
            this.disabledBtnVisT = false;
          }
          this.loading = false;
          let notif = this.$vs;
          let thise = this;

          if (this.notif === "active" && response.body.compteur > 0 && this.droitAcces.intervention) {
            this.$vs.notify({
              title: "VISITE TECHNIQUE",
              text:
                "Vous avez " +
                response.body.compteur +
                " visite(s) technique(s) qui expirent dans moins d'une semaine",
              type: "warning",
              position: "top-right",
              icon: "description",
              time: 5000
            });
          }

          this.listVisite.forEach(function(item) {
            if (thise.notif === "active" && item.expire == true && this.droitAcces.intervention) {
              notif.notify({
                title: "VISITE TECHNIQUE EXPIRE",
                text:
                  "La visite technique du véhicule " +
                  item.VehMat +
                  " a expirée depuis le " +
                  item.dateFin,
                color: "danger",
                position: "top-right",
                icon: "description",
                time: 5000,
                click: () => {
                  thise.dialogShowVisit = true;
                  thise.visiteCourant = item;
                }
              });
            }
          });
        }
      });
    },
    loadVign() {
      this.loading = true;
      let url = this.domaine + "vidange/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listVidn = response.body.vidange;
          this.nbVidang = response.body.nbVidang;
          if (this.listVidn === undefined || this.listVidn.length == 0) {
            this.disabledBtnAllVidn = true;
          } else {
            this.disabledBtnAllVidn = false;
          }
          this.loading = false;
          let notif = this.$vs;
          let thise = this;

          if (this.notif === "active" && response.body.compteur > 0 && this.droitAcces.intervention) {
            this.$vs.notify({
              title: "VIDANGE",
              text:
                "Vous avez " +
                response.body.compteur +
                " vidange(s) qui doivent être effectué aujourd'hui",
              color: "danger",
              position: "top-right",
              icon: "description",
              time: 10000
            });
          }

          this.listVidn.forEach(function(item) {
            if (thise.notif === "active" && item.expire == true && this.droitAcces.intervention) {
              notif.notify({
                title: "VIDANGE EXPIRE",
                text:
                  "La vidange du véhicule " +
                  item.VehMat +
                  " a expirée depuis le " +
                  item.dateDebt,
                color: "danger",
                position: "top-right",
                icon: "description",
                time: 10000,
                fixed: true,
                click: () => {
                  this.showVign(item);
                }
              });
            }
          });
        }
      });
    },
    loadMarque() {
      let url = this.domaine + "parc/index/marque";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listMarque = response.body.marque;
          this.nbMarqu = response.body.nbMarqu;
          if (this.listMarque === undefined || this.listMarque.length == 0) {
            this.disabledBtnMarq = true;
          } else {
            this.disabledBtnMarq = false;
          }
        }
      });
    },
    loadModele() {
      let url = this.domaine + "parc/index/modele";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listModele = response.body.modele;
          this.nbMarqu = this.listModele.length();
          if (this.listModele === undefined || this.listModele.length == 0) {
            this.disabledBtnMod = true;
          } else {
            this.disabledBtnMod = false;
          }
        }
      });
    },
    loadSerie() {
      let url = this.domaine + "parc/index/serie";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listSerie = response.body.serie;
          if (this.listSerie === undefined || this.listSerie.length == 0) {
            this.disabledBtnSerie = true;
          } else {
            this.disabledBtnSerie = false;
          }
        }
      });
    },
    loadVehicule() {
      this.loading = true;
      let url = this.domaine + "parc/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listVehicule = response.body.vehicule;
          this.nbVeh = response.body.nbVeh;
          this.tableStatVeh.push(...response.body.statVeh);
          this.loading = false;
        }
      });
    },
    loadListCartes() {
      this.loading = true;
      let url = this.domaine + "parc/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listVehicule = response.body.vehicule;
          this.nbVeh = response.body.nbVeh;
          this.tableStatVeh.push(...response.body.statVeh);
          this.loading = false;
        }
      });
    },

    loadVehiculeDispo() {
      let url = this.domaine + "mission/vehicule/disponible";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listVehiculeDispo = response.body.vehicule;
        }
      });
    },
    loadCarte() {
      this.loading = true;

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)

      let url = this.domaine + "carteCarburant/index";

      this.$http.get(url).then(
        response => {
          this.loading = false;

          // this.mntTTC =  response.body.mntTTC
          this.cartes = response.body.cartes;
          this.oldCartes = response.body.cartes;

          this.mntTotal = response.body.montantTotalFormat;
          //affichage nombre de demande
          this.nbCarteCar = this.cartes.length;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement des cartes"
          );
        }
      );
    },
    // loadStation()
    // {

    //     let url = this.domaine +  'carteCarburant/station/index'
    //     this.$http.get(url).then(response => {
    //        this.listeSociete = response.body.stations
    //        this.nbCarteCar =response.body.nbCarteCar

    //     },
    //      error=> {
    //         //this.$message("Chargement de la liste des stations en cours")
    //     })
    // },

    loadIntervention() {
      this.loading = true;
      let url = "";

      if (this.droitAcces.intervention) {
        url = this.domaine + "intervention/index";
      } else {
        url =
          this.domaine + "intervention/demandeur/" + this.user.id + "/index";
      }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listIntervention = response.body.intervention;
          this.nbDemand = response.body.nbDemand;
          this.tableStatInterv = response.body.statInterv;
          this.loading = false;
        }
      });
    },
    loadConsommation() {
      this.loading = true;
      let url = this.domaine + "consommation/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.loading = false;
          this.listConsommation = response.body.consommations;
          this.listOldConsommation = response.body.consommations;
          this.nbCarburan = response.body.nbCarburan;
          if (
            this.listConsommation === undefined ||
            this.listConsommation.length == 0
          ) {
            this.disabledBtnCarbu = true;
          } else {
            this.disabledBtnCarbu = false;
          }
          this.mntTotCons = response.body.totCons.mntTotCons;
          this.quantTotCons = response.body.totCons.quantTotCons;
          this.distParcTot = response.body.totCons.distParcTot;
          this.statConsom = response.body.stats;
          this.statConsom = response.body.stats;
          this.statQutConsom = response.body.stats;
          this.totCarb = response.body.totCarb;
          this.totMntCarb = response.body.totMntCarb;
          this.chartAllBilanCarburant();
          this.chartAllBilanCarburantQut();
          this.loading = false;
        }
      });
    },
    loadContrat() {
      this.loading = true;
      let url = this.domaine + "contrat/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listContrat = response.body.contrat;
          if (this.listContrat === undefined || this.listContrat.length == 0) {
            this.disabledBtnCont = true;
          } else {
            this.disabledBtnCont = false;
          }
          this.nbContrat = response.body.nbContrat;
          this.tableStatContrat = response.body.statCont;
          this.nbrContratExpireDay = response.body.nbrContratExpireDay;
          this.loading = false;
          let notif = this.$vs;
          let thise = this;
          this.listContrat.forEach(function(item) {
            //on verif le contrat est reservé
            if (thise.notif === "active" && item.etat == 0 && this.droitAcces.intervention) {
              notif.notify({
                title: "RESERVATION DU CLIENT " + item.client,
                text:
                  "Cet contrat que vous avez enrégistré est encore en réservation. Veuillez contacté le client pour plus d'info",
                type: "warning",
                position: "top-right",
                icon: "description",
                time: 10000
              });
            }

            //on verifi si la date de fin du contrat est passé
            if (thise.notif === "active" && item.expire == true && this.droitAcces.intervention) {
              notif.notify({
                title: "CONTRAT EXPIRE",
                text:
                  "Le contrat " +
                  item.ref +
                  " du client " +
                  item.client +
                  " a expiré depuis la date du " +
                  item.dateFFormat,
                color: "danger",
                position: "top-right",
                icon: "description",
                time: 10000,
                click: () => {
                  thise.contratCourant = item;
                  thise.dialogShowContrat = true;
                }
              });
            }
          });

          //contrat expirant aujourd'hui
          if (this.notif === "active" && this.nbrContratExpireDay != 0 && this.droitAcces.intervention) {
            this.$vs.notify({
              title: "CONTRAT EXPIRANT AUJOURD'HUI",
              text:
                this.nbrContratExpireDay +
                " Contrat (s) expire(ent) aujourd'hui.",
              color: "rgb(58, 154, 201)",
              position: "top-right",
              icon: "check_box",
              time: 10000
            });
          }
        }
      });
    },
    menuContrat() {
      this.dialogContrat = true;
      this.loadContrat();
      this.loadClientLocation();
    },
    menuClient() {
      this.dialogClientLocation = true;
      this.loadClientLocation();
    },
    menuIntervention() {
      this.dialogIntervention = true;
      this.loadIntervention();
    },
    menuVisiteTechnique() {
      this.dialogVisite = true;
      this.loadVisite();
    },
    menuVidange() {
      this.dialogVidange = true;
      this.loadVign();
    },
    menuAssurance() {
      this.dialogAssurance = true;
      this.loadAssu();
    },
    menuConducteur() {
      this.dialogConducteur = true;
      this.loadConducteur();
    },
    menuConsommation() {
      this.selectParc =''
      this.dialogConsommationCarburant = true;
      this.loadConsommation();
    },
    menuCarte() {
      this.showDialogCarcurant = true;
    },
    modalDmdCarb() {
      this.dialogShowListDfon = true
    },
      modalImpDmd(item)
      {
          this.demandeDetailFond = item;
          this.showModalDetailDmdFond = true;
      },
       showDialogDmdFondAfter(idDmd,type )
        {
            this.showModalDetailDmdFond = false;
            this.loadDemandeCarburan()
        },
       modalResponse(item, response)
      {
        this.demandeDetail = item
        if(response){
          this.dialogConfirm = true
        }else{
          this.dialogConfirmRefus = true
        }
      },
    menuMarque() {
      this.dialogParaMarque = true;
      this.loadMarque();
      this.loadModele();
      this.loadSerie();
    },
    modalMission() {
      this.showModalMission = true;
    },
    modalTarifs() {
      this.showModalTarif = true;
    },
    modalCalend() {
      this.showModalCalendContrat = true;
    },
    newContrat() {
      this.contratCourant = [];
      this.dialogEdit = false;
      this.loadTarification();
      this.dialogAjoutContrat = true;
      this.montantLocation = 0;
      this.selectVehicule = "";
      this.selectClient = "";
      this.selectCaisse = "";
      this.selectEtat = "";
      this.attribuer = false;
      this.totalF = 0;
      this.selectTarification = "";
      this.typeContrat = "Contrat de location";
      this.selectConducteur = "";
      this.remise = 0;
      this.tva = 0;
      this.penalite = 0;
      this.nbr = 1;
      this.montantLocation = 0;
      this.kilometrage = 0;
      this.avance = 0;
      this.dateS = "";
      this.dateD = "";
      this.datePaiement = "";
      this.optionContrat = [
        {
          key: Date.now(),
          libelle: "",
          cout: 0,
          qte: 1,
          tva: 0,
          total: 0,
          id: ""
        }
      ];
    },
    newClientLocation() {
      this.dialogAjoutClientLocation = true;
      this.dialogEdit = false;
      this.formClientLocation.nom = "";
      this.formClientLocation.prenom = "";
      this.formClientLocation.piece = "";
      this.formClientLocation.numPiece = "";
      this.formClientLocation.type = "";
      this.formClientLocation.contact = "";
      this.formClientLocation.adresse = "";
      this.formClientLocation.email = "";
    },
    newIntervention() {
      this.dialogEdit = false;
      this.dialogAjoutIntervention = true;
      this.interventionCourant = [];
      this.interventionCourant.etat = 0;
      this.etape = 1;
      //this.demandeur = ''
      this.loadUserAdmin();
      this.selectPriorite = "";
      this.selectType = "";
      this.selectGravite = "";
      this.selectCategorie = "";
      this.motif = "";
      this.dateInter = "";
      this.selectVehicule = "";
      this.selectCaisse = "";
      this.selectReponse = "";
      // this.calculTotalDevis()
      this.devis = [
        {
          key: Date.now(),
          libelle: "",
          cout: 0,
          qte: 1,
          tva: 0,
          total: 0,
          id: ""
        }
      ];
    },
    newValiderDevis(ligne) {
      this.dialogEdit = true;
      this.dialogValiderDevis = true;
      this.interventionCourant = ligne;
      this.selectReponseDevis = "";
      this.remarqueValider = "";
    },
    newConducteur() {
      this.dialogAjoutCond = true;
      this.dialogEdit = false;
      this.selectMarque = "";
      this.formConducteur = {};
      this.typedePermis =[]
      this.$refs.formConducteur.reset();
      this.conducteurCourant = [];
      this.imageChauf = "/static/img-doc.png";
    },
    newAssu() {
      this.dialogAjoutAssu = true;
      this.dialogEdit = false;
      this.assuranceCourant = []
      this.logoAssur = "/static/img-doc.png";
      this.selectMarque = "";
      this.selectParc =''
      this.selectCompagnLib = "";
      this.selectVehicule = "";
      this.formAssu = {};
    },
    newVida() {
      this.dialogAjoutVign = true;
      this.dialogEditVign = true;
      this.selectMarque = "";
      this.selectParc=""
      this.formVidn = {};
      this.vidangeCourant = []
      this.vidangeCourant.vehId = "";
      this.vidangeCourant.id = ""
      this.selectVehicule = "";
      this.selectVehiculeId = ""
      this.logoVidange = "/static/img-doc.png"
    },
    newAttrCondu(){
      this.dialogAjoutVehiConducteur = true;
      this.formAttribueCondu.vehicule = ''
      this.formAttribueCondu.parc = ''
      this.selectParc=""
    },
    newVisit() {
      this.dialogAjoutVisit = true;
      this.dialogEdit = false;
      this.formVisite = {};
      this.logoVisite = "/static/img-doc.png"
      this.selectVehicule = "";
      this.selectParc = ""
      this.visiteCourant =[]
    },
    newMarque() {
      this.dialogAjoutMarq = true;
      this.dialogEdit = false;
      this.formMarque = {};
      this.marqueCourant.id = "";
      this.logoMarque = "/static/img-doc.png";
    },
    newModele() {
      this.dialogAjoutMod = true;
      this.dialogEdit = false;
      this.selectMarque = "";
      this.formModele = {};
    },
    newSerie() {
      this.dialogAjoutSerie = true;
      this.dialogEdit = false;
      this.formSerie = {};
      this.selectSerie = "";
    },
    newConsom() {
      this.dialogAjoutCons = true;
      this.consommationCourant = "";
      this.imageConsom = "/static/img-doc.png";
      this.formAjoutCons.station = "";
      this.formAjoutCons.dateAchat = "";
      this.formAjoutCons.distParcourCons = 0;
      this.formAjoutCons.vehicule = "";
      this.formAjoutCons.typeCons = "";
      this.formAjoutCons.montant = 0;
      this.formAjoutCons.quantite = 0;
      this.formAjoutCons.kiloCons = 0;
    },
    editContrat(ligne) {
      this.contratCourant = ligne;
      this.dialogEdit = true;
      this.dialogAjoutContrat = true;
      this.selectVehicule = ligne.idVeh;
      this.selectClient = ligne.idCli;
      this.selectCaisse = ligne.idCaisse;
      this.selectEtat = ligne.etatContrat;
      this.attribuer = ligne.attribuer;
      this.selectTarification = ligne.idTarif;
      this.listTrarification = ligne.optionTarif;
      this.typeContrat = "Contrat de location";
      this.selectConducteur = ligne.idCond;
      this.remise = ligne.remise;
      this.tva = ligne.remise;
      this.nbr = ligne.nbr;
      this.montantLocation = ligne.montantLocation;
      this.avance = ligne.avance;
      this.penalite = ligne.penalite;
      this.kilometrage = ligne.kilomSorti;
      this.dateS = ligne.dateS;
      this.dateD = "";
      this.datePaiement = ligne.datePaiement;
      this.optionContrat = ligne.option;

      this.loadPrixLocation();
    },
    editClientLocation(ligne) {
      this.dialogAjoutClientLocation = true;
      this.dialogEdit = true;
      this.clientLocationCourant = ligne;
      this.formClientLocation = Object.assign({}, ligne);
      this.clientLocationCourant.url = ligne.url;
    },
    editCarburant(ligne) {
      this.consommationCourant = ligne;
      this.dialogAjoutCons = true;
      this.imageConsom = this.consommationCourant.imageRecu;
      this.formAjoutCons.station = ligne.station;
      this.formAjoutCons.dateAchat = ligne.dateAchat;
      this.formAjoutCons.distParcourCons = ligne.distParcourCons;
      this.formAjoutCons.vehicule = ligne.idVeh;
      this.formAjoutCons.typeCons = ligne.typeCons;
      this.formAjoutCons.montant = ligne.mntCons;
      this.formAjoutCons.quantite = ligne.quantite;
      this.formAjoutCons.kiloCons = ligne.kiloCons;
    },
    editConducteur(ligne) {
      this.dialogAjoutCond = true;
      this.dialogEdit = true;
      this.conducteurCourant = ligne;
      this.imageChauf = ligne.url;
      this.formConducteur.imageUrl = ligne.url;
      this.formConducteur.nom = ligne.nom;
      this.formConducteur.adresse = ligne.adresse;
      this.formConducteur.email = ligne.email;
      this.formConducteur.lieuNaiss = ligne.lieuNaiss;
      this.formConducteur.prenom = ligne.prenom;
      this.formConducteur.matricule = ligne.matricule;
      this.formConducteur.fonction = ligne.fonction;
      this.formConducteur.dateNaiss = ligne.dateNs;
      this.formConducteur.dateEmbauch = ligne.dateEmb;
      this.detailsPermis = ligne.typePermis;
      this.typedePermis ='';
      this.formConducteur.numPermis = ligne.numPermis;
      this.formConducteur.dateValPermis =ligne.dateVp;
      this.formConducteur.phone1 = ligne.phone1;
      this.formConducteur.phone2 = ligne.phone2;

      if (this.conducteurCourant.dispo == 0) {
        this.formConducteur.disponibilite = "Disponible";
      } else if (this.conducteurCourant.dispo == 1) {
        this.formConducteur.disponibilite = "Activite";
      } else {
        this.formConducteur.disponibilite = "Absent";
      }
      this.loading = false;
    },
    editAssu(ligne) {
      this.dialogShowAssu = false;
      this.dialogAjoutAssu = true;
      this.dialogEdit = true;
      this.logoAssur = ligne.url;
      this.assuranceCourant = ligne;
      this.formAssu.attestation = this.assuranceCourant.numAttes;
      this.formAssu.police = this.assuranceCourant.numPolice;
      this.formAssu.montant = this.assuranceCourant.mntAssurReel;
      this.formAssu.description = this.assuranceCourant.descripAssur;
      this.formAssu.dateAssu = this.assuranceCourant.dateAssur;
      this.formAssu.dateDebutAssu = this.assuranceCourant.dateDbtReel;
      this.formAssu.dateFinAssu = this.assuranceCourant.dateFnReel;
      this.formAssu.dateRenAssu = this.assuranceCourant.dateRenouvReel;
      // this.formAssu.statut = this.assuranceCourant.statut;
      this.selectCompagnLib = this.assuranceCourant.societeId;
      this.selectVehicule = this.assuranceCourant.vehId;
    },
    editVign(ligne) {
      this.dialogAjoutVign = true;
      this.dialogEditVign = false;
      this.dialogShowVign = false;
      this.vidangeCourant = ligne;
      this.selectParc = ligne.parcVehi
      console.log('ligne',ligne)
      this.logoVidange = ligne.url;
      this.formVidn = Object.assign({}, ligne);
      this.formVidn.montant = this.vidangeCourant.montant;
      this.formVidn.statut = this.vidangeCourant.statut;
      this.selectVehicule = this.vidangeCourant.vehMat;
      this.selectVehiculeId = this.vidangeCourant.vehId
    },
    editVisit(ligne) {
      this.dialogAjoutVisit = true;
      this.dialogEdit = true;
      this.logoVisite = ligne.url;
      this.selectParc = ""
      this.visiteCourant = ligne;
      this.formVisite = Object.assign({}, ligne);
      this.formVisite.montant = this.visiteCourant.montant;
      this.formVisite.statut = this.visiteCourant.statut;
      this.selectVehicule = this.visiteCourant.VehId;
    },
    editMarque(ligne) {
      this.loadingModalMarq = false;
      this.dialogAjoutMarq = true;
      this.dialogEdit = true;
      this.marqueCourant = ligne;
      this.formMarque.libelle = this.marqueCourant.libelle;
      this.logoMarque = ligne.url;
    },
    editModele(ligne) {
      this.loadingModalMod = false;
      this.dialogAjoutMod = true;
      this.dialogEdit = true;
      this.modeleCourant = ligne;
      this.formModele.libelle = this.modeleCourant.libelle;
      this.selectMarque = this.modeleCourant.marqLibelle;
    },
    editSerie(ligne) {
      this.loadingModalSerie = false;
      this.dialogAjoutSerie = true;
      this.dialogEdit = true;
      this.serieCourant = ligne;
      this.formSerie.libelle = this.serieCourant.libelle;
      this.selectSerie = this.serieCourant.ModeleId;
    },
    closeContrat(ligne) {
      this.contratCourant = ligne;
      this.dialogCloseContrat = true;
      this.selectCLose = "";
      this.remarque = "";
      this.dateR = "";
      this.kilometrage = 0;
    },
    //enregistrement des images
    onFileImageAssurLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoAssur = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoAssur = files[0];
    },
    onFileImageVidangeLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoVidange = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVidange = files[0];
    },
    onFileImageVisiteLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoVisite = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVisite = files[0];
    },
    showIntervention(ligne) {
      this.loadUserAdmin();
      this.loadIntervention();

      this.loading = true;
      this.interventionCourant = ligne;
      this.dialogEdit = true;
      this.dialogAjoutIntervention = true;

      this.selectPriorite = ligne.priorite;
      this.selectType = ligne.type;
      this.selectGravite = ligne.gravite;
      this.selectCategorie = ligne.categorie;
      this.motif = ligne.motif;
      this.selectReponse = ligne.etat;
      this.dateInter = ligne.dateFormat;
      this.selectVehicule = ligne.idVeh;
      this.selectPrestataire = ligne.idPres;
      this.remarque = ligne.remarque;
      this.diagnostique = ligne.diagnostique;
      this.maindoeuvre = ligne.maindoeuvre;
      this.kilometrage = ligne.kilometrage;
      this.dateD = ligne.dateDFormat;
      this.dateF = ligne.dateFFormat;
      this.remarqueFin = ligne.remarqueFin;
      this.fileFin = ligne.fichierFin;
      this.etape = ligne.etape;
      if (!this.droitAcces.intervention) {
        this.etape = 1;
      }
      this.devis = ligne.devis;
      this.datePaiement = ligne.datePaiement;
      this.selectCaisse = ligne.idCaisse;
      this.imageDevis = ligne.photoDevis;
      //this.demandeur = ligne.idDemandeur

      let url =
        this.domaine + "intervention/" + ligne.id + "/show/intervention";
      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.interventionCourant = response.body.intervention;
            this.loading = false;
          }
        },
        response => {}
      );
      this.calculTotalDevis();
    },
    showContrat(ligne) {
      this.contratCourant = ligne;
      this.dialogShowContrat = true;
    },
    showLocationClient(ligne) {
      this.dialogShowClientLocation = true;
      this.clientLocationCourant = ligne;
    },
    showCondMission(ligne) {
      console.log('eie',ligne)
      this.detailMission = ligne
      this.dialogShowCondMission = true;
      this.condMissionCourant = ligne;
    },
    showAssu(ligne) {
      this.dialogShowAssu = true;
      this.assuranceCourant = ligne;
      this.formAssu.attestation = this.assuranceCourant.numAttes;
      this.formAssu.police = this.assuranceCourant.numPolice;
      this.formAssu.montant = this.assuranceCourant.mntAssurReel;
      this.formAssu.description = this.assuranceCourant.descripAssur;
      this.formAssu.dateAssu = this.assuranceCourant.dateAssur;
      this.formAssu.dateDebutAssu = this.assuranceCourant.dateDbtReel;
      this.formAssu.dateFinAssu = this.assuranceCourant.dateFnReel;
      this.formAssu.dateRenAssu = this.assuranceCourant.dateRenouvReel;
      this.showCompagnLib = this.assuranceCourant.compagnLibelle;
      this.showVehLib = this.assuranceCourant.vehMatricule;
    },
    showVisit(ligne) {
      this.dialogShowVisit = true;
      this.visiteCourant = ligne;
    },
    showVign(ligne) {
      this.dialogShowVign = true;
      this.vidangeCourant = ligne;
      this.formVidn.attestation = this.vidangeCourant.numAttes;
      this.formVidn.police = this.vidangeCourant.numPolice;
      this.formVidn.montant = this.vidangeCourant.mntAssurReel;
      this.formVidn.description = this.vidangeCourant.descripAssur;
      this.formVidn.dateAssu = this.vidangeCourant.dateAssur;
      this.formVidn.dateDebutAssu = this.vidangeCourant.dateDbtReel;
      this.formVidn.dateFinAssu = this.vidangeCourant.dateFnReel;
      this.formVidn.dateRenAssu = this.vidangeCourant.dateRenouvReel;
      this.showCompagnLib = this.vidangeCourant.compagnLibelle;
      this.showVehLib = this.vidangeCourant.vehMatricule;
    },
    ficheConducteur(ligne) {
      console.log('ligne',ligne)
      this.dialogFicheCond = true;
      this.conducteurCourant = ligne;
    },
    submitIntervention(etape) {
      this.loading = true;
      if (this.$refs.formIntervention.validate()) {
        if (
          this.selectVehicule != "" &&
          this.selectType != "" &&
          this.selectGravite != "" &&
          this.selectPriorite != "" &&
          this.motif != "" &&
          this.dateInter != ""
        ) {
          var form = document.getElementById("formIntervention");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          // data.append("etape", etape);
          // data.append("type", this.selectType);
          // data.append("priorite", this.selectPriorite);
          // data.append("gravite", this.selectGravite);
          // data.append("categorie", this.selectCategorie);
          // data.append("vehicule", this.selectVehicule);
          if (this.interventionCourant.id) {
            data.append("id", this.interventionCourant.id);
          } else {
            data.append("id", "");
          }
          let url = this.domaine + "intervention/new/intervention";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Demande d'intervention enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.loadIntervention();
                  // this.showIntervention(response.body.data)
                  this.loading = false;

                  if (!this.droitAcces.intervention) {
                    this.dialogAjoutIntervention = false;
                  } else {
                    this.showIntervention(response.body.data);
                    if (etape == 1) {
                      this.dialogAjoutIntervention = false;
                    } else {
                      this.etape = etape;
                    }
                  }
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitContrat() {
      this.loading = true;
      if (
        this.$refs.formContrat.validate() &&
        (this.selectVehicule != "" &&
          this.selectClient != "" &&
          this.montantLocation != 0 &&
          this.selectCaisse != "" &&
          this.dateS != "" &&
          this.dateD != "" &&
          (this.selectEtat != "" || this.selectEtat != null) &&
          this.selectTarification != "" &&
          this.remise >= 0 &&
          this.nbr >= 1 &&
          this.datePaiement != "")
      ) {
        let etat = false;
        if (this.optionContrat.length > 0) {
          this.optionContrat.forEach(function(item) {
            if (item.libelle != "" && item.qte != 0 && item.cout != 0) {
              etat = true;
            }
          });
        } else {
          etat = true;
        }
        if (etat == true) {
          var form = document.getElementById("formContrat");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("vehicule", this.selectVehicule);
          data.append("client", this.selectClient);
          data.append("caisse", this.selectCaisse);
          data.append("etat", this.selectEtat);
          data.append("attribuer", this.attribuer);
          data.append("total", this.totalF);
          data.append("tarif", this.selectTarification);
          data.append("typeContrat", this.typeContrat);
          data.append("totalTtc", this.totalTtc);
          data.append("totalHT", this.ht);
          data.append("option", []);
          if (this.attribuer == true) {
            data.append("conducteur", this.selectConducteur);
          }
          if (this.contratCourant.id) {
            data.append("id", this.contratCourant.id);
          } else {
            data.append("id", "");
          }
          this.optionContrat.forEach(function(item) {
            data.append("option[id][]", item.id);
            data.append("option[libelle][]", item.libelle);
            data.append("option[qte][]", item.qte);
            data.append("option[unite][]", item.unite);
            data.append("option[montant][]", item.cout);
            data.append("option[tva][]", item.tva);
            data.append("option[total][]", item.total);
          });

          let url = this.domaine + "contrat/new";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Contrat enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });
                  this.totalTtc = 0
                  this.loadContrat();
                  this.loading = false;
                  this.dialogAjoutContrat = false;
                  this.$refs.formContrat.reset();
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error(
            "Veuillez compléter les champs obligatoires pour la facture !"
          );
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitClientLocation() {
      this.loading = true;
      if (this.$refs.formClientLocation.validate()) {
        if (
          this.formClientLocation.nom != "" &&
          this.formClientLocation.prenom != "" &&
          this.formClientLocation.piece != "" &&
          this.formClientLocation.numPiece != "" &&
          this.formClientLocation.DateDelivrPiece != "" &&
          this.formClientLocation.DateExpirPiece != "" &&
          this.formClientLocation.contact != "" &&
          this.formClientLocation.profession != "" &&
          this.formClientLocation.type != "" &&
          this.formClientLocation.persoSignataire != "" &&
          this.formClientLocation.nomPersoContact != "" &&
          this.formClientLocation.prenomPersoContact != "" &&
          this.formClientLocation.telPersoContact != ""
        ) {
          var form = document.getElementById("formClientLocation");
          var data = new FormData(form);
          data.append("type", this.formClientLocation.type);
          data.append("affinite", this.formClientLocation.affinite);
          let url = this.domaine + "client/new";
          if (this.clientLocationCourant.id) {
            data.append("id", this.clientLocationCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Location client enregistrée avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.loadClientLocation();
                  this.dialogAjoutClientLocation = false;
                  this.loading = false;
                  this.$refs.formClientLocation.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Location client n'a pas été enregistrée.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitValideIntervention(etape) {
      this.loading = true;
      if (this.$refs.formValidInter.validate()) {
        if (this.selectReponse != "") {
          var form = document.getElementById("formValidInter");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("etape", etape);
          data.append("reponse", this.selectReponse);

          let url =
            this.domaine +
            "intervention/new/" +
            this.interventionCourant.id +
            "/valider/intervention";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.loadIntervention();
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message:
                      "Validation de l'intervention enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.showIntervention(response.body.data);
                  this.loading = false;
                  if (this.selectReponse == 1) {
                    this.etape = etape;
                  } else {
                    this.etape = 2;
                  }
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitDiagnostique(etape) {
      this.loading = true;
      if (this.$refs.formDiagnostique.validate()) {
        if (
          this.selectPrestataire != "" &&
          (this.maindoeuvre != 0 && this.maindoeuvre >= 0) &&
          this.diagnostique != "" &&
          this.datePaiement != ""
        ) {
          let etat = false;
          if (this.devis.length > 0) {
            this.devis.forEach(function(item) {
              if (item.libelle != "" && item.qte > 0 && item.cout > 0) {
                etat = true;
              }
            });
          }
          if (etat == true) {
            var form = document.getElementById("formDiagnostique");
            var data = new FormData(form);
            data.append("idUser", this.user.id);
            data.append("etape", etape);
            data.append("idPres", this.selectPrestataire);
            data.append("caisse", this.selectCaisse);
            this.devis.forEach(function(item) {
              data.append("option[id][]", item.id);
              data.append("option[libelle][]", item.libelle);
              data.append("option[qte][]", item.qte);
              data.append("option[unite][]", item.unite);
              data.append("option[montant][]", item.cout);
              data.append("option[tva][]", item.tva);
            });

            let url =
              this.domaine +
              "intervention/new/" +
              this.interventionCourant.id +
              "/diagnostique";
            this.$http.post(url, data).then(
              response => {
                this.loading = false;
                this.$refs.fileDevis.value = "";
                this.imageDevis = "/static/img-doc.png";
                if (response.body) {
                  if (response.body.code == 1) {
                    this.$notify({
                      title: "ENREGISTREMENT REUSSI",
                      message: "Diagnostique enregistré avec succès.",
                      type: "success",
                      position: "top-center",
                    duration: 5000
                    });

                    this.loadIntervention();
                    this.showIntervention(response.body.data);
                    this.loading = false;
                  }
                }
              },
              response => {
                this.loading = false;
              }
            );
          } else {
            this.$message.error(
              "Veuillez compléter les champs obligatoires pour le dévis !"
            );
            this.loading = false;
          }
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitValiderDevis() {
      this.loading = true;
      if (this.$refs.formValiderDevis.validate()) {
        if (this.selectReponseDevis != "") {
          var form = document.getElementById("formValiderDevis");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("reponse", this.selectReponseDevis);

          let url =
            this.domaine +
            "intervention/new/" +
            this.interventionCourant.id +
            "/valider/devis";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Validation du dévis enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.$refs.fileDevis.value = "";
                  this.imageDevis = "/static/car_avatar.png";
                  this.dialogValiderDevis = false;
                  this.loadIntervention();
                  this.showIntervention(this.interventionCourant);
                  this.loading = false;
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    //enregistrement des images
    onFileImageChauffPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageChauf = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.imageChauf = files[0];
    },
    submitCloseContrat() {
      this.loading = true;
      if (this.$refs.formCloseContrat.validate()) {
        if (this.selectClose != "" && this.dateR != "") {
          var form = document.getElementById("formCloseContrat");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("reponse", this.selectClose);

          let url = this.domaine + "contrat/close/" + this.contratCourant.id;
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Contrat fermé avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.dialogCloseContrat = false;
                  this.loadContrat();
                  this.loadConducteur();
                  this.loading = false;
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitProgrammation(etape) {
      this.loading = true;
      if (this.$refs.formProgrammation.validate()) {
        if (
          this.dateD != "" &&
          this.dateF != "" &&
          this.dateD < this.dateF &&
          this.kilometrage > 0
        ) {
          var form = document.getElementById("formProgrammation");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("etape", etape);

          let url =
            this.domaine +
            "intervention/new/" +
            this.interventionCourant.id +
            "/programmation";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Programmation enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.dialogValiderDevis = false;
                  this.loadIntervention();
                  this.showIntervention(response.body.data);
                  this.loading = false;
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez remplir le formulaire correctement !");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitFinIntervention(etape) {
      this.loading = true;
      if (this.$refs.formFinIntervention.validate()) {
        if (this.remarqueFin != "") {
          var form = document.getElementById("formFinIntervention");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("etape", etape);

          let url =
            this.domaine +
            "intervention/new/" +
            this.interventionCourant.id +
            "/fin/intervention";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.saveFichier(this.interventionCourant.id);
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Fin de l'intervention enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.loadIntervention();
                  this.showIntervention(this.interventionCourant);
                  this.loading = false;
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez remplir le formulaire correctement !");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitConducteur() {
      // this.loading = true;
      if (this.$refs.formConducteur.validate()) {
        var form = document.getElementById("formConducteur");
        var data = new FormData(form);
        data.append("disponibilite", this.formConducteur.disponibilite);
        data.append("typePermis1", this.detailsPermis);
        data.append("typePermis", this.typedePermis);

        let url = this.domaine + "conducteur/new/conducteur";

        if (this.conducteurCourant.idCond) {
          data.append("id", this.conducteurCourant.idCond);
        } else {
          data.append("id", "");
        }

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Conducteur enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                    duration: 5000
                });

                this.loadConducteur();
                this.dialogAjoutCond = false;
                this.loading = false;
                this.$refs.formConducteur.reset();
                this.conducteurCourant = "";
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le conducteur n'a pas été enregistré.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitAttribution(){
      this.loading = true;
      var form = document.getElementById("formAttribueCondu");
      var data = new FormData(form);
      let url = this.domaine + "conducteur/vehicule/atribuer/new";
      data.append("vehicule", this.formAttribueCondu.vehicule);
      data.append("idConduteur", this.conducteurCourant.idCond);
      this.$http.post(url, data).then(response => {
          this.loading = false;
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Véhicule affécté à ce conducteur.",
              type: "success",
              position: "top-center",
              duration: 5000
            });
            this.loadVConducteur()
            this.dialogAjoutVehiConducteur = false;
            this.loading = false;
          }
        },
        error => {
          this.$message.error("Ce véhicule déja été affecter à ce conducteur");
          this.loading = false;
        }
      );
    },
    submitVisit() {
      this.loading = true;
      if (this.$refs.formVisite.validate()) {
        if (
          this.formVisite.numero != "" &&
          this.formVisite.dateDebut != "" &&
          this.formVisite.dateFin != "" &&
          this.formVisite.montant > 0 &&
          (this.formVisite.statut == 0 || this.formVisite.statut == 1) &&
          this.selectVehicule != ""
        ) {
          var form = document.getElementById("formVisite");
          var data = new FormData(form);
          data.append("idVeh", this.selectVehicule);
          data.append("statut", this.formVisite.statut);
          let url = this.domaine + "visite/new";
          if (this.visiteCourant.id) {
            data.append("id", this.visiteCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Visite technique enregistrée avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.loadVehicule();
                  this.loadVisite();
                  this.dialogAjoutVisit = false;
                  this.loading = false;
                  this.$refs.formVisite.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 4) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 2) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 3) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Vidange n'a pas été enregistrée.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitAssu() {
      this.loading = true;
      if (this.$refs.formAssu.validate()) {
        if (
          this.formAssu.attestation != "" &&
          this.formAssu.police != "" &&
          this.formAssu.montant > 0 &&
          this.formAssu.dateAssu != "" &&
          this.selectCompagnLib != "" &&
          this.selectVehicule != "" &&
          this.formAssu.dateDebutAssu &&
          this.formAssu.dateFinAssu &&
          (this.formAssu.statut == 1 || this.formAssu.statut == 0)
        ) {
          var form = document.getElementById("formAssu");
          var data = new FormData(form);
          data.append("idVeh", this.selectVehicule);
          data.append("idCompagn", this.selectCompagnLib);
          data.append("statut", this.formAssu.statut);
          let url = this.domaine + "parc/new/assurance";
          if (this.assuranceCourant.id) {
            data.append("id", this.assuranceCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;


                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Asssurance enregistrée avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  this.loadAssu();
                  this.loadVehicule();
                  this.loadCompagnie();
                  this.dialogAjoutAssu = false;
                  this.loading = false;
                  this.$refs.formAssu.reset();
                }
                else if (verif.code === 4) {
                 this.$notify({
                    title: "MODIFICATION REUSSI",
                    message: "Asssurance modifiée avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });
                  this.dialogAjoutAssu = false;
                  this.dialogShowAssu = false;
                  this.loading = false;
                }
                else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 2) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 3) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 1");
                this.loading = false;
              }
                  this.dialogAjoutAssu = false;
                  this.loadAssu();
                  this.loadVehicule();
                  this.loadCompagnie();
                  this.loading = false;
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 2");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Assurance n'a pas été enregistré.",
          position: "top-center",
          duration: 5000
        });

        this.loading = false;
      }
    },
    submitVign() {
      this.loading = true;
      if (this.$refs.formVidn.validate()) {
        let dateRen = this.functionTime(this.formVidn.dateRen)
        if (
          (this.formVidn.numero != "" &&
            this.selectVehicule != "" &&
            this.formVidn.kiloActu !="" &&
            this.formVidn.kiloProch !="" &&
            this.formVidn.dateDebt != "" &&
            this.formVidn.statut == 0) ||
          this.formVidn.statut == 1
        ) {
              if(dateRen.getTime() <= new Date().getTime() && this.formVidn.statut == 1 ){
                this.loading = false;
                  this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La date de renouvellement est passée,Veuillez désactiver l'assurance avant d'enregistrée",
                    position: "top-center"
                  });
              }else{
              var form = document.getElementById("formVidn");
              var data = new FormData(form);

              data.append("statut", this.formVidn.statut);
              let url = this.domaine + "vidange/new";
              if (this.vidangeCourant.id) {
                data.append("idVeh", this.selectVehiculeId);
                data.append("id", this.vidangeCourant.id);
              } else {
                data.append("id", "");
                 data.append("idVeh", this.selectVehicule);
              }

              this.$http.post(url, data).then(
                response => {
                  if (response.body) {
                    let verif = response.body;
                    if (verif.code === 1) {
                      this.$notify({
                        title: "ENREGISTREMENT REUSSI",
                        message: "Vidange enregistrée avec succès.",
                        type: "success",
                        position: "top-center"
                      });

                      this.loadVehicule();
                      this.loadVign();
                      this.dialogAjoutVign = false;
                      this.loading = false;
                      this.$refs.formVidn.reset();
                      this.selectVehicule = "";
                      this.selectVehiculeId = "";
                    } else if (verif.code === 0) {
                      this.$message.error(verif.message);
                      this.loading = false;
                    } else if (verif.code === 3) {
                      this.$message.error(verif.message);
                      this.loading = false;
                    }
                  } else {
                    this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                    this.loading = false;
                  }
                },
                response => {
                  this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                  this.loading = false;
                }
              );
              }

        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Vidange n'a pas été enregistrée.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitCarburant() {
      this.loading = true;
      if (this.$refs.formConsomm.validate()) {
        if (
          this.formAjoutCons.vehicule != "" &&
          this.formAjoutCons.station != "" &&
          this.formAjoutCons.dateAchat != "" &&
          this.formAjoutCons.montant > 0 &&
          this.formAjoutCons.quantite > 0 &&
          this.formAjoutCons.typeCons != ""
        ) {
          var form = document.getElementById("formConsomm");
          var data = new FormData(form);
          let url = this.domaine + "consommation/save";
          data.append("idUser", this.user.id);
          data.append("vehicule", this.formAjoutCons.vehicule);
          data.append("type", this.formAjoutCons.typeCons);
          data.append("identifiantCarte", this.formAjoutCons.identifiant);
          if (this.consommationCourant.id != "") {
            data.append("id", this.consommationCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              this.loading = false;
              this.dialogAjoutCons = false;
              if (response.body) {
                this.loading = false;
                let verif = response.body;
                if (verif.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "La consommation a été enregistré avec succès.",
                    type: "success",
                    position: "top-right"
                  });
                }

                if (verif.code == 3) {
                  this.$notify({
                    title: "SOLDE CARTE INVALIDE",
                    message: "Le solde de la carte est inférieur au montant",
                    type: "warning",
                    position: "top-right",
                    duration: 5000
                  });
                }
                this.loadConsommation();

                this.$refs.fileConsom.value = "";
                this.imageConsom = "/static/car_avatar.png";

                this.$refs.formConsomm.reset();
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
              this.loadConsommation();
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      }
    },
    submitMarq() {
      this.loading = true;
      if (this.$refs.formMarque.validate()) {
        if (this.formMarque.libelle != "") {
          var form = document.getElementById("formMarque");
          var data = new FormData(form);
          let url = this.domaine + "parc/new/marque";
          if (this.marqueCourant.id) {
            data.append("id", this.marqueCourant.id);
          } else {
            data.append("id", "");
          }
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Marque enregistrée avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.loadMarque();
                  this.dialogAjoutMarq = false;
                  this.loading = false;
                  this.$refs.formMarque.reset();
                  this.$refs.uploadFichCom.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La marque n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    deleteVehiCondu(row){
    this.loading = true
    let url = this.domaine + "conducteur/delete/vehicule/"+this.conducteurCourant.idCond+'/'+row.idVeh;
      this.$http.get(url).then(
        response => {
            if (response.body.code === 1) {
              this.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Véhicule retiré avec succès.",
                type: "success",
                position: "top-center"
              });
              this.loadVConducteur()
              this.loading = false
            }
        },
        error => {
          this.$message.error("Impossible de retirer ce vehicule à ce conducteur.");
          this.loading = false;
        }
      );
    },
    submitModele() {
      this.loading = true;
      if (this.$refs.formModele.validate()) {
        if (this.selectMarque != "" && this.formModele.libelle != "") {
          var form = document.getElementById("formModele");
          var data = new FormData(form);
          data.append("idMarque", this.selectMarque);

          let url = this.domaine + "parc/new/modele";
          if (this.modeleCourant.id) {
            data.append("id", this.modeleCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Marque enregistrée avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.loadModele();
                  this.loadMarque();
                  this.dialogAjoutMod = false;
                  this.loading = false;
                  this.$refs.formModele.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error(
                "Veuillez renseigner les champs obligatoires * "
              );
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La marque n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitSerie() {
      this.loading = true;
      if (this.$refs.formSerie.validate()) {
        if (this.formSerie.libelle != "" && this.selectSerie != "") {
          var form = document.getElementById("formSerie");
          var data = new FormData(form);
          data.append("idModele", this.selectSerie);
          let url = this.domaine + "parc/new/serie";
          if (this.serieCourant.id) {
            data.append("id", this.serieCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Marque enregistrée avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.loadSerie();
                  this.dialogAjoutSerie = false;
                  this.loading = false;
                  this.$refs.formSerie.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error(
                "Veuillez renseigner les champs obligatoires *"
              );
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La marque n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    saveFichier(id) {
      let url = this.domaine + "intervention/upload/fichiers/" + id;
      this.fichier.url = url;
      this.$refs.uploadIntervention.submit();
    },
    lienFlotte() {
      this.$router.push({
        name: "Flotte"
      });
    },
    impmerFacture(ligne) {
      this.contratCourant = ligne;
      let url =
        this.domaine +
        "contrat/" +
        this.contratCourant.id +
        "/" +
        this.user.id +
        "/imprimer/facture";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerDemande(ligne) {
      this.interventionCourant = ligne;
      let url =
        this.domaine +
        "intervention/" +
        this.interventionCourant.id +
        "/imprimer";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    ImprimerVidange(ligne) {
      let url = this.domaine + "vidange/imprimer/" + ligne.id;
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    ImprimerVisite(ligne) {
      let url = this.domaine + "visite/imprimer/" + ligne.id;
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    ImprimerConducteur(ligne) {
      let url = this.domaine + "conducteur/imprimer/" + ligne.idCond;
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimeListeHisAdminVisiteVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/admin-visite/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/admin-visite/vehicule";
      }
      window.open(url);
    },
    imprimeListeModele(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/modele/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/modele/liste";
      }
      window.open(url);
    },
    imprimeListeSerie(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/serie/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/serie/liste";
      }
      window.open(url);
    },
    imprimeListeMarque(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/marque/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/marque/liste";
      }
      window.open(url);
    },
    imprimeListeConducteur(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "conducteur/imprimerPDF/liste";
      } else {
        url = this.domaine + "conducteur/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeCarburant(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "consommation/imprimerPDF/liste";
      } else {
        url = this.domaine + "consommation/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeContrat(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "contrat/imprimerPDF/" + this.user.id + "/liste";
      } else {
        url = this.domaine + "contrat/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeClient(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "client/imprimerPDF/liste";
      } else {
        url = this.domaine + "client/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeVisitTechnik(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "visite/imprimerPDF/liste";
      } else {
        url = this.domaine + "visite/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeVign(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "vidange/imprimerPDF/liste";
      } else {
        url = this.domaine + "vidange/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeAssur(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/assurance/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/assurance/liste";
      }
      window.open(url);
    },
    imprimeListeDemande(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "intervention/imprimerPDF/liste";
      } else {
        url = this.domaine + "intervention/imprimerEXC/liste";
      }
      window.open(url);
    },

    deleteIntervention() {
      this.loading = true;
      let url = this.domaine + "intervention/" + this.InterId + "/delete";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Intervention supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;
          this.loading = false;
          this.loadIntervention();
          this.loading = false;
        }
      });
    },
    deleteMarq() {
      let url = this.domaine + "parc/delete/marque/" + this.idMarque;
      this.$http.get(url).then(response => {
        if (response.body) {
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Marque supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSuprMarq = false;
            this.loadMarque();
            // this.loadPage()
          } else if (verif.code === 0) {
            this.$message.error(verif.message);
            this.loading = false;
          }
        }
      });
    },
    deleteModel() {
      let url = this.domaine + "parc/delete/modele/" + this.idModele;
      this.$http.get(url).then(response => {
        if (response.body) {
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Modèle supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSuprModel = false;
            this.loadModele();
            // this.loadPage()
          } else if (verif.code === 0) {
            this.$message.error(verif.message);
            this.loading = false;
          }
        }
      });
    },
    deleteSeri() {
      let url = this.domaine + "parc/delete/serie/" + this.idSerie;
      this.$http.get(url).then(response => {
        if (response.body) {
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Serie supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSuprSeri = false;
            this.loadSerie();
            // this.loadPage()
          } else if (verif.code === 0) {
            this.$message.error(verif.message);
            this.loading = false;
          }
        }
      });
    },
    deleteConducteur() {
      let url = this.domaine + "conducteur/delete/" + this.idConducteur;
      this.$http.get(url).then(response => {
        if (response.body) {
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Conducteur supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSuprCond = false;
            this.loadConducteur();
            this.loadPage();
          } else if (verif.code === 0) {
            this.$message.error(verif.message);
            this.loading = false;
          }
        }
      });
    },
    deleteCarburant() {
      this.loading = true;
      let url = this.domaine + "consommation/delete/" + this.idConsommation;
      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.loading = false;

            this.$notify({
              title: "SUPPRESSION",
              message: "La consommation a été  supprimé avec succès.",
              type: "success",
              position: "top-right"
            });
            this.dialogSuppCarburant = false;
            this.idConsommation = null;
            this.loadConsommation();
          }
        },
        response => {
          this.$message.error(
            "Erreur lors de la suppression de la consommation"
          );
          this.loading = false;
        }
      );
    },
     deleteAssu() {
      let url = this.domaine + "parc/delete/assurance/" + this.idAssu;
      this.$http.get(url).then(response => {
        if (response.body.rep == 1) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Assurance supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprAssu = false;
          this.loadAssu();
          this.loadPage();
        } else if (response.body.rep == 0) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center"
          });
          this.dialogSuprAssu = false;
        }
      });
    },
    deleteVisit() {
      let url = this.domaine + "visite/delete/" + this.idVisit;
      this.$http.get(url).then(response => {
        if (response.body.rep == 1) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Visite technique supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprVisit = false;
          this.loadVisite();
          this.loadPage();
        } else if (response.body.rep == 0) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center"
          });
          this.dialogSuprVisit = false;
        }
      });
    },
    deleteVign() {
      let url = this.domaine + "vidange/delete/" + this.idVign;
      this.$http.get(url).then(response => {
        if (response.body.rep == 1) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Vidange supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprVign = false;
          this.loadVign();
          this.loadPage();
        } else if (response.body.rep == 0) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center"
          });
          this.dialogSuprVign = false;
        }
      });
    },
    deleteClientLocation() {
      let url = this.domaine + "client/delete/" + this.idClientLoc;
      this.$http.get(url).then(response => {
        if (response.body) {
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Client supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSuprClientLocation = false;
            this.loadClientLocation();
            this.loadPage();
          } else if (verif.code === 0) {
            this.$message.error(verif.message);
            this.loading = false;
          }
        }
      });
    },
    selectTab(idtab) {
      switch (idtab) {
        case "tab-2":
          {
            this.loading = true;
            let url =
              this.domaine +
              "conducteur/load/mission-en-cours/" +
              this.conducteurCourant.idCond;
            this.$http.get(url).then(response => {
              if (response.body) {
                this.loading = false;
                this.listCondMissEnCours = response.body.missionsCondEnCours;
              }
            });
          }
          break;
        case "tab-3":
          {
            let url = this.domaine + "tabParcauto/docadmin/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.itemsDocAss = resp.body.docsassur;
                this.itemsDocVig = resp.body.docsvig;
                this.itemsDocVis = resp.body.docsvistech;
                this.mntTotAssur = resp.body.total.mntTotAssur;
                this.mntTotVig = resp.body.total.mntTotVig;
                this.mntTotVistech = resp.body.total.mntTotVistech;
              },
              resp => {
                this.$message.error(
                  "erreur lors du chargement des documents administratifs"
                );
              }
            );
          }
          break;
        case "tab-4":
          {
            let url = this.domaine + "tabParcauto/consommation/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.itemsCons = resp.body.consommation;
                this.mntTotCons = resp.body.total.mntTotCons;
                this.quantTotCons = resp.body.total.quantTotCons;
                this.distParcTot = resp.body.total.distParcTot;
              },
              resp => {
                this.$message.error(
                  "erreur lors du chargement des consommations"
                );
              }
            );
          }
          break;
        case "tab-5":
          {
           this.loadVConducteur();
          }
          break;
      }
    },
    loadListMarq(queryString, cb) {
      var links = this.listMarque;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      cb(results);
    },
    loadVConducteur(){
    this.loading = true
    let url = this.domaine +"conducteur/load/list-vehicule-affecter/"+this.conducteurCourant.idCond;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listVehiculeAffecte = response.body.listVehiculeAffecte;
          this.loading = false
        }
      });
    },
    loadListMod(queryString, cb) {
      var links = this.listModele;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      cb(results);
    },
    querySearch(queryString, cb) {
      var links = this.listProduit;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

    calculTotalDevis() {
      let total = 0;
      let tvaG = 0;
      let ht = 0;
      this.devis.forEach(function(item) {
        let t = 0;
        let c = 0;
        let tva = 0;
        c = parseInt(item.cout) * parseInt(item.qte);
        tva = c * (parseInt(item.tva) / 100);
        t = c + tva;
        item.total = t;
        total += t;
        tvaG += tva;
        ht += c;
      });

      this.total = new Intl.NumberFormat("fr-Fr").format(total);
      this.tva = new Intl.NumberFormat("fr-Fr").format(tvaG);
      this.ht = new Intl.NumberFormat("fr-Fr").format(ht);
    },
    calculContrat() {
      let total = 0;
      let tvaG = this.tvaCont;
      let ht = 0;
      let montantLocation =
        this.montantLocation * this.nbr -
        this.montantLocation * this.nbr * (this.remise / 100);
      tvaG = this.montantLocation * (parseInt(this.tvaCont) / 100);
      if (this.optionContrat.length != 0) {
        this.optionContrat.forEach(function(item) {
          let t = 0;
          let c = 0;
          let tva = 0;
          c = parseInt(item.cout) * parseInt(item.qte);
          tva = c * (parseInt(item.tva) / 100);
          t = c + tva;
          item.total = t;
          total += t;
          tvaG += tva;
          ht += c;
        });
      }

    console.log('montantLocation',montantLocation)
      total += Math.round(montantLocation);
      ht += Math.round(montantLocation);
    console.log('totalHDHD',total)
    console.log('jrjrjr',tvaG)

      this.tva = new Intl.NumberFormat("fr-Fr").format(tvaG);
      this.totalRemise = new Intl.NumberFormat("fr-Fr").format(
        Math.round(this.montantLocation * this.nbr * (this.remise / 100))
      );
      this.totalF = Math.round(montantLocation);

      this.ht = new Intl.NumberFormat("fr-Fr").format(ht);
      this.total = new Intl.NumberFormat("fr-Fr").format(ht+tvaG);
      this.totalTtc =  Math.round(ht+tvaG);

    },
    contratLigne() {
      this.optionContrat.push({
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      });
      this.totComLigneTTC += 5;
    },
    devisLigne() {
      this.devis.push({
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      });
      this.totComLigneTTC += 5;
    },
    suppressionDevis(index) {
      var item = this.devis.indexOf(index);
      this.devis.splice(item, 1);
      this.calculTotalDevis();
    },
    deleteOptionContrat(index) {
      var item = this.optionContrat.indexOf(index);
      this.optionContrat.splice(item, 1);
      this.calculContrat();
    },
    lienFlotte() {
      this.$router.push({ name: "Flotte" });
    },
    loadParc() {
      let url = this.domaine + "parc/index/parc";
      this.$http.get(url).then(response => {
        if (response.body) {
          var tableau = response.body.parc;
          for (var i = 0; i < tableau.length; ++i) {
            for (var j = i + 1; j < tableau.length; ++j) {
              if (tableau[i].libelle === tableau[j].libelle) {
                tableau.splice(j--, 1);
              }
            }
          }
          this.listParc = tableau;
        }
      });
    },
    loadTypeParc(item) {
      this.loading = true;
      let url = this.domaine + "parc/parcSelect/" + item;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listVehicule = response.body.detailVehi;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des vehicules"
          );
        }
      );
    },
    loadUserAdmin() {
      let url = this.domaine + "mission/liste/admin";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listDemandeur = response.body.listAdmin;
        }
      });
    },
    loadGraph() {
      let url = this.domaine + "mission/graph/vehicule";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.disponible = response.body.etatVehicule.disponible;
          this.enCours = response.body.etatVehicule.enCours;
          this.panne = response.body.etatVehicule.panne;
          this.reparation = response.body.etatVehicule.reparation;
          this.location = response.body.etatVehicule.location;
          this.statsMarque = response.body.dataAxis;
          this.statsMarqueData = response.body.data;
          this.chartsDisponibilite();
          this.chartsMarqueVeh();
        }
      });
    },
    chartsDisponibilite() {
      let optionDisponibilite = {
        title: {
          text: "DISPONIBILITEES DES VEHICULES DU PARC AUTO",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: [
            "En panne",
            "En cours de mission",
            "En cours de location",
            "En cours de reparation",
            "Disponible"
          ]
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "12",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: this.panne, name: "En panne" },
              { value: this.enCours, name: "En cours de mission" },
              { value: this.location, name: "En cours de location" },
              { value: this.reparation, name: "En cours de reparation" },
              { value: this.disponible, name: "Disponible" }
            ]
          }
        ]
      };

      let chartsDisponibilite = echarts.init(
        document.getElementById("chartsDisponibilite")
      );
      chartsDisponibilite.setOption(optionDisponibilite);
    },

    chartAllBilanCarburant() {
      let option = {
        title: {
          text:
            "Montant de la consommation de carburant/Mois Total = " +
            this.totMntCarb +
            " Fcfa"
        },
        tooltip: {},
        legend: {
          data: ["Sales"]
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [],
            type: "bar"
          }
        ]
      };


      this.statConsom.forEach(function(element) {
        option.xAxis.data.push(element.date);
        option.series[0].data.push(element.montant);
      });

      let myChart = echarts.init(
        document.getElementById("chartAllBilanCarburant")
      );
      // use configuration item and data specified to show chart
      myChart.setOption(option);
    },

    chartAllBilanCarburantQut() {
      let option = {
        title: {
          text: "Quantite de carburant/Mois Total=" + this.totCarb + " L"
        },
        tooltip: {},
        legend: {
          data: ["Sales"]
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [],
            type: "bar"
          }
        ]
      };


      this.statQutConsom.forEach(function(element) {
        option.xAxis.data.push(element.date);
        option.series[0].data.push(element.quantite);
      });

      let myChart = echarts.init(
        document.getElementById("chartAllBilanCarburantQut")
      );
      // use configuration item and data specified to show chart
      myChart.setOption(option);
    },

    onFileDevPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageDevis = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileDevis = files[0];
    },

    onFileConsomPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageConsom = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileConsom = files[0];
    },
    chartsMarqueVeh() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];
      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      let optionApproEntre = {
        title: {
          text: "STATISTIQUES DU NOMBRE DE VEHICULES ACQUIS PAR AN",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        series: [
          {
            // For shadow
            type: "bar",
            itemStyle: {
              normal: { color: "rgba(0,0,0,0.05)" }
            },
            barGap: "-100%",
            barCategoryGap: "40%",
            data: dataShadow,
            animation: false
          },
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" }
                ])
              }
            },
            data: []
          }
        ]
      };
      var zoomSize = 23;

      this.statsMarque.forEach(function(element) {
        optionApproEntre.xAxis.data.push(element);
      });

      this.statsMarqueData.forEach(function(element) {
        optionApproEntre.series[1].data.push(element);
      });

      let chartsMarqueVeh = echarts.init(
        document.getElementById("chartsMarqueVeh")
      );
      chartsMarqueVeh.setOption(optionApproEntre);
    },
    //impression de limage du recu consommation carburant
    imprimerRecu(urlImageRecu) {
      window.open(urlImageRecu);
    },

    //impression de liste consommation carburant

    imprimeListeConsPDF() {
      let tab = [];
      this.listConsommation.forEach(function(consommation) {
        tab.push(consommation.id);
      });

      let url = this.domaine + "consommation/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    functionTime(dateR) {
      var date = "";
      var splittedDate = dateR.split("-");

      //on verifie si la date est au format Y-m-d
      if (splittedDate[2].length == 4) {
        date = [splittedDate[2], splittedDate[1], splittedDate[0]].join("-");
        var dateObject = new Date(date);
      } else {
        var dateObject = new Date(dateR);
      }
      return dateObject;
    },
    filtrePeriode() {
      if (this.periode == null) {
        this.listConsommation = this.listOldConsommation;
        return;
      }
      //this.listConsommation.splice(0)

      let dateDbt = new Date(this.periode[0]);
      let dateFin = new Date(this.periode[1]);
      this.listConsommation = this.listOldConsommation.filter(function(item) {
        let dateAchat = new Date(item.dateAchatNonFormat);
        if (dateAchat >= dateDbt && dateAchat <= dateFin) {
          return item;
        }
      });
    }
  },
  computed: {},
  mounted() {
    this.loadPage();
    this.loadAssu();
    this.loadBesoinVehAvalider();
    this.loadParc();
    this.loadGraph();
    this.loadVehicule();
    this.loadCarte();
    this.loadMarque();
    this.loadForfait();
    this.loadDevis();
    this.loadVisite();
    this.loadVign();
    this.loadPrestaire();
    this.loadConsommation();
    this.loadCompagnie();
    this.loadClientLocation();
    this.loadConducteurDispo();
    this.loadConducteur();
    this.loadContrat();
    this.loadIntervention();
    this.loadCaisse();
    this.loadVehiculeDispo();
    this.loadCout();
    this.loadClient();
    this.chartsDisponibilite();
    this.loadDemandeCarburan()
  }
};
</script>

<style>
.btnV {
  width: 100%;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/ParcAuto.vue